export const jp = {
  app: {
    home: 'ホーム',
    playerScout: '選手の検索',
    playerComparison: '選手の比較',
    playerRecruitment: '選手募集',
    collections: 'コレクション',
    favoritePlayers: 'お気に入りの選手',
    teamAnalytics: 'チームの分析',
    gameAnalysis: '試合の分析',
    seasonStats: 'シーズン',
    leagueTable: '順位表',
    scoresAndFixtures: '結果',
    notifications: '通知',
    administration: '管理',
    inbox: '受信箱',
    teamStats: 'チームスタッツ',
    blog: 'ブログ',
    leagues: 'リーグ',
    squadBuilder: 'チーム作成者',
    playerAlerts: '検索の通知',
    searchAlerts: '検索アラート',
    videoUploadTool: '動画アップロードツール',
    videoPlaylists: 'Playlists',
    uploadedGames: '試合映像',
    favoriteTeams: 'Favorite Teams',
    arrigo: 'Arrigo',
    validateEvents: 'イベントの検証'
  },
  playerRecruitment: {
    title: '選手シート',
    subtitle: '選手の特徴や統計情報を詳しく見ることができます',
    league: 'リーグ',
    selectedSeason: 'シーズン選択',
    year: '年',
    radar: 'レーダーチャート',
    positions: 'ポジション',
    numberOfPlayers: '選手数',
    template: 'テンプレート',
    compareWith: '〜と比較',
    previousPerformance: '前回までの成績',
    xGames: '{0} 試合',
    average: '平均',
    leagueAverage: 'リーグ平均',
    selectSeason: 'シーズンを選択',
    positionsPlayed: 'プレーしたポジション',
    minMax: '最低と最高',
    top5Leagues: '5大リーグ',
    infoMessage: '最小値と最大値を有効にするためにシーズンを1つだけ選択してください。',
    infoMessage2: 'どちらも同じシーズンを選択してください。',
    dataPer90MinText: '90分間のデータ',
    adjustToPossessionText: '* ポゼッション調整済み',
    text: 'テキスト',
    lollipop: '横棒グラフ',
    polar: 'ポーラーチャート',
    noGamesBetweenDates: '選択した日付の間に試合が見つかりません',
    radarTemplates: {
      Goalkeeper: 'ゴールキーパー',
      GoalkeeperCustom: 'ゴールキーパーカスタム',
      GoalkeeperCustom1: 'ゴールキーパー カスタム 1',
      GoalkeeperCustom2: 'ゴールキーパー カスタム 2',
      GoalkeeperCustom3: 'ゴールキーパー カスタム 3',
      GoalkeeperCustom4: 'ゴールキーパー カスタム 4',
      GoalkeeperCustom5: 'ゴールキーパー カスタム 5',
      GoalkeeperCustom6: 'ゴールキーパー カスタム 6',
      Defender: 'ディフェンダー',
      DefenderCustom: 'ディフェンダーカスタム',
      DefenderCustom1: 'ディフェンダー カスタム 1',
      DefenderCustom2: 'ディフェンダー カスタム 2',
      DefenderCustom3: 'ディフェンダー カスタム 3',
      DefenderCustom4: 'ディフェンダー カスタム 4',
      DefenderCustom5: 'ディフェンダー カスタム 5',
      DefenderCustom6: 'ディフェンダー カスタム 6',
      FullBack: 'サイドバック',
      FullBackCustom: 'フルバックカスタム',
      FullBackCustom1: 'サイドバック カスタム 1',
      FullBackCustom2: 'サイドバック カスタム 2',
      FullBackCustom3: 'サイドバック カスタム 3',
      FullBackCustom4: 'サイドバック カスタム 4',
      FullBackCustom5: 'サイドバック カスタム 5',
      FullBackCustom6: 'サイドバック カスタム 6',
      FullBackPredictive: 'サイドバック',
      Midfielder: 'ミッドフィールダー',
      MidfielderCustom: 'ミッドフィールダーカスタム',
      MidfielderCustom1: 'ミッドフィールダー カスタム 1',
      MidfielderCustom2: 'ミッドフィールダー カスタム 2',
      MidfielderCustom3: 'ミッドフィールダー カスタム 3',
      MidfielderCustom4: 'ミッドフィールダー カスタム 4',
      MidfielderCustom5: 'ミッドフィールダー カスタム 5',
      MidfielderCustom6: 'ミッドフィールダー カスタム 6',
      MidfielderPredictive: 'ミッドフィールダー',
      MidfielderDefensive: '守備的ミッドフィールダー',
      MidfielderOffensive: '攻撃的ミッドフィールダー',
      AttackingMidfielder: 'トップ下',
      MidfielderWing: 'インサイドハーフ',
      Winger: 'ウインガー',
      WingerCustom: 'ウィンガーカスタム',
      WingerCustom1: 'ウインガー カスタム 1',
      WingerCustom2: 'ウインガー カスタム 2',
      WingerCustom3: 'ウインガー カスタム 3',
      WingerCustom4: 'ウインガー カスタム 4',
      WingerCustom5: 'ウインガー カスタム 5',
      WingerCustom6: 'ウインガー カスタム 6',
      WingerOffensive: '攻撃的ウインガー',
      Forward: 'フォワード',
      ForwardCustom: 'フォワードカスタム',
      ForwardCustom1: 'フォワード カスタム 1',
      ForwardCustom2: 'フォワード カスタム 2',
      ForwardCustom3: 'フォワード カスタム 3',
      ForwardCustom4: 'フォワード カスタム 4',
      ForwardCustom5: 'フォワード カスタム 5',
      ForwardCustom6: 'フォワード カスタム 6',
      ForwardPredictive: 'フォワード',
      WingBack: 'ウイングバック',
      WingBackCustom: 'ウイングバックカスタム',
      WingBackCustom1: 'ウイングバック カスタム 1',
      WingBackCustom2: 'ウイングバック カスタム 2',
      WingBackCustom3: 'ウイングバック カスタム 3',
      WingBackCustom4: 'ウイングバック カスタム 4',
      WingBackCustom5: 'ウイングバック カスタム 5',
      WingBackCustom6: 'ウイングバック カスタム 6',
      WingBackMedia: 'ウイングバック (SocialMedia)',
      FullBackMedia: 'サイドバック (SocialMedia)',
      MidfielderMedia: 'ミッドフィールダー (SocialMedia)',
      WingerMedia: 'ウインガー (SocialMedia)',
      ForwardMedia: 'フォワード (SocialMedia)',
      PhysicalWingBack: 'フィジカルが強いウイングバック',
      PhysicalForward: 'フィジカルが強いフォワード',
      PhysicalWinger: 'フィジカルが強いウインガー',
      PhysicalMidfielder: 'フィジカルが強いミッドフィールダー',
      PhysicalFullBack: 'フィジカルが強いサイドバック',
      PhysicalDefender: 'フィジカルが強いディフェンダー',
      PhysicalWingBackLMO: 'フィジカルが強いウイングバック',
      PhysicalForwardLMO: 'フィジカルが強いフォワード',
      PhysicalWingerLMO: 'フィジカルが強いウインガー',
      PhysicalMidfielderLMO: 'フィジカルが強いミッドフィールダー',
      PhysicalFullBackLMO: 'フィジカルが強いサイドバック',
      PhysicalDefenderLMO: 'フィジカルが強いディフェンダー'
    },
    radarTemplatesWomen: {
      Goalkeeper: 'ゴールキーパー',
      Defender: 'ディフェンダー',
      FullBack: 'サイドバック',
      FullBackPredictive: 'サイドバック',
      Midfielder: 'ミッドフィールダー',
      MidfielderPredictive: 'ミッドフィールダー',
      MidfielderDefensive: '守備的ミッドフィールダー',
      MidfielderOffensive: '攻撃的ミッドフィールダー',
      AttackingMidfielder: 'トップ下',
      MidfielderWing: 'インサイドハーフ',
      Winger: 'ウインガー',
      WingerOffensive: '攻撃的ウインガー',
      Forward: 'フォワード',
      ForwardPredictive: 'フォワード',
      WingBack: 'ウイングバック',
      WingBackMedia: 'ウイングバック (SocialMedia)',
      FullBackMedia: 'サイドバック (SocialMedia)',
      MidfielderMedia: 'ミッドフィールダー (SocialMedia)',
      WingerMedia: 'ウインガー (SocialMedia)',
      ForwardMedia: 'フォワード (SocialMedia)',
      PhysicalWingBack: 'フィジカルが強いウイングバック',
      PhysicalForward: 'フィジカルが強いフォワード',
      PhysicalWinger: 'フィジカルが強いウインガー',
      PhysicalMidfielder: 'フィジカルが強いミッドフィールダー',
      PhysicalFullBack: 'フィジカルが強いサイドバック',
      PhysicalDefender: 'フィジカルが強いディフェンダー',
      PhysicalWingBackLMO: 'フィジカルが強いウイングバック',
      PhysicalForwardLMO: 'フィジカルが強いフォワード',
      PhysicalWingerLMO: 'フィジカルが強いウインガー',
      PhysicalMidfielderLMO: 'フィジカルが強いミッドフィールダー',
      PhysicalFullBackLMO: 'フィジカルが強いサイドバック',
      PhysicalDefenderLMO: 'フィジカルが強いディフェンダー'
    },
    radarDescription: {
      basicStatistics: {
        title: '基本統計',
        minutes: '時間',
        goals: 'ゴール',
        assists: 'アシスト',
        redCards: 'レッドカード',
        yellowCards: 'イエローカード',
        games: '試合',
        goalsReceived: 'PKを除く被ゴール数',
        xGFaced: '被ゴール期待値'
      },
      profiles: {
        3: {
          1: 'ショートパスとロングパスを正確に蹴れる足元の技術のあるゴールキーパー。',
          2: 'ショートパスとロングパスの成功率が高く、足元の技術に優れビルドアップに関与できるゴールキーパー。',
          3: 'パスの成功率が高く、足元の技術に優れたゴールキーパー。',
          4: '自陣から相手陣までパスで目立つゴールキーパー。',
          5: 'パスに優れ、足元のボール扱いが正確なゴールキーパー。',
          6: '長短のパス成功率が高く、足元の技術に優れ、ビルドアップに継続的に参加できるゴールキーパー。',
          7: 'ショートパスとロングパスの両方で高い成功率を記録する、足元の技術に優れたゴールキーパー。'
        },
        5: {
          1: '一対一に強く、タックルやインターセプトの回数が多いディフェンダー。',
          2: 'タックルやデュエルに強く、相手の動きの予測にも優れたセンターバック。',
          3: 'デュエルに強く、継続的にボール奪取ができるセンターバック。',
          4: '守備レベルが高く、タックルとインターセプトで多くのボールを奪う選手。',
          5: 'タックルでの強さと一対一での存在感が目立ち、多くのインターセプトを生み出すディフェンダー。',
          6: 'タックルの精度と頻度が高く、相手のプレーを読む力に優れ、1試合あたりのボール奪取数が多いセンターバック。',
          7: 'タックルの量と質、優れた予測力により、高いレベルでボールを奪取するディフェンダー。'
        },
        6: {
          1: '試合を読む力があり、パスでチャンスを生み出すことに大きく貢献するディフェンダー。'
        },
        7: {
          1: '攻撃（xGの構築に大きく貢献）と守備（多くのボール奪取）のバランスが取れたサイドバック。'
        },
        8: {
          1: 'タックルとインターセプトによるボール奪取が多く、1対1で堅実な守備を見せるサイドバック。'
        },
        9: {
          1: '守備面では課題がある一方で、攻撃面では危険なアクションを多く生み出すサイドバック。'
        },
        10: {
          1: 'ピッチを広くカバーし、ボール奪取ができるだけでなく、チームのxG構築にも大きく貢献するミッドフィールダー。'
        },
        11: {
          1: '攻撃での影響力は限定的だが、高い守備能力とパスの有効性を兼ね備えたミッドフィールダー。'
        },
        12: {
          1: '多くのインターセプトとタックルを行い、空中戦にも強く、チャンスも演出できる完成度の高いミッドフィールダー。'
        },
        15: {
          1: '1対1のスキルと高いレベルのクロス精度を持ち、シュート（xG）よりもキーパス（xA）で貢献するウインガー。'
        },
        16: {
          1: 'スルーパスとボール前進でチャンスを生み出し、サイドよりも中央でのポゼッションに大きな影響を与える選手。'
        },
        17: {
          1: '優れたドリブルスキルを持ち、外から中へカットインし、キーパス（xA）よりも多くのシュート（xG）を生み出すアタッカー。'
        },
        18: {
          1: '前線からの積極的なプレッシングが評価され、インターセプトやボール奪取につながるフォワード。'
        },
        22: {
          1: 'スルーパスを受けたり外に流れたりしながらよく動き、得点チャンスを多く生み出すフォワード。1試合におけるタッチのうち、ペナルティエリア外での割合が高いタイプ。'
        }
      },
      description: '記述',
      conjuction: ' と ',
      conjuction2: ' と ',
      over: '上回って',
      under: '下回って',
      respectively: 'それぞれ',
      Defending1: {
        1: '守備のパフォーマンスは、5大リーグの中でも最低レベルです。'
      },
      Defending2: {
        1: 'パフォーマンスが平均を下回っているため、守備面で十分な役割を果たせていません。'
      },
      Defending3: {
        1: 'レベルは平均より少し over_under_average で、守備面では一定の貢献を見せています。'
      },
      Defending4: {
        1: '守備面では平均以上のパフォーマンスを発揮しており、非常に良い仕事をしています。'
      },
      Defending5: {
        1: '守備的タスクに優れ、5大リーグの player_positions の中で上位80%に入るパフォーマンスです。'
      },
      Saving1: {
        1: 'パフォーマンスが非常に低く、シュートストップに大きな苦労が見られるゴールキーパーです。'
      },
      Saving2: {
        1: 'レベルは平均以下で、ゴールキーパーとして十分なパフォーマンスとは言えません。'
      },
      Saving3: {
        1: '平均よりわずかに over_under_average で、metric_name を改善する余地があります。ゴールキーパーとしてのパフォーマンスは許容範囲です。'
      },
      Saving4: {
        1: '5大リーグの平均を上回るレベルのゴールキーパーで、特に metric_name で際立っています。'
      },
      Saving5: {
        1: '非常に完成度の高いゴールキーパーであり、ヨーロッパ5大リーグのゴールキーパーと比較しても、すべての指標が上位20%以内に位置しています。'
      },
      Passing1: {
        1: 'ボール扱いに関しては、リーグでも最低レベルと言える成績です。'
      },
      Passing2: {
        1: 'パスに関しては、パフォーマンスが平均を下回っています。'
      },
      Passing3: {
        1: 'パスのレベルは許容範囲で、平均よりわずかに over_under_average です。'
      },
      Passing4: {
        1: 'この面で非常に優れたレベルのパサーで、平均を大きく上回っています。'
      },
      Passing5: {
        1: 'ほとんどの選手よりも高いパフォーマンスで、効果的なパスを供給しています。'
      },
      Aerial1: {
        1: '空中戦で非常に苦戦しており、この点でポジションの中でも最も弱い部類に入ります。'
      },
      Aerial2: {
        1: '空中戦に関しては成績が悪く、平均を下回っています。'
      },
      Aerial3: {
        1: '空中戦で許容できるレベルで、平均より少し over_under_average です。'
      },
      Aerial4: {
        1: '空中戦で優れたパフォーマンスを発揮し、この面で高い効果を示します。'
      },
      Aerial5: {
        1: '空中戦での指標はトップクラスです。'
      },
      Shooting1: {
        1: 'シュートに関する統計は非常に低く、この面ではリーグでも最低レベルです。'
      },
      Shooting2: {
        1: 'シュートのレベルは改善の余地が非常に大きく、平均を下回っています。'
      },
      Shooting3: {
        1: '攻撃面で許容できるパフォーマンスで、平均よりわずかに over_under_average です。'
      },
      Shooting4: {
        1: 'この領域で非常に優れた能力を発揮しており、60%の選手を上回るパフォーマンスです。'
      },
      Shooting5: {
        1: '攻撃面で優れたスキルと素晴らしいパフォーマンスを発揮し、この点でトップクラスの選手です。'
      },
      Association1: {
        1: 'ボールキープに関するパフォーマンスは非常に低く、5大リーグの中でも最も低いグループに属します。'
      },
      Association2: {
        1: 'この点で平均的なパフォーマンスを下回っており、ボールキープにおいて改善すべき点が多くあります。'
      },
      Association3: {
        1: 'ボールキープは良好で、平均よりわずかに over_under_average です。'
      },
      Association4: {
        1: 'ボールキープの能力が非常に高く、素晴らしいレベルを示しています。'
      },
      Association5: {
        1: '足元でのボールキープ能力は並外れており、この点でトップクラスの選手です。'
      },
      BallHandling1: {
        1: '5大リーグの選手の中でも、ボール扱いは最低レベルのグループに含まれます。'
      },
      BallHandling2: {
        1: 'ボール扱いに関しては、レベルが平均以下です。'
      },
      BallHandling3: {
        1: 'ボール扱いは許容レベルで、平均よりわずかに over_under_average です。'
      },
      BallHandling4: {
        1: 'ボール扱いのレベルが高く、この面でトップレベルに近い数値を記録しています。'
      },
      BallHandling5: {
        1: '5大リーグの中でも、ボール扱い能力はトップクラスです。'
      },
      Crosses1: {
        1: 'ペナルティエリア内へのクロスに関するパフォーマンスレベルは低く、この指標では最下位グループに属します。'
      },
      Crosses2: {
        1: 'クロスで危険を生み出すパフォーマンスは平均以下です。'
      },
      Crosses3: {
        1: 'ペナルティエリアへのクロス精度は許容レベルですが、改善の余地があり、平均より少し over_under_average です。'
      },
      Crosses4: {
        1: 'クロスに関する統計は平均をかなり上回っています。'
      },
      Crosses5: {
        1: 'クロスの質と量が非常に高く、このカテゴリーで最も効果的な上位20%に入る選手です。'
      },
      Carries1: {
        1: 'ボールを運ぶという点で、数値は非常に低く、下位20%の選手に分類されます。'
      },
      Carries2: {
        1: 'ボールキープとボール運びのパフォーマンスは、同ポジションの選手の平均から大きく離れています。'
      },
      Carries3: {
        1: 'ボール運びに関しては平均に近いパフォーマンスで、わずかに over_under_average です。'
      },
      Carries4: {
        1: 'ボール運びに関する数値が非常に優れており、注目に値する選手です。'
      },
      Carries5: {
        1: 'ボール運びに非常に優れた才能を持ち、ドリブル関連の指標で高いパフォーマンスを発揮しています。'
      },
      Turnovers1: {
        1: 'パフォーマンスは非常にネガティブで、多くのボールロストにより相手に危険な状況を与えています。この指標で最下位グループに入ります。'
      },
      Turnovers2: {
        1: '多くの危険なボールロストが相手に有利に働いており、大きな改善とロストの削減が必要です。'
      },
      Turnovers3: {
        1: 'ボールロストに関して平均よりわずかに over_under_average であり、さらにパフォーマンスを向上させる余地があります。'
      },
      Turnovers4: {
        1: 'ボールロストに関するパフォーマンスは良好で、60%の選手よりボールを失う回数が少ないです。'
      },
      Turnovers5: {
        1: 'ボールロストの少なさが際立っており、チームのポゼッション維持に大きく貢献する選手です。'
      },
      SequenceInvolvement1: {
        1: 'ボール保持に関する数値は良くなく、プレーがシュートで終わることはほとんどありません。'
      },
      SequenceInvolvement2: {
        1: '最終局面でのプレーには大きな改善の余地があり、シュートで終わる回数が非常に少ないため、平均を大きく下回っています。'
      },
      SequenceInvolvement3: {
        1: 'ゴール前での最終局面の関与は許容できるレベルで、平均をわずかに over_under_average しており、さらなる成長の余地があります。'
      },
      SequenceInvolvement4: {
        1: 'チームのポゼッションをシュートで終わらせる能力が高く、その一部はゴールにもつながっており、このカテゴリーで非常に優れたパフォーマンスを発揮しています。'
      },
      SequenceInvolvement5: {
        1: 'チームのポゼッションをフィニッシュで終わらせる能力に優れ、危険なシュートで締めくくる場面が多い選手です。'
      },
      OutPlay1: {
        1: '守備構造を崩す場面での影響力は最小限にとどまっています。'
      },
      OutPlay2: {
        1: 'ビルドアップや守備崩しへの貢献は、そのポジションの基準を下回っています。'
      },
      OutPlay3: {
        1: '時折優位性を生み出すことができ、ポジション平均程度のパフォーマンスを示します。'
      },
      OutPlay4: {
        1: '守備ラインを頻繁に突破し、相手に不均衡を生み出します。'
      },
      OutPlay5: {
        1: '相手をかわして前進を生み出す能力において、このポジションでトップクラスの評価を受けています。'
      },
      LineBreakingPasses1: {
        1: '守備ラインを破るパスをほとんど試みず、成功もほぼなく、この面での貢献は極めて少ないです。'
      },
      LineBreakingPasses2: {
        1: 'ライン間やプレス裏で味方を継続的に見つけることができず、この点でポジション基準を下回っています。'
      },
      LineBreakingPasses3: {
        1: '時折ラインを破るパスを出しており、この面ではポジション平均程度に位置しています。'
      },
      LineBreakingPasses4: {
        1: 'パスで頻繁にラインを破り、相手ブロックのバランスを崩していることが確認できます。'
      },
      LineBreakingPasses5: {
        1: 'リーグでも有数のラインブレイク能力を持つパサーで、プレス回避や突破が大きな強みとなっています。'
      },
      PassUnderPressure1: {
        1: '相手に詰められると落ち着きや効果的なプレーを保つのに苦労している様子がうかがえます。'
      },
      PassUnderPressure2: {
        1: '強いプレッシャー下ではパス精度を維持するのが難しいタイプです。'
      },
      PassUnderPressure3: {
        1: 'プレッシャー下のパスは平均的で、対応自体は安定しているものの、常にクリーンに実行できるとは限りません。'
      },
      PassUnderPressure4: {
        1: 'プレッシャー下でも頻繁に味方を見つけることに成功しており、この種類のパスで平均を上回っています。'
      },
      PassUnderPressure5: {
        1: '強いプレッシャー下でも卓越した落ち着きと精度を発揮し、この面でポジション内のトップクラスに位置しています。'
      },
      BallReceived1: {
        1: '前線でパスを受ける回数が非常に少なく、ライン間でプレーすることはほとんどありません。'
      },
      BallReceived2: {
        1: '相手陣でフリーの状態で受けることはあるものの、一貫性に欠けます。'
      },
      BallReceived3: {
        1: '攻撃ゾーンでの無圧レシーブ数は中程度です。'
      },
      BallReceived4: {
        1: 'ライン間や無圧エリアで頻繁にパスを受けます。'
      },
      BallReceived5: {
        1: 'ライン間でのフリー受けが多く、重要なエリアでの受けも目立ちます。'
      },
      OnBallPressure1: {
        1: 'ほとんどプレスをかけず、ボール保持者への接近もほぼありません。全体的な強度は低いです。'
      },
      OnBallPressure2: {
        1: '時折強いプレスを行いますが頻度は低く、総合的な強度は低めです。'
      },
      OnBallPressure3: {
        1: 'ボール保持者への接近プレス数は中程度です。'
      },
      OnBallPressure4: {
        1: '規律正しく、定期的にボール保持者へ接近してプレスを行います。'
      },
      OnBallPressure5: {
        1: 'ボールがない時でも非常に強度が高く、規律正しく相手に積極的にプレスをかけます。'
      },
      SpatialCoverage1: {
        1: 'スペースの占有やコントロールへの貢献が非常に限定的で、チームの陣形や戦術構造への関与も最小限です。攻守両面でのスペースカバーが乏しく、組織やコンパクトさへの影響も小さいです。'
      },
      SpatialCoverage2: {
        1: 'スペースカバーは平均以下で、一定の参加は見られるもののポジション維持やチームとの連動性に欠けます。戦術構造への影響は断続的で、上位の選手と比べて一貫性に欠けます。'
      },
      SpatialCoverage3: {
        1: 'スペースカバーは平均的で、スペースの占有とコントロールに安定して貢献します。ポジショニングは概ね正しく機能的で、攻守両面で中程度の影響を与えています。'
      },
      SpatialCoverage4: {
        1: '平均以上のスペースカバーを示し、ピッチ占有やポジション構造への関与が大きいです。形を維持し、トランジションに適応する能力がコンパクトさと重要スペースのコントロールに大きく貢献します。'
      },
      SpatialCoverage5: {
        1: '卓越したスペースカバーを誇り、ポジショニングを最適化してチームの陣形と戦術構造に決定的な影響を与えます。ゲーム理解とブロック全体との連動により、攻守両面で戦略的スペースの占有を最大化します。'
      },
      OffBallPressure1: {
        1: 'ボールがない時の守備プレッシャーは非常に限定的で、相手の行動を妨害したりミスを誘発することはほとんどありません。プレスや守備構造への貢献も最小限です。'
      },
      OffBallPressure2: {
        1: 'ボールがない時の守備プレッシャーは平均以下で、時折相手に寄せますがタイミングや位置取りが不安定です。ボール奪取や相手のビルドアップ妨害への影響は限定的です。'
      },
      OffBallPressure3: {
        1: 'ボールがない時のプレッシャーは平均的で、守備への貢献は安定しています。ポジショニングやタイミングは概ね効果的で、相手の選択肢を減らすプレッシャーを適切にかけます。'
      },
      OffBallPressure4: {
        1: '平均以上の守備プレッシャーをボールがない時に提供し、相手の行動を頻繁に妨害して時間とスペースを削ります。努力は連動性が高く、守備構造を維持する助けとなります。'
      },
      OffBallPressure5: {
        1: 'ボールがない時の守備プレッシャーで卓越しており、相手を絶えず追い詰め、パスコースを限定し、ボール奪取を促します。強度、位置取り、予測力がチームの守備効率を大幅に高めます。'
      },
      Distance1: {
        1: '平均よりも大幅に走行距離が短く、ピッチ上での動きが非常に限られています。'
      },
      Distance2: {
        1: '1試合あたりの走行距離はトップレベルの平均を下回り、平均的な選手ほど活動的ではありません。'
      },
      Distance3: {
        1: 'リーグ平均に近い妥当な距離を走り、フィジカル面での関与はバランスが取れています。'
      },
      Distance4: {
        1: '高い走行距離を安定して記録し、優れた持久力を示しています（フィジカル出力が高い）。'
      },
      Distance5: {
        1: 'フィジカルボリュームは卓越しており、走行距離では欧州5大リーグでもトップクラスです。'
      },
      Sprint1: {
        1: '平均に比べて高速スプリントの回数が非常に少なく、試合を通してスプリントの負荷は最小限です。'
      },
      Sprint2: {
        1: 'ポジション平均よりもスプリント頻度が低く、高速動作での爆発力が限られています。'
      },
      Sprint3: {
        1: '1試合あたりのスプリント回数は中程度で、リーグ平均付近の数値です。'
      },
      Sprint4: {
        1: 'スプリント頻度が平均を大きく上回り、安定した爆発力を発揮し続けます。'
      },
      Sprint5: {
        1: '90分あたりのスプリント数で上位20%に入る選手で、繰り返しの高速動作で最高レベルのフィジカルパフォーマンスを示します。'
      },
      Acceleration1: {
        1: 'ペース変化の能力が平均を明確に下回り、試合中の爆発的な加速はほとんど見られません。'
      },
      Acceleration2: {
        1: '短距離での加速頻度が限られており、同タイプの選手と比べても加速数は平均以下です。'
      },
      Acceleration3: {
        1: '加速回数はリーグ平均付近で、ペース変化は目立たないものの数値としては妥当です。'
      },
      Acceleration4: {
        1: '素早くかつ繰り返し加速できる能力が高く、加速頻度は平均を大きく上回ります。'
      },
      Acceleration5: {
        1: '繰り返しの加速で上位20%に入り、スタートダッシュやペース変化の数値が平均を大きく上回ります。'
      },
      Speed1: {
        1: 'フィジカル的に遅いか、試合中に高強度の動きを節約している可能性があります。'
      },
      Speed2: {
        1: '最高速度は競技平均をわずかに下回ります。'
      },
      Speed3: {
        1: '試合を通して平均的な最高速度を維持します。'
      },
      Speed4: {
        1: '高い速度にしばしば到達し、速さとパワーを兼ね備えています。'
      },
      Speed5: {
        1: '非常に高い最高速度を記録し、スピード面で違いを生み出せる選手です。'
      },
      LineBreakingCarries1: {
        1: 'ボールを運んでラインを破ることはほとんどなく、前進への積極性に欠けます。'
      },
      LineBreakingCarries2: {
        1: '時折ラインを破る運びを見せますが、頻度は高くありません。'
      },
      LineBreakingCarries3: {
        1: '成功するラインブレイクの運びは中程度の回数です。'
      },
      LineBreakingCarries4: {
        1: '運びで頻繁にラインを越え、前進に貢献します。'
      },
      LineBreakingCarries5: {
        1: '運びのスペシャリストで、常に高頻度でラインを破ります。'
      },
      LineBreakingActions1: {
        1: 'ラインブレイクのアクション（パスや運び）は非常に少なく、リスクをほとんど取りません。'
      },
      LineBreakingActions2: {
        1: '前進的なアクション（パスや運び）を時折行いますが頻度は低く、横方向のプレーが多いです。'
      },
      LineBreakingActions3: {
        1: 'パスと運びを組み合わせてラインを定期的に突破し、前進に貢献します。'
      },
      LineBreakingActions4: {
        1: '技術と判断力に優れ、多くのラインブレイクアクション（パスや運び）を生み出します。'
      },
      LineBreakingActions5: {
        1: '前進のスペシャリストで、パスと運びで常にラインを破りチームに大きな影響を与えます。'
      },
      OffBallRuns1: {
        1: '意図的なオフザボールの動きは非常に少なく、攻撃面でのサポートは限定的です。スペース創出や守備ライン崩し、連動性向上にはほとんど寄与しません。'
      },
      OffBallRuns2: {
        1: 'オフザボールの動きは平均以下で、時折攻撃をサポートしますがタイミング・方向・意図に一貫性がなく、スペース創出や攻撃構造改善への影響は限定的です。'
      },
      OffBallRuns3: {
        1: '意図的なオフザボールの動きは平均的で、適切なタイミングでスペースを作りチームプレーをサポートします。'
      },
      OffBallRuns4: {
        1: '平均以上のオフザボール活動を示し、頻繁に守備構造を崩し、パスコースや攻撃スペースを創出します。'
      },
      OffBallRuns5: {
        1: 'オフザボールの動きに優れ、常にプレーを先読みし、攻撃機会を最大化する賢いランニングを行います。'
      },
      OverMaxValue: {
        1: 'over_max_metric_name において非常に高い能力を示しており、最大値を上回るパフォーマンスです。この指標では5大リーグの中で上位10%に入ります。'
      },
      OverAverageSeason: {
        1: 'over_average_metric_name のパフォーマンスはリーグ league_name の平均を上回っています（average_metric_value に対して over_average_metric_value）。',
        2: '数値をリーグ league_name の指標と比較すると、over_average_metric_name で平均を上回るパフォーマンスを発揮しています（average_metric_value に対して over_average_metric_value）。'
      },
      UnderMinValue: {
        1: 'under_min_metric_name については、5大リーグの中でも最も低い percent_metric_name に位置しており、パフォーマンスを大きく改善する必要があります。'
      },
      Over70Percent: {
        1: 'over_70_metric_name で際立っており、90分あたり over_70_metric_value を記録しています。',
        2: 'over_70_metric_name で70％以上の数値を示しており、90分あたり over_70_metric_value です。',
        3: 'over_70_metric_name で非常に高い貢献を見せており、90分あたり over_70_metric_value を記録しています。'
      },
      Under30Percent: {
        1: 'under_30_metric_name ではパフォーマンスが低く、90分あたり under_30_metric_value であるため、より大きなインパクトが求められます。',
        2: 'under_30_metric_name においては、90分あたり under_30_metric_value と期待を下回る数値であり、大幅な改善が必要です。',
        3: 'under_30_metric_name に関しては、90分あたり under_30_metric_value であり、より良い数値を得るためにさらなる努力が必要です。'
      },
      OverAverageSeasonMoreThanOne: {
        1: 'リーグ league_name で平均を上回るパフォーマンスは特筆に値します。'
      },
      OverAverageStats: {
        1: ' over_average_metric_name（平均 average_metric_value に対して over_average_metric_value）。'
      },
      Over70PercentIndividualPressure: {
        1: 'ボールを取り戻す際に非常に良いプレッシャーをかけています。',
        2: 'ボールを奪うために相手に高いプレッシャーをかけています。'
      },
      Under30PercentIndividualPressure: {
        1: 'ボールを奪うために、より強いプレッシャーをかける必要があります。',
        2: '相手にプレッシャーをかけるという点で、さらなる向上が求められます。'
      }
    },
    himSelf: '本人',
    ownSeason: '自身のシーズン',
    minMaxTooltip: 'レーダーの最小値と最大値を調整します。',
    infoMessage3: 'This option is only available from matchday 6'
  },
  login: {
    login: 'ログイン',
    latestBlogPosts: '最新の投稿',
    signIn: 'サインイン',
    username: 'ユーザーネーム',
    password: 'パスワード',
    passwordForgotten: 'パスワードを忘れた',
    signUp: '登録する',
    enter: '入力',
    forceTitle: '使用中のアカウント',
    forceMessage: 'アカウントは別のデバイスで使用されています。 このデバイスに切り替えますか?',
    forgotMyPassword: 'パスワードを忘れた',
    firstLogin: '最初のアクセス',
    firstLoginMessage: 'アプリケーションで表示する言語に加えて、セキュリティ上の理由から、最初のアクセス時に新しいパスワードを割り当てる必要があります。',
    firstLoginOverview: 'ここでは、あなたのアカウント、あなたがアクセスできるリーグと商品の概要を説明します。',
    passwordConfirmation: 'パスワードの確認',
    forgotPasswordMessage: 'メールを書いてください。有効なアカウントである場合は、メールでパスワードを回復するための次の手順を受け取ります。',
    resetPassword: 'パスワードをリセットする。',
    resetPasswordLinkInvalid: 'このリンクは無効または期限切れです。ログインページからパスワード再設定を再度リクエストしてください。',
    skipSettings: '設定をスキップする',
    contact: '連絡先',
    cookiesText: 'このサイトは、Google のクッキーを使用してサービスを提供し、トラフィックを分析してサービスの品質を確保し、利用統計を作成し、不正行為を検出して対処します。',
    contactUs: 'お問い合わせ',
    newsTitle: '新機能：フィジカルスコア！',
    newsText: '従来のイベントデータスコアに加えて、新たに2つのフィジカルパフォーマンススコアを追加しました：持久力スコアとスピード＆パワースコアです。持久力は、継続的に走行距離を稼ぎ、高い運動量を維持できる選手を強調します。一方、スピード＆パワーは最高速度、スプリント、爆発的な加速に焦点を当てます。どちらも0〜100で表示され、リーグ別・ポジション別のパーセンタイルにより、同等の選手と直接比較できます。'
  },
  settings: {
    pageSubtitle: 'driblabの設定を編集する',
    language: '言語',
    availableLeagues: '利用可能なリーグ',
    availableSeasons: '利用可能なシーズン',
    availableProducts: '利用可能な製品',
    organization: '組織',
    changePassword: 'パスワードの変更',
    seasonTemplates: 'シーズンテンプレート',
    seasonTemplatesSubtitle: 'シーズンテンプレートを作成します。その後、選手のパフォーマンスと選手の検索で選択できます。',
    templateName: 'テンプレートネーム',
    selectTemplate: '編集するテンプレートを選択する',
    radarDefault: '欠点で検索',
    default: 'デフォルト',
    tabs: {
      options: 'オプション',
      templates: 'テンプレート',
      availableLeagues: '利用可能なリーグ',
      contactData: '連絡先情報 GBE'
    },
    contactData: {
      userDetails: 'ユーザーデータ',
      firstName: '名前',
      lastName: '苗字',
      contactDetails: '連絡先情報',
      name: '名前',
      phone: '電話番号',
      mobile: '携帯電話番号',
      email: 'Eメール',
      representativeDetails: '代表者情報'
    },
    currency: '通貨',
    fieldPreferences: 'フィールド選択',
    visualizationsPreferences: '可視化選択',
    fieldColor: 'フィールドの色',
    fieldColors: {
      green: '緑',
      blue: '青',
      white: '白',
      black: '黒',
      grey: 'グレー'
    },
    defaultPlayerVisualization: '選手能力グラフの表示',
    appPreferences: 'アプリケーション設定',
    darkMode: 'ダークモード',
    showTour: 'ガイドツアーを表示',
    customStats: 'カスタマイズされた統計',
    radarTemplates: '検索のテンプレート',
    radarTemplatesSubtitle: '統計テンプレートを作成します。その後、選手のパフォーマンスと選手のランキングで選択できます。',
    radarCategories: {
      Custom1: 'カスタム 1',
      Custom2: 'カスタム 2',
      Custom3: 'カスタム 3',
      Custom4: 'カスタム 4',
      Custom5: 'カスタム 5',
      Custom6: 'カスタム 6',
      Physical: 'フィジカル',
      CustomPhysical1: 'カスタム フィジカル 1',
      CustomPhysical2: 'カスタム フィジカル 2',
      CustomPhysical3: 'カスタム フィジカル 3',
      CustomPhysical4: 'カスタム フィジカル 4',
      CustomPhysical5: 'カスタム フィジカル 5',
      CustomPhysical6: 'カスタム フィジカル 6'
    },
    templateRemoveTitle: '検索を削除',
    templateRemoveMsg: '本当にこの検索を削除しますか?',
    templateEditTitle: 'テンプレートの保存',
    templateEditMsg: '未保存のテンプレートがありますが、編集のために別のテンプレートを読み込む前に保存しますか？',
    category: 'カテゴリー',
    playerRadar: '選手の検索',
    teamRadar: 'チームの検索',
    statsAlert: '保存する統計を少なくとも 1 つ挿入してください。',
    recommended: 'おすすめ',
    warning: 'レーダーの数が上限に達しているポジションがあります。テンプレートを削除または編集してください。',
    fieldPositions: {
      default: 'Driblab',
      fifa: 'FIFA',
      spanish: 'スペイン語',
      numeric: '数値'
    },
    showMediaMode: 'メディアモードの表示',
    statTemplates: 'ゲーム統計テンプレート',
    statTemplatesSubtitle: '多数のメトリクスから選択し、独自のテンプレートを作成する。',
    ratingFormat: {
      ratingFormat: '評価形式',
      numbers: '数字',
      letters: '文字 A ～ F'
    }
  },
  playerDetail: {
    passport: 'パスポート',
    secondPassport: '２つ目のパスポート',
    age: '年齢',
    dateOfBirth: '生年月日',
    height: '身長',
    weight: '体重',
    wage: '給料',
    history: '経歴',
    positions: 'ポジション',
    injuries: '怪我',
    transfers: '移籍',
    nationalTeam: '代表',
    addFavorite: 'お気に入りに追加',
    removeFavorite: 'お気に入りから除外',
    contractEnd: '契約終了',
    yearsOld: '歳',
    playerAvailability: '使用可能',
    playerUsage: 'プレーした時間',
    usage: '利用法',
    addToCollection: 'コレクションに追加',
    performance: 'パフォーマンス',
    info: '情報',
    career: 'キャリア',
    playerStyle: 'プレースタイル',
    radar: '検索',
    finishingMap: '決定率',
    threatMap: '危険性',
    keyPassMap: 'キーパス',
    beeswarm: 'ランキング',
    allGames: '試合',
    eventsMap: 'イベント',
    lbpMap: 'ラインブレイクパス',
    obpMap: 'オンボールプレッシャー',
    pupMap: 'プレッシャーを乗り越える',
    obrMap: 'ボールレシート',
    fullName: 'フルネーム',
    academy: 'アカデミー',
    name: '名前',
    lastName: '苗字',
    playerAvailabilityLong: 'シーズンでの怪我や出場停止のない試合の割合',
    playerUsageLong: '出場時間',
    playerAvailability1: '怪我や出場停止のない試合',
    playerAvailability2: '今シーズンの試合数',
    playerUsage1: '出場時間',
    playerUsage2: 'チーム総出場時間',
    notMinutesThisSeason: '今季は出場機会なし',
    seasonPlaceholder: 'アクティブシーズンはありません',
    inactivePlayer: '非活動な選手',
    inactivePlayerMessage: 'さらに詳しい情報が必要な場合は、レポートをリクエストできます。',
    goRequest: '申し込む。',
    warningMinutes: '注意！プレイ時間は450分未満です。分析結果は信憑性を欠く可能性があります。',
    scoreWarningMinutes: '合計450分以上出場した選手',
    pdScoreWarningMinutes: '合計450分以上出場した選手（1試合あたり最低60分）',
    warningSeasonGames: '5試合未満のシーズン、5大リーグの最小値と最大値。',
    warningStatsRemoved: '一部の統計データは、選択したシーズンでは利用できないため表示されていません。',
    warningBeeswarm: '選択したシーズンのデータがないため、プレイヤーは表示されません。',
    warningPlayersZeroValue: '{x}人の0の選手を表示しない ',
    onlyPlayersThatFit: '検索テンプレートに適合するプレイヤーのみ',
    gamesPlayedNotEnough: '試合数が不足しているため、オプションが無効になっています',
    gbe: 'GBE',
    analysis: '分析',
    documents: '書類',
    rankDefensive: '守備',
    rankBallHandling: 'ボールの動き',
    rankGoal: 'ゴールへの貢献',
    rankXt: '危険性',
    rankIndex: 'インデックス',
    visitHistory: 'アクセス履歴',
    placer: 'フィールド',
    touchesMap: 'タッチマップ',
    heatMap: 'ヒートマップ',
    ageProfile: '年齢グラフ',
    strongFoot: '利き足',
    player: '選手',
    outOf: '外',
    in: '中',
    radius: '半径',
    blur: 'ぼかし',
    careerTable: {
      nationalTeamCareer: '代表チームの経歴',
      nationalTeamCompetitions: '代表チームの大会'
    },
    physicalProgression: 'Physical Progression',
    gpi: 'グローバルプレイヤーインデックス',
    warningGPI: '過去30日間にELOリーグでプレーした選手のみ利用可能',
    diffGPI: '前回の試合からの変動',
    rankingInTheWorld: '世界で#{0}位',
    rankingInTheLeague: '{1}で#{0}位',
    max: '最大',
    gpiChart: '過去{0}試合のグローバル・プレーヤー・インデックスの値に基づくチャート',
    percentileRange: 'パーセンタイル {0} ～ {1}',
    months: '月',
    month: '月',
    contractExpOver4Years: '契約の有効期限が切れる',
    contractExpSoon: 'もうすぐ契約期限が切れます',
    contractFinalYear: '契約最終年',
    freeAgent: 'フリーエージェント',
    gpiDescription: 'Global Player Index (GPI) は、チームの強さ、対戦相手の強さ、試合のパフォーマンス、および出場可能性に基づいてサッカー選手を評価する標準化された選手評価システムです。 Elo レーティング システムからインスピレーションを得たもので、プレイヤーのレーティングが恣意的なベースラインではなく実際の競争環境を反映するようになります。',
    turnoversMap: '売上高と回収率のマップ',
    playerProfiles: {
      24: {
        label: 'Libero',
        abbreviation: 'LIB'
      },
      25: {
        label: 'Box Goalkeeper',
        abbreviation: 'PAR'
      },
      26: {
        label: 'Line',
        abbreviation: 'LIN'
      },
      27: {
        label: 'Initiator',
        abbreviation: 'INI'
      },
      28: {
        label: 'Ball Carrier',
        abbreviation: 'CON'
      },
      29: {
        label: 'Anticipator',
        abbreviation: 'ANT'
      },
      30: {
        label: 'Cover',
        abbreviation: 'COB'
      },
      31: {
        label: 'Box Defender',
        abbreviation: 'DAR'
      },
      32: {
        label: 'Deep Forward',
        abbreviation: 'DPR'
      },
      33: {
        label: 'Inside',
        abbreviation: 'INT'
      },
      34: {
        label: 'Playmaker',
        abbreviation: 'PLY'
      },
      35: {
        label: 'Defensive',
        abbreviation: 'DEF'
      },
      36: {
        label: 'Central',
        abbreviation: 'CEN'
      },
      37: {
        label: 'Ball Winner',
        abbreviation: 'REC'
      },
      38: {
        label: 'Regista',
        abbreviation: 'REG'
      },
      39: {
        label: 'Pressing',
        abbreviation: 'PRS'
      },
      40: {
        label: 'Progressive',
        abbreviation: 'PRG'
      },
      41: {
        label: 'Box-to-box',
        abbreviation: 'B2B'
      },
      42: {
        label: 'Attacking Regista',
        abbreviation: 'ROF'
      },
      43: {
        label: 'Final Third',
        abbreviation: 'ULT'
      },
      44: {
        label: 'Workhorse',
        abbreviation: 'CAB'
      },
      45: {
        label: 'Late Runner',
        abbreviation: 'LLE'
      },
      46: {
        label: 'Difference Maker',
        abbreviation: 'DES'
      },
      47: {
        label: 'Inverted Scorer',
        abbreviation: 'ING'
      },
      48: {
        label: 'Creator',
        abbreviation: 'CRE'
      },
      49: {
        label: 'Deep Midfielder',
        abbreviation: 'MPR'
      },
      50: {
        label: 'Target',
        abbreviation: 'REF'
      },
      51: {
        label: 'Link-up',
        abbreviation: 'ASO'
      },
      52: {
        label: 'Runner',
        abbreviation: 'RUP'
      },
      53: {
        label: 'Finisher',
        abbreviation: 'FIN'
      }
    },
    sucessfulTouch: '成功したタッチ',
    unsuccessfulTouch: '失敗したタッチ',
    showLegend: '凡例を表示'
  },
  finishingMap: {
    typesOfShot: 'シュートの種類',
    shotStrategy: '戦略',
    strategiesCount: '{count} 戦略',
    areas: 'エリア',
    bodyPart: '体の部分',
    more: 'より多く',
    selectAll: 'すべて選択',
    minutes: '時間',
    circles: '円',
    boxes: 'ボックスヒートマップ',
    lines: 'ライン',
    games: '試合',
    perShot: 'シュートあたり',
    goal: 'ゴール',
    missedShot: '枠外シュート',
    savedShot: 'セーブしたシュート',
    shotOnPost: 'バー、ポスト',
    missedChance: '逃したチャンス',
    openPlay: 'インゲーム',
    regularPlay: 'プレー中',
    fastBreak: '　カウンター中',
    individualPlay: '個人プレー中',
    setPiece: 'セットプレー',
    fromCorner: 'コーナーキックから',
    freeKick: 'フリーキック',
    indirectFreeKick: '関節フリーキック',
    throwInSetPiece: 'スローインから',
    inBox: 'ペナルティーエリア内',
    goalArea: 'ゴールエリア',
    boxLeft: 'ペナルティーエリア - 左側',
    boxCenter: 'ペナルティーエリア - 中央',
    boxRight: 'ペナルティーエリア - 右側',
    outOfBox: 'ペナルティーエリア外',
    outBoxDeepLeft: 'ペナルティーエリア外 - 左側深く',
    outBoxDeepRight: 'ペナルティーエリア外 - 右側深く',
    outBoxLeft: 'ペナルティーエリア外 - 左側',
    outBoxCentreLeft: 'ペナルティーエリア外 - 右側',
    outBoxCentre: 'ペナルティーエリア外 - 中央',
    outBoxCentreRight: 'ペナルティーエリア外 - 中央右側',
    outBoxRight: 'ペナルティーエリア外 - 右側',
    left35: '左 +35',
    centreLeft35: '中央左 +35',
    centre35: '中央 +35',
    centreRight35: '中央右 +35',
    right35: '右 +35',
    head: 'ヘッド',
    rightFooted: '右足',
    leftFooted: '左足',
    otherBodyPart: 'その他',
    chart: {
      shots: 'シュート',
      xGPerShot: 'シュートあたりの xG',
      exceptionTextPenaltyGoals: '* PK = 0.765 xG',
      exceptionTextGKPenaltyGoals: '* PK = 0.765 xGOT',
      exceptionTextOwnGoals: '* オウンゴールは数えません。',
      og: 'オウンゴール',
      penaltiesExcluded: 'ペナルティゴールは除外',
      ownGoalsExcluded: 'オウンゴールを除く',
      sumOfxG: ' xG の合計',
      exceptionShotsOutOfRange: '* 範囲外のシュートは表示されません'
    },
    inGoal: '枠内',
    outOfGoal: '枠外',
    highLeft: '左上',
    highCenter: '中央上',
    highRight: '右上',
    lowLeft: '左下',
    lowCenter: '中央下',
    lowRight: '右下',
    outHighLeft: '左上外れ',
    high: '中央上外れ',
    outHighRight: '右上外れ',
    closeHighLeft: '左上近く',
    closeHigh: '中央上近く',
    closeHighRight: '右上外れ',
    closeLeft: '左下近く',
    closeRight: '右下近く',
    finishingTable: '決定率表',
    onGoal: '枠内',
    distributionFilters: '配布フィルター',
    penalty: 'ペナルティ',
    penaltyShootout: 'PK戦',
    onlyPercentage: 'パーセンテージを表示',
    showAll: 'すべて表示',
    chanceMissed: 'チャンスを逃した'
  },
  keyPassMap: {
    chart: {
      keyPasses: 'キーパス',
      xAPerPass: 'パスあたりの xA ',
      xAOpenPlay: 'インプレーの xA ',
      xASetPiece: 'セットプレーの xA '
    }
  },
  beeswarm: {
    template: 'テンプレート',
    templates: {
      Goalkeeper: 'ゴールキーパー',
      Defender: 'ディフェンス',
      'Full-Back': 'サイドバック',
      FullBack: 'サイドバック',
      'Wing-Back': 'ウイングバック',
      WingBack: 'ウイングバック',
      Midfielder: 'ミッドフィールダー',
      AttackingMidfielder: 'トップ下',
      Winger: 'ウイング',
      Forward: 'ファワード',
      Physical: 'フィジカル'
    },
    compareWith: '比較',
    highlightPlayersOf: '選手をマークする',
    highlightPlayers: 'ハイライト選手',
    per90: 'プレイ時間90分あたりのデータ',
    highlightTeams: 'チームをハイライト',
    filterTeams: 'チームをフィルター',
    warningZeros: '反転していないスタッツのみ対象'
  },
  collections: {
    newCollection: '新しいコレクション',
    editCollection: 'コレクションを編集',
    name: '名前',
    visibility: '公開設定',
    privacity: {
      publicTitle: '公開タイトル',
      publicDescription: 'あなたとあなたのクラブ全体に表示されます。',
      privateTitle: 'プライベート',
      privateDescription: 'あなたにのみ表示されます。',
      supervisedTitle: '監督あり',
      supervisedDescription: 'あなたとあなたのスーパーバイザのみに表示されます'
    },
    addSuccess: '正常に追加されました。',
    createAddSuccess: '正常に作成および追加されました。',
    editSuccess: '正常に更新されました。',
    deleteSuccess: '正常に削除されました。',
    title: '選手のコレクション',
    publics: '公開',
    privates: 'プライベート',
    supervised: '監修された',
    totalMarketValue: '総市場価値',
    avgMarketValue: '平均市場価値',
    avgAge: '平均年齢',
    searchBarPlaceholder: 'コレクションに追加するプレーヤーを検索して選択します。',
    deleteCollection: 'コレクションを削除。',
    deleteCollectionMessage: 'コレクションが削除されます。 よろしいですか？',
    removePlayer: '選手を削除',
    removePlayerMessage: '選手が削除されます。 よろしいですか？',
    subtitle: '検索を整理する。',
    notExitingTemplate: 'テンプレートはまだない'
  },
  searchbar: {
    placeholder: '入力して検索 (例: `山田　太郎´)',
    players: '選手',
    teams: 'チーム',
    games: '試合',
    leagues: 'リーグ',
    explore: 'さらに結果を調べる',
    placeholderNoResults: 'テンプレートの結果はありません。',
    teamPlaceholder: '比較するチームを検索して選択する。'
  },
  favorites: {
    showOnly: '表示のみ',
    selfFavorites: '私のお気に入り',
    clubFavorites: 'クラブのお気に入り',
    contractExpiration: '契約満了',
    groupBy: 'のグループにまとめる。',
    noGrouped: 'グループにしない',
    maxSelection: '最大',
    selectAtleastOne: '最低1つ選択してください。',
    comparePlayers: '選手を比較する。',
    selectedPlayers: '選択した',
    subtitle: 'あなたのお気に入りを管理する',
    generateXlsx: 'XLSX　作成',
    generating: '作成中．．．',
    subscribed: 'Subscribed',
    subscribedTooltip: 'Subscribe to recieve a mail when a game have been played',
    deleteSelected: '選択したものを削除'
  },
  expiration: {
    summer: '6月',
    winter: '12月'
  },
  positions: {
    noposition: 'ポジション無し',
    goalkeeper: 'ゴールキーパー',
    goalkeepers: 'ゴールキーパー',
    defender: 'ディフェンス',
    defenders: 'ディフェンス',
    defenses: 'ディフェンス',
    fullback: 'サイドバック',
    fullbacks: 'サイドバック',
    midfielder: 'ミッドフィールダー',
    midfielders: 'ミッドフィールダー',
    winger: 'ウインガー',
    wingers: 'ウインガー',
    forward: 'フォワード',
    forwards: 'フォワード',
    wingback: 'ウイングバック',
    wingbacks: 'ウイングバック'
  },
  dPos: {
    1: {
      name: 'ゴールキーパー',
      alias: ''
    },
    2: {
      name: '右サイドバック',
      alias: 'RFB'
    },
    3: {
      name: '右センターバック',
      alias: 'RCB'
    },
    4: {
      name: '左センターバック',
      alias: 'LCB'
    },
    5: {
      name: '左サイドバック',
      alias: 'LFB'
    },
    6: {
      name: '守備的ミッドフィールダー',
      alias: 'DM'
    },
    7: {
      name: '右翼',
      alias: 'RW'
    },
    8: {
      name: 'センターミッドフィールダー',
      alias: 'CM'
    },
    9: {
      name: 'ストライカー',
      alias: 'ST'
    },
    10: {
      name: '攻撃的ミッドフィールダー',
      alias: '午前'
    },
    11: {
      name: '左ウィンガー',
      alias: 'ＬＷ'
    }
  },
  charts: {
    seasonsCompareSelectLabel: 'と比較',
    lastSeasonSelectText: '昨シーズン',
    lastAndCurrentSeasonSelectText: '昨シーズン + 今シーズン',
    currentSeasonSelectText: '今シーズン',
    lastNgamesSelectText: '最近の{x}試合',
    npgVsXGTitle: 'ペナルティ抜きのゴール VS xG',
    totalXGLabel: '合計 xG',
    xGLabel: 'xG',
    totalNPGLabel: 'ペナルティ抜きの合計ゴール',
    xGAgainstvsNPGAgainstTitle: '被 xG VS ペナルティ抜きの被ゴール',
    totalXGAgainstLabel: '合計被 xG ',
    xGAgainstLabel: '被 xG ',
    totalNPGAgainstLabel: 'ペナルティ抜きの合計被ゴール数',
    xGvsxGAgainstTitle: 'xG VS 被 xG ',
    pointsVsXPointsTitle: '獲得ポイント VS ポイント期待値',
    xTTitle: '試合のコントロール',
    totalXPoints: '合計ポイント期待値',
    totalPoints: '合計ポイント',
    requestedReports: '要求されたレポート',
    playersScouted: '目を通した選手',
    performanceVSAverageChart: 'パフォーマンス VS 平均',
    perPositions: 'ポジションで',
    perLeagues: 'リーグで',
    perMonths: '月で',
    perClients: '顧客で',
    ofPreposition: 'の',
    idJChartTitle: 'ゲームイニシアチブ',
    idJChartLabel: 'IdJ 指数',
    vJOChartTitle: 'オフェンシブゲームのボリューム',
    vJOChartLabel: 'VJO 指数',
    preJOChartTitle: 'オフェンシブゲームの精度',
    preJOChartLabel: 'PreJO 指数',
    proJOChartTitle: 'オフェンシブゲームの進展',
    proJOChartLabel: 'ProJO 指数',
    chart: 'チャート',
    table: 'テーブル',
    showLeaguesWithAtLeast: '少なくとも',
    playersScoutedSuffix: '見た選手'
  },
  table: {
    history: {
      season: 'シーズン',
      team: 'チーム',
      position: 'ポジション',
      side: 'サイド',
      games: '試合',
      minutes: '分',
      goals: 'NPG (G)',
      assists: 'A',
      yellowCards: 'YC',
      redCards: 'RC',
      gameLost: 'GM',
      gamesMissed: '欠場試合',
      goalsReceived: 'NPGC (GC)'
    },
    injury: {
      season: 'シーズン',
      team: 'チーム',
      injury: '怪我',
      dateFrom: '開始日',
      dateTo: '終了日',
      daysLost: '失った日数',
      gamesLost: '負けた試合',
      allInjuries: 'すべての怪我'
    },
    transfers: {
      season: 'シーズン',
      date: '日付',
      teamFrom: '前のチーム',
      teamTo: '次のチーム',
      marketValue: '市場価格',
      fee: 'コスト',
      type: 'タイプ'
    },
    caps: {
      team: 'チーム',
      debut: 'デビュー',
      games: '試合',
      goals: 'ゴール',
      coachDuringDebut: 'デビュー時の監督',
      debutAge: 'デビュー年齢'
    },
    roster: {
      country: 'パリ',
      player: '選手',
      positions: 'ポジション',
      minutes: '分',
      games: '試合',
      goals: 'ゴール',
      assists: 'アシスト',
      cards: 'カード',
      gamesExplicit: 'プレーした試合'
    },
    league: {
      title: 'リーグシート',
      subtitle: 'リーグのランキングと統計をさらに詳しく見る',
      team: 'チーム',
      games: '行った試合',
      gamesExplicit: 'プレーした試合',
      gamesRanking: '試合数',
      gamesRankingExplicit: 'プレーした試合',
      points: 'Pts',
      pointsExplicit: 'ポイント',
      expectedPoints: 'xP',
      expectedPointsExplicit: 'ポイント期待値',
      goalsScored: 'ペナルティ抜きのゴール',
      goalsScoredExplicit: 'ペナルティ抜きのゴール',
      xG: 'xG',
      xGExplicit: 'ゴール期待値',
      goalsAgainst: 'ペナルティ抜きの被ゴール',
      goalsAgainstExplicit: '被ゴール',
      xGAgainst: '被 xG ',
      xGAgainstExplicit: '被ゴール期待値',
      xGAgainstDiff: '被 xG Dif.',
      xGAgainstDiffExplicit: '被ゴール期待値の差',
      form: 'フォーム',
      sos: 'SoS',
      sosExplicit: 'スケジュールの問題',
      sosHfa: 'SoS HFA',
      sosHfaExplicit: 'ホームアドバンテージ',
      difficultyAboveAvg: '平均以上の難易度',
      differentGames: '* プレーした試合の数が異なる',
      berth: 'レーティング'
    },
    usersOfClient: {
      userName: '名前',
      userRole: 'ユーザー',
      devRole: '開発者',
      adminRole: '管理者',
      servicesRole: 'サービス',
      xgRole: 'xG',
      radarRole: 'レーダー',
      beeswarmRole: 'Ranking',
      elevenRole: 'Elevens',
      similarityRole: 'Similarity',
      gameAnalysisRole: '試合分析',
      clientStatsRole: 'クライアント統計',
      created: '作成日',
      type: 'タイプ',
      logins: 'アクセス',
      lastLogin: '最終アクセス',
      trialDate: '締め切り'
    },
    clientLeagues: {
      league: 'リーグ',
      area: 'エリア',
      tier: 'レベル',
      seasons: 'シーズン',
      currentMatchDay: '節',
      regular: 'レギュラー',
      youthLeague: '下部組織',
      clientActive: 'アクティブ',
      visibleLeagues: '可視化できるリーグ',
      male: '男子リーグ',
      female: '女子リーグ'
    },
    connections: {
      title: '最も一般的な組み合わせ',
      playerFrom: 'パサー',
      playerTo: 'パス受け手',
      passes: 'パス',
      passesTooltip: '成功したパスの合計',
      passesFinalThird: 'ファイナルサードでのパス',
      passesFinalThirdTooltip: '相手ペナルティーエリア付近でのパス'
    },
    playerPassMapData: {
      title: 'パスの統計',
      player: '選手',
      passes: 'パス',
      passesPct: '% パス',
      xA: 'xA',
      xG: 'xG',
      xT: 'xT',
      playerTooltip: '選手の名前',
      passesTooltip: 'パスの合計数',
      passesPctTooltip: '成功したパスの割合',
      xATooltip: 'アシスト期待値',
      xGTooltip: 'ゴール期待値',
      xTTooltip: '予想される危険'
    },
    playerAllGames: {
      gameDate: '日付',
      game: '試合',
      team: 'チーム',
      positionsPlayed: 'ポジション',
      minsPlayed: '分',
      gameActions: 'アクション',
      gameDateTooltip: '試合日程',
      gameTooltip: '試合',
      positionsPlayedTooltip: 'プレーしたポジション',
      minsPlayedTooltip: 'プレーした時間',
      gameActionsTooltip: 'ゴール、アシスト、カード',
      from: '開始',
      to: '終了',
      goalText: 'でのゴール',
      assistText: 'でのアシスト',
      penaltyText: 'でのPK',
      ownGoalText: 'でのオウンゴール',
      yellowCardText: 'でのイエローカード',
      secondYellowCardText: 'での2枚目のイエローカード',
      redCardText: 'でのレッドカード',
      substitutionIN: 'に入る',
      substitutionOUT: 'に出る',
      suspendedText: '出場停止',
      Team: 'チーム'
    },
    gameFlow: {
      phase: '局面 ',
      mins: '時間',
      team: 'チーム',
      period: '期間',
      possession: 'Pos',
      possessionTooltip: 'ポゼッション',
      xT: 'xT',
      xTTooltip: '脅威期待値',
      pft: 'PUT',
      pftTooltip: '相手ペナルティーエリア付近でのパス',
      xG: 'xG',
      xGTooltip: 'ゴール期待値'
    }
  },
  game: {
    title: 'ゲームシート',
    subtitle: 'ゲームの特徴や統計についてさらに深く掘り下げる',
    header: {
      gameDetails: '詳細',
      gameStats: '統計',
      gameFinishingMap: ' xG マップ',
      gameKeyPassMap: ' xA マップ',
      gamePassMap: 'パスマップ',
      gameThreat: '危険マップ',
      gameFlow: '試合のコントロール',
      gameAnalysis: '分析',
      gamePhysicalStats: '身体的統計',
      possessions: 'ポゼッション',
      bench: 'ベンチ',
      video: 'ビデオハイライト',
      preGame: '試合前',
      postGame: '試合後',
      areaCoverage: '対応エリア'
    },
    passMap: {
      typeOfPlay: 'プレータイプ:',
      passes: 'パス:',
      team: 'チーム',
      minutes: '時間:',
      select: '選択',
      all: '全て',
      attacking: '攻撃',
      defending: '守備',
      forwards: '前へ',
      backwards: '後ろへ',
      sideways: 'サイドへ',
      longBall: 'ロングパス',
      successfullPasses: '成功したパス',
      homeTeam: 'ホーム',
      awayTeam: 'アウェイ',
      passingMatrix: 'パスのマトリックス',
      passer: 'パサー',
      receiver: 'レシーバー',
      passOutcome: 'パス結果',
      passDirection: 'パス方向',
      half: 'ハーフ',
      offensive: 'オフェンシブ',
      defensive: 'ディフェンシブ',
      passingConnections: 'パスコネクション',
      pitchView: 'ピッチ',
      passSingular: 'パス',
      passPlural: 'パス',
      playerLocation: 'プレイヤーの位置',
      passLegend: '平均タッチ位置',
      minuteRange: '分の範囲'
    },
    stats: {
      summary: 'Summary',
      attacking: 'Attacking',
      defending: 'Defending',
      contribution: 'Contribution',
      possession: 'ポゼッション',
      expectedPoints: 'ポイント期待値',
      directness: '縦性',
      ppda: 'PPDA',
      xg: 'xG',
      xG: 'xG',
      xGSetPiece: 'xG セットプレー',
      xA: 'xA',
      xASetPiece: 'xA xG セットプレー',
      xT: 'xT',
      xTSetPiece: 'xT xG セットプレー',
      touchesInOppBox: '相手ペナルティーエリアでのタッチ',
      passesFinalThird: '相手ペナルティーエリア付近でのパス',
      interceptions: 'インターセプト',
      recoveries: 'ボールの奪取',
      recoveriesOppHalf: '敵陣地でのボールの奪取',
      tackles: 'タックル',
      tacklesWasDribbled: '守備1v1勝利数',
      fouls: 'ファール',
      yellowCards: 'イエローカード',
      redCards: 'レッドカード',
      passes: 'パス',
      passing: 'パス率',
      crosses: 'クロス',
      crossing: 'クロス率',
      shots: 'シュート',
      shotsOnTarget: '枠内シュート',
      ppdaExplicit: '守備アクションあたりのパス数',
      xgExplicit: 'ゴール期待値',
      xp: 'xP',
      ExpectedPassing: 'xP%',
      seasonAvg: '大会平均',
      winChanceTooltip: '勝つ可能性 作ったのと与えた xG に基づく。',
      drawChance: '引き分け',
      xgAgainst: '被 xG ',
      averagePossession: 'ポゼッション',
      averageShots: 'シュート',
      averagexG: 'ゴール期待値',
      fieldTilt: 'Field Tilt',
      fieldTiltExplicit: 'Field Tilt',
      recoveriesRate: '回収率',
      turnoversRate: '離職率'
    },
    detail: {
      halfTime: 'ハーフタイム',
      overTime: '延長',
      showStats: '統計を表示',
      hideStats: '統計を隠す',
      bench: 'ベンチ',
      showShotOptions: 'シュートオプションを表示',
      hideShotOptions: 'シュートオプションを隠す',
      showPassOptions: 'パスオプションを表示',
      hidePassOptions: 'パスオプションを隠す',
      endGame: '試合終了',
      penalties: 'PK'
    },
    timeline: {
      events: {
        goal: 'ゴール',
        goal_ownGoal: 'オウンゴール',
        goal_penalty: 'PKゴール',
        card: 'カード',
        card_yellowCard: 'イエローカード',
        card_secondYellowCard: '2枚目のイエローカード',
        card_redCard: 'レッドカード',
        formationChange: 'フォーメーションチェンジ',
        substitution: '交代',
        saveShot: 'シュートセーブ',
        saveShot_penalty: 'PKセーブ',
        missedShot: 'シュートミス',
        missedShot_penalty: 'PKミス',
        shotOnPost: 'シュート、バーポスト直撃',
        shotOnPost_penalty: 'PK、バーポスト直撃',
        drinksBreak_startDrinksBreak: 'Start Cooling Break',
        drinksBreak_endDrinksBreak: 'End Cooling Break',
        assist: 'Assist'
      },
      gameTimeline: 'Game Timeline'
    },
    gameFlow: {
      goalOf: 'のゴール ',
      redCardTo: 'へレッドカード ',
      missedPenalty: 'PKミス '
    },
    gameThreat: {
      typeOfPlay: 'アクションの種類',
      regularPlay: '試合中',
      setPiece: 'セットプレー',
      setPiecePlay: 'セットプレー',
      throwInSetPiecePlay: 'スローインプレー',
      throwInPlay: 'スローインプレー',
      gkThrow: 'ゴールキーパーの投げ',
      gkKick: 'ゴールキーパーキック',
      kickOff: 'キックオフ',
      actionEnding: '最後のアクション',
      pass: 'パス',
      shot: 'シュート',
      foul: 'ファール',
      other: 'その他',
      threat: '脅威',
      legendSumOfXT: 'xT の合計',
      legendPass: 'パス',
      legendShot: 'シュート',
      legendCarryAndAction: 'ボールを運んでアクション',
      legendCarryAndPass: 'ボールを運んでパス',
      legendOnlyShowing: '· xT と個々のアクションのみを表示 > ',
      legendOnlyShowingPart1: 'アクションのみを表示',
      legendOnlyShowingPart2: '個々と xT > ',
      legendOnlyShowingSetPiece: '·セットプレーのみ表示 con xT > ',
      legendOnlyShowingOpenPlay: '· インプレーのアクションを表示するだけ con xT > ',
      legendPlays: 'アクション',
      legendPerPlay: 'アクションごと',
      legendCarry: 'ボールを運ぶ',
      penaltyPlay: 'PK',
      freeKickTakenPlay: 'プリーキックプレー',
      cornerTakenPlay: 'コーナーキックプレー',
      fromCornerPlay: 'コーナーキックプレー',
      keeperThrowPlay: 'ゴールキック',
      fastBreakPlay: 'カウンター',
      indirectPlay: '間接フリーキック',
      minutes: '時間',
      games: '試合',
      xT: 'xT',
      xTPer90: '90分間の xT\''
    },
    gameAnalysis: {
      next: '次',
      previous: '前',
      phaseLabel: 'フェーズ',
      phasesLabel: 'フェーズ',
      dot: '. ',
      comma: ', ',
      from: 'から',
      to: 'に',
      and: ' と ',
      steps: {
        finishingMapFullGame: '終了マップ',
        keyPassMapFullGame: 'キーパスマップ',
        gameFlow: '試合コントロール',
        finishingMapPerPhases: '終了マップ、フェーズ',
        keyPassMapPerPhases: 'キーパスマップ、フェーズ',
        passMapPerPhases: 'パスマップ、フェーズ'
      },
      step1: {
        table: {
          draw: '引き分け',
          win: '勝ち',
          lose: '負け',
          possession: 'ポゼッション',
          xP: 'ポイント期待値',
          directness: '縦性',
          ppda: 'PPDA',
          xG: 'xG',
          xGOpenPlay: 'インプレーの xG ',
          xGSetPiece: 'セットプレーの xG ',
          xA: 'xA',
          xAOpenPlay: 'インプレー xA '
        },
        text: {
          firstParagraph: {
            1: '右側のマップは、home_team_name と away_team_name によって生まれるゴール期待値を示しています。 塗りつぶされた円は、ゴールで終わったシュートです。 円のサイズは、各シュートの xG によって異なります。'
          },
          lastParagraph: {
            1: '勝利の確率と予想されるポイント数は、シュートから計算されます (ゴールの確率を考慮しシュートを100,000回シミュレーション)。'
          },
          targetHighTeamXG: {
            1: 'target_team_name, または rival_team_name は高いゴール期待値を生み出してる。'
          },
          targetHighTeamOpenPlayXG: {
            1: 'この試合では、target_team_name のチャンスのほとんどはインプレ-から生まれています。'
          },
          targetHighTeamOpenPlayXGvsGameRival: {
            1: 'この対戦では、target_team_name のチャンスのほとんどはインプレーから生まれています。(rival_team_name とは違い)'
          },
          targetHighTeamSetPieceXG: {
            1: 'この試合では、target_team_name のチャンスのほとんどはセットプレーから生まれました。'
          },
          targetHighTeamSetPieceXGvsGameRival: {
            1: 'この対戦では、target_team_name のチャンスのほとんどはセットプレーから生まれています。 (rival_team_name とは違い)'
          },
          targetHighTeamCornerXG: {
            1: 'この試合では、target_team_name のチャンスのほとんどはコーナーキックから生まれています。'
          },
          targetLowTeamGoalConversion: {
            1: 'しかし、ゴールに変わる係数は低い。'
          },
          dot: {
            1: '. '
          },
          targetHighTeamXGOPandSP: {
            1: 'target_team_name は、インプレーとセットプレーの両方で大量のゴール期待値を生み出しました'
          },
          targetHighTeamGoalConversion: {
            1: 'またこのようなゴールチャンスに変える高い能力を持っています。 '
          },
          targetLowTeamGoalConversionZeroGoals: {
            1: '生まれたいずれかのチャンスを決めることができません。'
          },
          targetLowTeamGoalConversionScoringGoals: {
            1: 'しかし、より多くのゴ​​ールを決めるチャンスを生み出しました。'
          },
          targetHighTeamXGvsGameRival: {
            1: 'この対戦で、target_team_name は rival_team_name よりも多くのチャンスを生み出しました。'
          },
          targetLowTeamGoalConversionScoringGoals2: {
            1: 'それともっと多くのゴールを決められたかもしれません。 '
          },
          targetHighTeamXGZeroGoals: {
            1: 'しかし、ゴールを決めるチャンスを生かすことができませんでした。 '
          },
          targetHighTeamXGGoalDiff: {
            1: '試合後のシミュレーションによると、 team_winning_chance が勝つチャンスがあります。'
          },
          startTargetHighTeamOpenPlayXG: {
            1: 'target_team_name のチャンスのほとんどは、インプレーによるものです。 '
          },
          startTargetHighTeamSetPieceXG: {
            1: 'target_team_name のチャンスのほとんどは、セットプレーによるものです。 '
          },
          startTargetHighTeamCornerXG: {
            1: 'ほとんどのチャンスはコーナーキックによって生み出されました。 '
          },
          targetSimilarTeamXG: {
            1: 'この試合中、ゴール期待値に関して、両チームは敵チームに対して同様の xG を生みだしました。'
          },
          targetSimilarTeamXGGoalDiff: {
            1: 'しかし、target_team_name の方がこれらのチャンスをうまく終わらせました。'
          },
          targetLowTeamXGGoalDiff: {
            1: '結果に関係なく、target_team_name はゴール期待値に関して言えば、対戦相手に大きな危険をもたらしませんでした。'
          },
          targetLowTeamXGZeroGoalDiff: {
            1: 'target_team_name は、ゴール期待値に関して言えば、対戦相手に試合に勝つための十分な危険をもたらしませんでした。'
          },
          rivalHighTeamXG: {
            1: 'そして、riverrivate_team_name にあまりにも多くのチャンスをもたらすのを許しました。 '
          },
          rivalHighTeamXGGoalDiff: {
            1: '試合後のシミュレーションに基づくと、target_team_name が team_winning_chance しか勝てない試合です。'
          },
          targetHighTeamGoalConversion2: {
            1: 'ゴールに変わる係数が高い。'
          },
          winningChance: {
            1: '両方のチームのショット数と xG を考えると、 この試合は target_team_name が team_winning_chance 勝つべきでした。'
          },
          highPlayerXGManyShots: {
            1: '興味深いことに、player_name は shots_value シュートで xg_value xG を生みました。'
          },
          highPlayerXGMoreThanOneGoal: {
            1: 'ゴールを決めるには xg_value xG が必要です。'
          },
          highPlayerXGOneGoal: {
            1: 'ゴールを決めるため'
          },
          highPlayerXGAnyGoal: {
            1: 'ゴールを決めることができませんでしたが。'
          },
          highPlayerXGNotManyShots: {
            1: 'player_name が数回のシュートで xg_value xG を出したことは興味深いです。'
          },
          highManyPlayerXG: {
            1: 'player_name と player_name2 がそれぞれ xg_value と xg_value2 <b>xG</b</b> を出したことに注目するのは興味深いです。 '
          },
          highTeamXGPerShot: {
            1: 'target_team_name のシュートの選択に関しては、xg_per_shot_value で1シュートあたりの平均 xG を記録し、得点の可能性に関して非常に優れていました。'
          },
          highTeamXGPerShotVSGameRival: {
            1: 'target_team_name のシュートの選択は、rival_team_name よりもはるかに優れており、平均シュート1本あたり xg_per_shot_value xG でした。'
          },
          xGTimesNotAfter70xG: {
            1: '高い XG にもかかわらず、target_team_name は試合終盤にチャンスを生み出すのに苦労しました。'
          },
          xGTimesBefore25xG: {
            1: 'target_team_name は、特に前後半の序盤に多くのチャンスを生み出しました。 '
          },
          xGTimesAfter25xG: {
            1: 'target_team_name は、特に前後半の終盤に多くのチャンスを生み出しました。 '
          },
          xGTimesBefore25xGvsItself: {
            1: 'target_team_name は、前半の早い時間帯でほとんどのチャンスを生み出しました。'
          },
          xGTimesAfter25xGvsItself: {
            1: 'target_team_name は、前半の遅い時間帯でほとんどのチャンスを生み出しました。'
          },
          xGTimesBefore70xGvsItself: {
            1: 'target_team_name は、後半の早い時間帯でほとんどのチャンスを生み出しました。'
          },
          xGTimesAfter70xGvsItself: {
            1: 'target_team_name は、後半の遅い時間帯でほとんどのチャンスを生み出しました。'
          },
          xGTimesBefore25xG2: {
            1: 'target_team_name は、 xg_value <b>xG</b> を生みだしチャンスとともに非常に力強くゲームを開始しました。'
          },
          xGTimesAfter25xG2: {
            1: 'target_team_name は、 xg_value ゴール期待値を生み出し、チャンスとともに前半を終了しました。'
          },
          xGTimesBefore70xG: {
            1: 'target_team_name は、 xg_value ゴール期待値を生み出し、チャンスとともに休憩から出ました。'
          },
          xGTimesAfter70xG: {
            1: 'target_team_name は、 xg_value ゴール期待値を生み出し、チャンスとともに後半を終了しました。 '
          },
          xGTimesAfter70xGOverOneDotTwo: {
            1: 'target_team_name は、後半終盤に多くのチャンスを生み出しました。'
          },
          xGTimesBefore70xGOverOneDotTwo: {
            1: 'target_team_name は、後半の早い時間帯に多くのチャンスを生み出しました。'
          },
          xGTimesAfter25xGOverOneDotTwo: {
            1: 'target_team_name は、前半終盤に多くのチャンスを生み出しました。'
          },
          xGTimesBefore25xGOverOneDotTwo: {
            1: 'target_team_name は、前半の早い時間帯に多くのチャンスを生み出しました。'
          },
          xGTimesFirstHalfXGSecondHalfXGRival: {
            1: 'target_team_name は前半でほとんどのチャンスを生み出しましたが、rival_team_name は後半で同じことをしました。'
          },
          xGTimesSecondHalfXGFirstHalfXGRival: {
            1: 'target_team_name は後半でほとんどのチャンスを生み出しましたが、rival_team_name は前半で同じことをしました。'
          },
          xGTimesFirstHalfXGFirstHalfXGRival: {
            1: '前半にゴール期待値のチャンスのほとんどが発生した試合。 '
          },
          xGTimesSecondHalfXGSecondHalfXGRival: {
            1: 'ゴール期待値の面で最もチャンスを作ったのは後半の試合だ。'
          },
          xGTimesFirstHalfXG: {
            1: 'target_team_name は、前半にほとんどのチャンスを生み出すことができました。 '
          },
          xGTimesSecondHalfXG: {
            1: 'target_team_name は、後半にほとんどのチャンスを生み出すことができました。'
          },
          xGTimesFirstHalfXGRival: {
            1: 'target_team_name は、ゴール期待値に関してみると前半にほとんどの危険を許容しました。'
          },
          xGTimesSecondHalfXGRival: {
            1: 'target_team_name は、ゴール期待値に関してみると後半にほとんどの危険を許容しました。 '
          },
          highInBoxXG: {
            1: 'シュートマップを見ると、ほとんどの危険がペナルティーエリア内で発生したことがわかります。 '
          },
          highOutOfBoxXG: {
            1: 'シュートマップから、この試合で target_team_name がボックスの外から多くの危険を生み出したことがわかります。 '
          },
          highInBoxXGRival: {
            1: 'target_team_name によって与えられた危険のほとんどは、ペナルティーエリア内でのシュートによるものだったことを指摘しておきます。'
          },
          highInBoxXGRival2: {
            1: 'また、target_team_name によって与えられた危険のほとんどが、ペナルティーエリア内でのシュートによるものだったことにも注目してください。 '
          },
          highOutOfBoxXGRival: {
            1: 'target_team_name はペナルティーエリア内の危険をうまく回避しました。'
          },
          highTeamChancesHighPPDARival: {
            1: 'target_team_name からのプレッシャーがなく、守備アクションのために ppda_value パスを許したのは、 rival_team_name が多くのチャンスを作るための鍵の1つでした。'
          },
          lowPPDAWithGoalDiff: {
            1: 'target_team_name 守備アクションのために ppda_value パスのみ許しました。これが勝利への鍵の1つになりました。'
          },
          lowPPDA: {
            1: 'target_team_name は rival_team_name のプレーを妨げる素晴らしい仕事をし、守備アクションごとに平均 ppda_value のパスしか許しませんでした。'
          },
          highPossession: {
            1: 'ポゼッション possession_value で、target_team_name はボールを支配してました。'
          },
          highPPDARival: {
            1: 'ボールをスムーズに配分するのと同様に'
          },
          chancesCreated: {
            1: 'これにより多数のオープンプレー(chances_value)の機会を持つことができました。'
          },
          chancesCreatedRival: {
            1: 'ただし rival_team_name は多数のオープンプレー(chances_value)の機会を作ることできました。 '
          },
          xGPerShotRival: {
            1: ' rival_team_name は xg_per_shot_value <b>xG por tiro</b> で、より脅威になるチャンスを作ることができました。 '
          },
          winGame: {
            1: '試合に勝つための重要な要素の1つです。'
          },
          notEnoughWinGame: {
            1: '試合に勝つには十分ではありません'
          },
          goalsFromErrorsFirstGoal: {
            1: '最初のゴールは、 player_error_name のエラーを player_name が生かしました。'
          },
          goalsFromErrorsFirstGoalFinalResult: {
            1: '最初で唯一のゴールは、player_error_name のエラーからで player_name が生かしました。'
          },
          lastPhaseOfGame: {
            1: '試合の終盤で。'
          },
          goalsFromErrorsFinalResultGoalToLead: {
            1: '決勝ゴールは player_error_name のミスが原因で、 player_name のゴールにつながりました。 '
          },
          goalsFromErrorsFinalResultGoalToTie: {
            1: '試合を引き分けにしたゴールは player_error_name のミスが原因で、 player_name のゴールにつながりました。'
          },
          goalsFromErrorsGoalToTie: {
            1: ' player_error_name のミスが起点となり、target_team_name の同点のチャンスにつながりました。'
          },
          goalsFromErrorsGoalToLead: {
            1: 'target_team_name は player_error_name のミスをうまく利用してリードしました。'
          },
          xGChance: {
            1: ' xg_value <b>xG</b>の確率で '
          },
          rivalGoalsFromErrorsFinalResultGoalToLead: {
            1: 'player_error_name のミスが原因での player_name のゴールが rival_team_name の決勝点になりました。'
          },
          rivalGoalsFromErrorsGoalToTie: {
            1: 'player_error_name のミスが起点となり、 rival_team_name　の同点のチャンスにつながりました。'
          },
          rivalGoalsFromErrorsGoalToLead: {
            1: 'rival_team_name は player_error_name のミスをうまく利用してリードしました。'
          },
          hugeChancesMissedOneScored: {
            1: 'target_team_name は、試合中に生まれた唯一の大きなチャンスをマークしました。 ゴール期待値マップで xg_value の <b>xG</b> で表示される player_name のゴールです。'
          },
          hugeChancesMissedMoreThanOneScored: {
            1: 'target_team_name は、試合中に生まれたすべてのビッグチャンスをものにしました。'
          },
          hugeChancesMissedZeroGoalsOneChance: {
            1: 'player_name は <b>xG</b> は xg_value で、target_team_name の唯一の大きなゴールチャンスでした。 '
          },
          hugeChancesMissedZeroGoalsMoreChances: {
            1: 'target_team_name は、ゴールになる可能性が40%を超える chances_value のチャンスを決めきることができませんでした。 '
          },
          oneHugeChancesBeforeFirstGameGoal: {
            1: 'player_name は得点をリードするための、 xg_value <b>xG</b> の絶好の機会を得ました。'
          },
          moreThanOneHugeChancesBeforeFirstGameGoal: {
            1: 'target_team_name は <b>xG</b> で chances_value チャンスがあり、スコアボードで優位に立つ可能性は40%以上ありました。'
          },
          moreThanOneBigChancesBeforeFirstGameGoal: {
            1: 'target_team_name は <b>xG</b> は高く、スコアボードで優位に立つチャンスが chances_value ありました。'
          },
          shotOnPostBeforeFirstGameGoal: {
            1: 'player_name は、ポストに当たった xg_value <b>xG</b> でリードするチャンスがありました。 '
          },
          beforeEndOfGame: {
            1: '試合終了前に、'
          },
          oneHugeChancesAfterFirstGameGoal: {
            1: 'player_name は xg_value <b>xG</b> で試合に勝つチャンスがありました。 '
          },
          moreThanOneHugeChancesAfterFirstGameGoal: {
            1: 'target_team_name には、3 ポイントを獲得するためのゴール確率が40%を超える chances_value のチャンスがありました。'
          },
          moreThanOneBigChancesAfterFirstGameGoal: {
            1: 'target_team_name は <b>xG</b> が高く、試合に勝つチャンスが chances_value ありました。'
          },
          oneHugeChancesBeforeFirstGameGoalRival: {
            1: 'player_name は xg_value <b>xG</b> でチームをリードさせる絶好のチャンスを楽しみました。 '
          },
          moreThanOneHugeChancesBeforeFirstGameGoalRival: {
            1: 'target_team_name は <b>xG</b> が <b>40%</b> を超えるチャンスが chances_value あり、試合でリードすることができました。 '
          },
          moreThanOneBigChancesBeforeFirstGameGoalRival: {
            1: 'target_team_name は高いxGで、 chances_value 回あり、リードのチャンスを楽しみました。'
          },
          shotOnPostBeforeFirstGameGoalRival: {
            1: 'player_name は xg_value <b>xG</b> でチームをリードするチャンスを楽しみましたが、ポストに当たってしまいました。'
          },
          bigChancesMissedWhenLosingByOne: {
            1: 'player_name は xg_value <b>xG</b>  で同点のチャンスがありましたが、運がありませんでした。'
          },
          moreThanOneBigChancesMissedWhenLosingByOne: {
            1: 'target_team_name は、30%を超えるゴールの可能性で試合を引き分けるチャンスが chances_value ありました。 '
          },
          shotOnPostWhenLosingByOne: {
            1: 'player_name は xg_value <b>xG</b> から同点のチャンスを得ましたが、ポストに当たってしまいました。'
          }
        }
      },
      step2: {
        table: {
          draw: '引き分け',
          win: '勝利',
          possession: 'ポゼッション',
          xP: 'ポイント期待値',
          directness: '縦性',
          ppda: 'PPDA',
          xA: 'xA',
          xAOpenPlay: 'インプレー xA ',
          xASetPiece: 'セットプレー xA ',
          chancesCreated: '作ったチャンス',
          shotsOnTarget: '枠内シュート'
        },
        text: {
          firstParagraph: {
            1: 'この画像は、 <b>home_team_name</b> と <b>away_team_name</b> の <b>アシスト期待値</b> を示しています。'
          },
          xAPerKeyPass: {
            1: 'キーパスごとの xA '
          },
          keyPassesGeneratedFrom: {
            1: 'キーパスを特に作ったのは'
          },
          highTeamXAvsXG: {
            1: ' xAマップでわかるように、 target_team_name によって生まれるチャンスのほとんどは、個々のアクションではなく、コンビネーションプレーから発生します。'
          },
          openPlay: {
            1: 'インプレー'
          },
          setPiece: {
            1: 'セットプレーで'
          },
          cornerKicks: {
            1: 'コーナーキックから'
          },
          combinationPlays: {
            1: 'コンビネーションプレー'
          },
          dot: {
            1: '. '
          },
          comma: {
            1: ', '
          },
          averageTeamXAvsXG: {
            1: 'この試合では、target_team_name コンビネーションプレーでチャンスを多く生み出しました。'
          },
          individualActions: {
            1: '個人のアクションのように'
          },
          dangerFromIndividualActions: {
            1: 'この試合では、target_team_name によって作られるチャンスのほとんどは、個人のプレーに起因します。'
          },
          highTeamXAvsXGRival: {
            1: ' xAマップで確認できるように、この試合 target_team_name が与えたチャンスはコンビネーションプレーから生じています。'
          },
          rivalStrongKeyPassesFrom: {
            1: ' rival_team_name 生み出されたキーパスの数々で強さを見せた。 '
          },
          manyPlayerKeyPasses: {
            1: '<b>player_name</b> が <b>key_passes pases clave</b> で<b>xa_value xA</b> 生み出したことは興味深いことです。'
          },
          playerAssists: {
            1: ' assist</b> ごとに <b>xa_per_assist xA が必要です。'
          },
          giveAssist: {
            1: 'アシストするために.'
          },
          noAssists: {
            1: '彼のパスはいずれもアシストにはなりませんでしたが。'
          },
          highXANotManyShots: {
            1: '<b>player_name</b> が数回のパスで <b>xa_value xA</b> を生みだしたことは興味深いことです。'
          },
          manyPlayersHighXA: {
            1: '<b>player_name</b> と <b>player_name2</b> がそれぞれ <b>xa_value</b> と <b>xa_value2 xA</b> を生みだしたことは興味深いことです。'
          },
          xATimes: {
            1: 'target_team_name は前半でほとんどのチャンスを生み出しましたが、rival_team_name は後半で同じことをしました。'
          },
          firstHalf: {
            1: '前半'
          },
          secondHalf: {
            1: '後半'
          },
          left: {
            1: '左サイド'
          },
          center: {
            1: '中央 '
          },
          right: {
            1: '右サイド'
          },
          xAFirstHalfFirstHalfRival: {
            1: 'ゴール期待値に関して、ほとんどの危険が発生した期間は'
          },
          xAFirstHalf: {
            1: 'target_team_name は彼らの危険のほとんどを起こしました '
          },
          xATimesXARival: {
            1: 'target_team_name ゴール期待値に関して、あまりにも多くの危険を与えました。 '
          },
          xASides: {
            1: 'target_team_name によって作られたチャンスのほとんどは、side_name (<b>xa_value xA</b>)から生まれました。'
          },
          xASidesRival: {
            1: '一方、 rival_team_name は side_name (<b>xa_value xA</b>)から多くを作りました。'
          },
          dangerCreationRival: {
            1: 'rival_team_name のチャンスは、特に、 desde el side_name (<b>xa_value xA</b>)から発生します。'
          },
          speciallyEffective: {
            1: 'target_team_name は特に効果的でした '
          },
          xAPerChanceCreated: {
            1: '平均 <b>xa_value xA</b>'
          },
          speciallyEffectiveRival: {
            1: 'rival_team_name は特に効果的でした '
          }
        }
      },
      step3: {
        text: {
          chance: ' チャンス',
          chances: ' チャンス',
          goal: ' ゴール',
          goals: ' ゴール',
          home: 'ホーム',
          away: 'アウェイ',
          last: '最後',
          first: '最初',
          goalScorer: 'ゴールスコアラー',
          goalScorers: 'ゴールスコアラー',
          lastPhase: '試合の終盤で、',
          phase: {
            1: '試合のこの phase_position フェーズでは、'
          },
          moreXT: {
            1: '<b style=\'color:more_color\'>more_xt_team_name</b> は <b style=\'color:less_color\'>less_xt_team_name</b> (<b style=\'color:less_color\'>less_xt_team_value xT</b>) よりも多くの脅威 (<b style=\'color:more_color\'>more_xt_team_value xT</b>) を起こしました。'
          },
          sameTeamMoreMinutes: {
            1: 'そして、相手よりも多くの時間脅威を発生させました。(<b style=\'color:more_color\'>more_time_xt_minutes mins.</b> に対して <b style=\'color:less_color\'>less_time_xt_minutes mins.</b>)'
          },
          rivalTeamMoreMinutes: {
            1: 'しかし、この試合で多くの時間脅威を発生させたのは反対のチームです。(<b style=\'color:more_color\'>more_time_xt_minutes mins.</b> に対して <b style=\'color:less_color\'>less_time_xt_minutes mins.</b> del rival)'
          },
          maxXTValue: {
            1: '<b style=\'color:max_color\'>max_xt_team_name</b> は <b style=\'color:max_color\'>max_xt_team_minute\'</b> に一番の脅威(<b style=\'color:max_color\'>max_xt_team_value xT</b>)を引き起こしました。'
          },
          maxXTValueRival: {
            1: '対して <b style=\'color:max_rival_color\'>max_xt_rival_team_name</b> は <b style=\'color:max_rival_color\'>max_xt_rival_team_minute\'</b> に一番の脅威 (<b style=\'color:max_rival_color\'>max_xt_rival_team_value xT</b>) を引き起こしました。'
          },
          bothTeamsScoreButDraw: {
            1: 'この試合両チームとも相手チームのゴールキーパーをそれぞれ <b>number_of_goals_each_team</b> で打ち負かしました。ホームの得点者は <b style=\'color:#3366FF\'>home_player_name_goals</b> でアウェイは <b>away_player_name_goals</b> です。'
          },
          oneTeamTakesTheLead: {
            1: 'ゴールに関しては <b style=\'color:replace_color\'>goal_scored_team_name</b> が <b style=\'color:replace_color\'>home_player_name_goals</b> が goal_scorer_word で <b style=\'color:replace_color\'>difference_number_of_goals</b> 差で相手を負かしました。'
          }
        }
      },
      step4: {
        table: {
          team: 'チーム',
          period: '期間',
          possession: 'ポゼッション',
          ppda: 'PPDA',
          xGOpenPlay: 'xG インプレー',
          tooltip: {
            team: 'チーム',
            period: '期間',
            possession: 'ポゼッション',
            ppda: '守備アクションあたりのパス数',
            xGOpenPlay: 'xG インプレー'
          }
        },
        text: {
          clearly: '明らかに',
          very: 'すごく ',
          haveGotText1: 'それを達成しただけでなく',
          haveGotText2: '以上達成するべき',
          gaveUpPoss: 'ポゼッションを放棄した。',
          lostPoss: 'ボールのポゼッションを失った。',
          too: 'また ',
          possession: {
            1: '試合のこの段階では、 <b style=\'color:team_color\'>team_name</b> clearly_text ボールのポゼッションをコントロールしていました。'
          },
          equalPossession: {
            1: '試合のこの段階では、どちらのチームもボールを持っていて非常にバランスが取れていたため、相手を圧倒していませんでしたが、数字に注目すると <b style=\'color:team_color\'>team_name</b> が <b style=\'color:team_color\'>possession_value%</b> の支配率で対戦相手をわずかに上回っていました。'
          },
          lowPossessionHighPPDA: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> はプレッシャーの悪さにより、守備のアクション時に <b style=\'color:rival_team_color\'>rival_team_name</b> に <b style=\'color:target_team_color\'>ppda_value 回のパスを与えました。</b>'
          },
          lowPossessionLowPPDA: {
            1: 'しかし <b style=\'color:target_team_color\'>target_team_name</b> は rival_team_name がボールを持っていたときにうまくプレスし、<b>ppda_value</b> の<b>PPDA</b> でした。'
          },
          highPossessionLowPPDA: {
            1: 'と rival_team_name からの very_text 低度のプレッシャーのおかげでプレーできた。'
          },
          highPossessionHighPPDA: {
            1: ' rival_team_name のプレッシャーの激しさは very_textalta でしたが'
          },
          highPossessionHighPFT: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> は、ファイナルサード</b>で <b>pft_value</b> <b> 本のパスをし高いポゼッションを獲得しました。'
          },
          highPossessionMidLowPFT: {
            1: '高いプレッシャーにもかかわらず、ファイナルサード</b>で <b style=\'color:target_team_color\'>target_team_name</b> have_got_text <b>pft_value</b> <b> 回パスとしました。'
          },
          lowPossessionHighPFT: {
            1: 'このフェーズで <b style=\'color:target_team_color\'>target_team_name</b> possession_text でしたが、ファイナルサード</b>で <b>pft_value</b> <b>回のパスを出すことができました。'
          },
          midPossessionHighPFT: {
            1: 'このフェーズのポゼッションはかなり均等でしたが、 <b style=\'color:target_team_color\'>target_team_name</b> がファイナルサード</b>で <b>pft_value</b> <b> 回のパスを作ることを妨げませんでした。'
          },
          highPFTHighTouchesIOB: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> はファイナルサードでコントロールするだけでなく、対戦相手のペナルティーエリア内でも強い存在感を示しました。'
          },
          highPFTLowTouchesIOB: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> はファイナルサードでボールをコントロールしましたが、多くのボールをペナルティーエリアに入れることはできませんでした。'
          },
          highPFTMidTouchesIOB: {
            1: 'ファイナルサード</b>での<b>パスの数を考えると、<b style=\'color:target_team_color\'>target_team_name</b> は相手ペナルティーエリアでより多くの危険を生み出す必要があります。'
          },
          lowPFTHighTouchesIOB: {
            1: ' <b style=\'color:target_team_color\'>target_team_name</b> はファイナルサードで多くのパスを完了できませんでしたが、何度も相手のペナルティーエリアに到達することができました。 '
          },
          midPFTHighTouchesIOB: {
            1: 'ファイナルサードで完了したパスの数を考えると、 <b style=\'color:target_team_color\'>target_team_name</b> は何度も相手のペナルティーエリアに到達できました。'
          },
          maxDirectness: {
            1: 'このフェーズでは <b style=\'color:max_dir_color\'>target_team_name</b> が、<b>directness_value</b> の <b>縦性 </b> でより攻撃的にプレーしたことが際立ってます。 '
          },
          maxXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> は試合の他のどのフェーズよりも多くの xG を生み出すことができました。 '
          },
          highXGFifthQuintile: {
            1: ' <b style=\'color:target_team_color\'>target_team_name</b> は多くのゴール期待値を生み出すことに成功しました。'
          },
          highXG: {
            1: '多くのゴール期待値を出しました。'
          },
          highXGLowPossession: {
            1: ' ボールをコントロールできなくても'
          },
          highXGLowShots: {
            1: '数回のシュートのみ、<b>シュートあたりのxG</b> が <b>xg_per_shot_value</b>'
          },
          highXGLowXGPerShot: {
            1: ' シュートあたりの xG は too_text 低かったのですが '
          },
          lowXGZeroXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> は対戦相手に危険をもたらすことができませんでした。'
          },
          lowXGMinXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> にとって、ゴール期待値を生み出すという点では不十分でした。'
          },
          lowXGFirstQuintileXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> は非常に少量のゴール期待値を作りました。'
          },
          lowXGSecondQuintileXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> は十分な量のゴール期待値を作れませんでした。'
          },
          lowXGHighPossession: {
            1: 'ボールはコントロールしていましたが '
          },
          lowXGHighShots: {
            1: '何発もシュートしたにも関わらず'
          },
          lowXGHighPFT: {
            1: 'ファイナルサード</b>で <b>pft_value</b> <b> パスを完了したにも関わらず'
          },
          midXGQuintileMinXG: {
            1: 'xG の数字は悪くありませんでしたが、これはその側面で <b style=\'color:target_team_color\'>target_team_name</b> の試合で最も弱い時間帯でした。'
          },
          midXGQuintileMaxXG: {
            1: 'これは、 <b style=\'color:target_team_color\'>target_team_name</b>  が最大の <b>xG (xg_value)</b> を作り出せたフェーズでした。'
          }
        }
      },
      step5: {
        table: {
          team: 'チーム',
          period: '期間',
          possession: 'ポゼッション',
          directness: '縦性',
          passesFinalThird: 'ファイナルサードでのパス',
          tooltip: {
            team: 'チーム',
            period: '期間',
            possession: 'ポゼッション',
            directness: '縦性',
            passesFinalThird: 'ファイナルサードでのパス'
          }
        },
        text: {
          last: '最後',
          goal: 'ゴール',
          goals: 'ゴール',
          chance: 'チャンス',
          chances: 'チャンス',
          first: '最初',
          homeTeam: 'ホームチーム',
          awayTeam: 'アウェイチーム',
          home: 'ホーム',
          away: 'アウェイ',
          clearly: '明らかに',
          slightly: '軽く',
          firstOrLastPhase: {
            1: 'この試合のフェーズ phase_position で',
            2: 'この試合のフェーズ phase_position に関して、'
          },
          phase: {
            1: '試合のこの区間の間'
          },
          bothZeroGoalsScored: {
            1: '両チームともスコアボードを動かすことができません。'
          },
          equalGoalsScored: {
            1: 'ゴールを決めている <b>number_goals</b>'
          },
          differentGoalsScored: {
            1: 'ゴールを決めている'
          },
          equalPossesion: {
            1: '両方のチームが正確に <b>poss_value%</b> の時間ボールを持っていました。'
          },
          morePossesion: {
            1: '<b>more_poss_team_name</b> は、対戦相手(時間の<b>less_poss_team_value%</b>)よりも多くの時間 (時間の<b>more_poss_team_value%</b>)ボールを保持していました。'
          },
          equalDirectness: {
            1: '2つのチームが同じ縦性でゲームを進めた(それぞれ<b>directness_value</b>)'
          },
          moreDirectnessSameTeam: {
            1: 'さらに、彼らは対戦相手よりも縦に早く、<b>less_dir_team_value</b> に対して、 <b>more_dir_team_value</b> の縦性を持つゲームを行っています。.'
          },
          moreDirectnessDifferentTeam: {
            1: 'しかし、<b>less_dir_team_value</b>　に対してより縦 (<b>more_dir_team_value</b>) にプレーしたのは home_away チームでした。'
          },
          equalChancesCreated: {
            1: 'ホームチームとアウェイチームの両方で同じ数のチャンスが生まれました。具体的には <b>chances_created_value</b> チャンスです。'
          },
          moreChancesCreated: {
            1: '<b>less_cc_team_name</b> は、対戦相手に adverb_text 圧倒 (<b>more_cc_team_value 回のチャンス</b>)され、 <b>less_cc_team_value 回のチャンス</b> のみを作りました。'
          },
          equalXA: {
            1: 'ホームチームとアウェイチームの両方で同じ数のチャンスが生まれました。アシスト期待値 </b> の <b>xa_value 反映されています。'
          },
          moreXA: {
            1: 'home_away は対戦相手よりも <b>diff_xa_team_value アシスト期待値</b> (<b>less_xa_team_value</b> 対して <b>more_xa_team_value</b>) 多く生み出しました。'
          },
          xAOpenPlay: {
            1: 'インプレーではそれぞれ <b>more_xa_op_value</b> と <b>less_xa_op_value</b> を生み出しています。'
          }
        }
      },
      step6: {
        text: {
          eachOne: 'それぞれが',
          respectively: 'それぞれ',
          with: ' (と一緒に <b style=\'color:replace_color\'>other_player_name</b>)',
          playerWas: '選手は',
          playerWere: '選手は',
          firstPhase: {
            1: 'この試合の序盤で際立つ部分は ',
            2: 'この試合の序盤について強調するところは'
          },
          otherPhase: {
            1: '<b style=\'color:replace_color\'>min_from\'</b> と el <b style=\'color:replace_color\'>min_to\'</b> の間に言及する必要があります。'
          },
          lastPhase: {
            1: '試合の終盤で言及することは ',
            2: 'ゲームの終盤について、引用 '
          },
          playerMaxSuccessfullPasses: {
            1: '<b style=\'color:replace_color\'>player_name</b> は、チームで成功したパスの数が最も多く、特に <b style=\'color:replace_color\'>successfull_passes_value 回のパス</b> '
          },
          playerMaxTotalPasses: {
            1: 'それはまたそうであったことを見ることでさらに価値を得ます。'
          },
          playerMaxTotalPasses2: {
            1: 'with_text 最も多くのパスを試みた選手 (<b style=\'color:replace_color\'>total_passes_value 回のパス</b>). '
          },
          playerNotMaxTotalPasses: {
            1: '最も多くのパスを試みたわけではありませんでしたが (<b style=\'color:replace_color\'>player_name</b> と <b style=\'color:replace_color\'>total_passes_value 回のパス</b>). '
          },
          playersMaxSuccessfullPassesTotalPasses: {
            1: 'この期間中にそれぞれ <b style=\'color:replace_color\'>total_passes_value 回のパス</b> を試みてます。 '
          },
          playerMaxPctPasses: {
            1: '完了したパス</b>の <b style=\'color:replace_color\'>% については、<b style=\'color:replace_color\'>player_name</b> の <b style=\'color:replace_color\'>max_pct_passes_value%</b>が高いことを強調してます。 ',
            2: 'パスの成功率に関しては、パスの有効性が <b style=\'color:replace_color\'>max_pct_passes_value%</b> の  <b style=\'color:replace_color\'>player_name</b> に言及する必要があります。'
          },
          playerSumTotalXG: {
            1: 'この間に、チームは合計 <b style=\'color:replace_color\'>sum_xg_value xG</b> を作りました。 ',
            2: 'この期間中、 <b style=\'color:replace_color\'>team_name</b> は <b style=\'color:replace_color\'>sum_xg_value</b>　の <b style=\'color:replace_color\'>xG</b> を生み出しました。 '
          },
          ZeroSumXG: {
            1: 'チーム全体で合計 <b style=\'color:replace_color\'>all_team_total_passes 回のパス</b> を作ったにもかかわらず、1つのチャンスを作ることができなかったため、無駄でした。 ',
            2: 'この期間に行われた <b style=\'color:replace_color\'>all_team_total_passes 回のパス</b> は一度もゴールチャンスを生み出せず、役に立たなかった。'
          },
          playerMaxXGMaxXADiffPlayer: {
            1: '<b style=\'color:replace_color\'>player_xg_name</b> が <b style=\'color:replace_color\'>xg_value xG</b> 、 <b style=\'color:replace_color\'>player_xa_name</b> が <b style=\'color:replace_color\'>xa_value xA</b> で、チャンス創出という点で最も優れた選手となっている。'
          },
          playerMaxXGMaxXASamePlayer: {
            1: '<b style=\'color:replace_color\'>player_name</b> は <b style=\'color:replace_color\'>xg_value xG</b> と <b style=\'color:replace_color\'>xa_value xA</b> で、チームのチャンスの大部分を生み出した人物です。'
          },
          playersMaxXGMaxXA: {
            1: 'とりわけキーパスでそれぞれ <b style=\'color:replace_color\'>xa_value xA</b> の <b style=\'color:replace_color\'>players_name</b> のおかげです。'
          },
          playerMaxXGZeroXA: {
            1: '<b style=\'color:replace_color\'>xg_value xG</b> の <b style=\'color:replace_color\'>player_xg_name</b> はチャンスのすべてを握っていました。キーパスは受け取っていなく自分でチャンスを作り出す必要がありました。'
          },
          playersMaxXGZeroXA: {
            1: '<b style=\'color:replace_color\'>xg_value xG</b> の <b style=\'color:replace_color\'>player_xg_name</b> はチャンスのすべてを握っていました。キーパスは受け取っていなく自分達でチャンスを作り出す必要がありました。'
          },
          oneMaxConnections: {
            1: '試合のこの部分で最も多くのパスを出したペアは <b style=\'color:replace_color\'>couple_name</b> で、合計 <b style=\'color:replace_color\'>connections_value 回のパス</b> を行いました。',
            2: '<b style=\'color:replace_color\'>couple_name</b> によって形成されたコンビは、 <b style=\'color:replace_color\'>connections_value</b> 回ボールを交換しました。',
            3: '<b style=\'color:replace_color\'>couple_name</b> のコンビは、この試合のこのセクションで最も多くボールをパスしており、 <b style=\'color:replace_color\'>connections_value</b> 回もパスを出しました。'
          },
          twoMaxConnections: {
            1: '<b style=\'color:replace_color\'>couple_name</b> と <b style=\'color:replace_color\'>couple_name2</b> のペアは、この期間で最も頻繁につながり、最大 <b style=\'color:replace_color\'>connections_value</b> 回ボールをパスした。'
          },
          moreThanTwoMaxConnections: {
            1: '<b style=\'color:replace_color\'>couple_name</b> などいくつかのペアが、最大 <b style=\'color:replace_color\'>connections_value 回のパス</b> を行っています。'
          },
          oneMinConnections: {
            1: '逆に、二人の間で最もパスが少なかったのは <b style=\'color:replace_color\'>couple_name</b> で、わずか <b style=\'color:replace_color\'>connections_value 回のパス</b> しかありませんでした。',
            2: 'その対極は、 <b style=\'color:replace_color\'>couple_name</b> の二人組であり、わずか <b style=\'color:replace_color\'>connections_value</b> 回のみのボールを交換でした。 '
          },
          twoMinConnections: {
            1: '一方、 <b style=\'color:replace_color\'>couple_name</b> と <b style=\'color:replace_color\'>couple_name2</b> の間でのパス交換がほとんどありませんでした。 (<b style=\'color:replace_color\'>connections_value 回のパス</b>)'
          },
          moreThanTwoMinConnections: {
            1: '十分につながっていない組み合わせがいくつかあるが、 <b style=\'color:replace_color\'>couple_name</b> のデュオの例のように、パス数が <b style=\'color:replace_color\'>connections_value 回</b> という組み合わせは平均より低いです。'
          }
        }
      },
      step7: {
        ballPossession: 'ボールポゼッション',
        gamePossessionDist: 'ボールポゼッション分布'
      }
    },
    gamePossessionMap: {
      of: 'の',
      to: 'へ',
      and: 'と',
      endsWith: '終わるのは',
      time: '時間',
      touches: 'タッチ',
      passes: 'パス',
      threat: '脅威',
      xG: 'xG',
      xT: 'xT',
      minutes: '分',
      duration: '期間',
      endsGoal: 'ゴールで終わる',
      endsInBox: 'ペナルティーエリアで終わる',
      withShot: 'シュート',
      withCross: 'センタリング',
      possession: 'ポゼッション',
      events: 'イベント',
      filters: 'フィルター',
      filtersWarning: 'チャンスは、シュートなしのポゼッションにのみ適用されます。',
      sumWarning: 'フィルターはシークエンス内のすべてのシュートのxG合計に適用されるため、1を超える場合があります',
      show: '見せる',
      sequenceNumbers: 'シーケンス番号',
      jerseyNumbers: '背番号',
      pass: 'パス',
      carryAndPass: 'ボールを運んでパス',
      carryAndAction: 'ボールを運んでアクション',
      carryAndShot: 'ボールを運んでシュート',
      shotFailed: '失敗したシュート',
      goal: 'ゴール',
      savedShot: '止められたシュート',
      missedShot: '失敗したシュート',
      shotOnPost: 'ポスト、バーに当たったシュート',
      headerGoal: 'ヘディングゴール',
      headerFailed: '外したヘディングシュート',
      failed: '外した',
      with: 'と'
    },
    report: {
      title: '試合レポート',
      maps: 'マップ',
      xGRace: 'xGレース',
      lineups: 'ラインナップ / 首発',
      button: '試合の完全なPDFレポートを作成する',
      mobileButton: 'PDFレポート',
      most: 'ほとんどの場合',
      topXPlayers: 'トップ {x} 人のプレイヤー',
      mobileButtonXY: 'XY report',
      mobileButtonPD: 'PD report',
      pDReportTitle: 'ゲーム物理データレポート'
    },
    avgScoreTooltip: '1分あたりの平均スコア',
    status: {
      scheduled: '予定されている',
      postponed: '延期した',
      cancelled: 'キャンセル',
      inPlay: 'ライブ',
      finished: '終了した',
      awarded: '受賞',
      dataAvailable: 'データは数時間以内に利用可能になります'
    },
    preGameAnalysis: {
      showExpectations: '期待を示す',
      hideExpectations: '期待を隠す',
      goalsPeriods: '目標期間',
      synergyIndex: 'シナジー指数',
      synergyIndexSubtitle: 'パサーとフィニッシャーの接続の全体的な強度'
    }
  },
  general: {
    1: '1',
    2: '2',
    3: '3',
    4: '4',
    5: '5',
    8: '左',
    9: '両方',
    10: '右',
    create: '作る',
    save: '保存する',
    cancel: 'キャンセルする',
    delete: '消す',
    edit: 'エディットする',
    reset: 'リセット',
    go: '進む',
    formErrors: {
      required: '必須項目です',
      passwordMatch: 'パスワードが一致しません',
      minLength: '最小文字数に達していません',
      maxLength: '最大長',
      emailValid: '有効なメールアドレスでなければなりません',
      youthAge: '年齢は10歳から23歳の間である必要があります',
      seasonYear: '年は2016年から2050年の間である必要があります',
      integer: '小数は使用できません'
    },
    confirmationTitle: '本気に良いですか？',
    confirmationMessage: 'アクションを実行するかどうかを確認します',
    yes: 'はい',
    no: 'いいえ',
    search: '探す',
    clearFilters: 'フィルターをクリアする',
    minimum: '最小',
    maximum: '最高',
    minimumPercent: 'パーセンテージ (%) 最小',
    period: '期間',
    exclude: '除外する',
    team: 'チーム',
    clear: 'クリア',
    all: '全て',
    ground1: '全試合',
    ground2: 'ホーム',
    ground3: 'アウェイ',
    filter: 'フィルター',
    noData: '結果が見つかりません',
    noDataGivenFilters: '選択したフィルターの結果は見つかりませんでした。',
    similarityMinutesWarning: '450分未満のプレイのためデータがありません',
    templateOnlyEditable: 'テンプレートは次のユーザーのみ編集可能 ',
    close: '閉じる',
    load: 'ロード',
    filters: 'フィルター',
    players: '選手',
    teams: 'チーム',
    compare: '比較する',
    seeMore: 'もっと見る',
    seeLess: '隠す',
    request: '要求する',
    notes: 'メモ',
    closeSession: 'セッションを閉じる',
    settings: '各種設定',
    player: '選手',
    state: '状態',
    updated: '更新済',
    file: 'ファイル',
    uploadFile: 'ファイルをアップロードする',
    reports: 'レポート',
    download: 'ダウンロードする',
    new: '新しい',
    comparison: '比較',
    scout: 'スカウト',
    favorites: 'お気に入り',
    moreOptions: 'より多くのオプション',
    lessOptions: '少ないオプション',
    today: '今日',
    home: 'ホーム',
    away: 'アウェイ',
    until: 'まで',
    firstHalf: '前半',
    secondHalf: '後半',
    firstPeriodOT: '延長前半',
    secondPeriodOT: '延長後半',
    postponed: '延期',
    stats: 'スタッツ',
    yesterday: '昨日',
    last: '最後',
    startDate: '開始日',
    active: '活動中',
    playerLimit: 'プレーヤー制限',
    type: 'タイプ',
    successMessage: 'オペレーションは正常に実行されました。',
    failMessage: 'オペレーションは失敗しました。',
    by: 'によって',
    checkYourInbox: 'あなたのメールをチェックしてください。',
    faq: '書類',
    globalSearch: 'グローバル検索',
    gamesLost: '負けた試合',
    outOf: 'から',
    avgSeason: 'シーズン平均',
    leftDays: '残り日数',
    notifyError: 'エラーを報告する',
    notify: '報告する',
    comments: 'コメント',
    searches: '検索',
    now: '今',
    twoHoursAgo: '2時間前',
    incomings: '到着',
    departures: '出発',
    transferLoans: 'ローン',
    transfers: '移籍',
    movements: '移動',
    incomes: '収入',
    expenditures: '支出',
    action: '活動',
    target: 'ターゲット',
    uses: '使用',
    users: 'ユーザー',
    since: 'から',
    mediaMode: 'メディアモード',
    white: '白',
    enabled: '始動した',
    disabled: '機能を無効にした',
    left: '左',
    right: '右',
    both: '両方',
    'left-both': '左両方',
    'right-both': '右両方',
    'left foot': '左',
    'right foot': '右',
    files: 'ファイル',
    confirm: '決定する',
    currentStep: '現在のステップ',
    phases: 'フェーズ',
    entries: '受信',
    none: 'なし',
    times: '回',
    darkMode: 'ダークモード',
    client: '顧客',
    visits: 'ビジター',
    lastVisit: '最後の訪問',
    strong: '強い',
    medium: '普通',
    weak: '弱い',
    goal: 'ゴール',
    list: 'リスト',
    map: 'マップ',
    copiedToClipboard: 'クリップボードにコピーしました。',
    division: 'ディビジョン',
    many: '多くの',
    few: '少しの',
    median: '中間の',
    topRight: '上　右',
    topLeft: '上　左',
    bottomRight: '下　右',
    bottomLeft: '下　左',
    library: '図書館',
    mediaLibrary: 'メディア図書館',
    for: '間',
    stat: 'スタッツ',
    position: 'ポジション',
    order: '命令',
    add: '追加',
    visualization: '表示',
    basic: '基本',
    selectAll: 'すべて選ぶ',
    unselectAll: '全て選択を外す',
    distribution: '配給',
    end: '終了',
    accuracy: '正確さ',
    opponent: '相手',
    ownTeam: '自チーム',
    center: 'センター',
    line: 'ライン',
    live: 'ライブ',
    unavailable: '利用不可',
    calendar: 'カレンダー',
    activeLeague: '活動中リーグ (進行中)',
    similarity: '類似',
    emptyForSelectAll: '空のすべてを選択',
    size: 'サイズ',
    selectPlayersRestriction: '1 人から {x} 人の選手を選択',
    group: 'グループ',
    alerts: '通知',
    shortcuts: 'ショートカット',
    share: 'シェア',
    dataAvailable: 'データは近日公開予定',
    someStatsAvailableSoon: 'いくつかの統計がまもなく利用可能になります',
    monthGamesWarning: '今月の厳選ゲームは近日公開予定',
    metrics: '指標',
    competition: 'Competition',
    code: 'Code',
    alias: 'Alias',
    never: 'なし',
    unlimited: '無制限',
    user: 'ユーザー',
    warning: '警告',
    requests: 'リクエスト',
    contactSales: '営業部へのお問い合わせ',
    comingSoon: 'もうすぐ',
    firstPost: '最初の投稿',
    secondPost: '2回目の投稿',
    dZone: 'Dゾーン',
    penaltySpot: 'ペナルティスポット',
    secondPlay: '2回目のプレイ',
    otherZone: 'その他のゾーン',
    baseline: 'ベースライン',
    youth: 'Youth',
    male: 'Male',
    direct: '直接',
    indirect: '間接的',
    processing: 'Processing',
    addNew: '新規追加',
    createdBy: '作成者',
    downloading: 'Downloading',
    displayType: 'プレゼンテーションタイプ',
    alreadyExists: 'すでに存在する',
    aggregation: 'Aggregation',
    unavailableLeagues: 'あなたは、その選手がプレーしたどのリーグにもアクセスできません',
    meters: 'Meters',
    quantity: '数量',
    allTime: 'All Times',
    games: 'Games',
    unit: '単位',
    categories: 'カテゴリー',
    maintenanceWarning: 'メンテナンス中',
    maintenanceMessage: 'ただいま更新作業を行っています。現在行った変更は保存されません。ご理解ありがとうございます。',
    seeAll: 'すべて見る',
    from: 'から',
    to: 'へ',
    showFilters: 'フィルターを表示',
    hideFilters: 'フィルターを非表示',
    horizontal: '水平',
    vertical: '垂直',
    drop: '落とす',
    orientation: '向き',
    goalProbability: 'ゴールの確率',
    assistProbability: 'アシスト確率',
    attackingDirection: '攻撃方向',
    currentTeam: '現在のチーム',
    expectations: '期待',
    sideBySide: '並んで',
    teamValue: 'チームの価値',
    fieldLayout: 'フィールドのレイアウト',
    searchPlaceholder: 'Type {x} letters at least to search',
    crests: 'クレスト',
    pcts: 'PCT'
  },
  playerScout: {
    dlabDatabase: 'driblab データベース',
    league: 'リーグ',
    top5: 'トップ 5',
    topCountries: '国',
    tier: 'レベル',
    division1: '1部',
    division2: '2部',
    division3: '3部',
    division4: '4部',
    division5: '5部',
    division6: '第6師団',
    summary: '要約',
    offensive: '攻撃的',
    defensive: '守備的',
    gk: 'GK',
    all: '全て',
    physical: 'フィジカル',
    arrigo: 'アリゴ',
    yearTooltip: '1年間のみ',
    expectedThreat: '脅威期待値',
    expectedThreatTooltip: 'すべてのポゼッションに追加脅威',
    expectedThreatOP: '脅威期待値 OP',
    expectedThreatOPTooltip: 'すべてのインプレーのポゼッションに追加脅威',
    expectedThreatInTeam: 'チームでの脅威期待値　％',
    expectedThreatInTeamTooltip: 'チームでの追加脅威の割合',
    ballProgression: 'ボールの進行',
    ballProgressionTooltip: '10メートル以上の進行',
    deepProgression: '深さ',
    deepProgressionTooltip: 'ピッチ最後の5分の1までのボールの進行',
    ballRetention: 'ボールの保持　%',
    ballRetentionTooltip: 'ボールを保持し、最終的にボールを失うことのなかった回数の割合',
    ballRetentionOppHalf: 'ボールの保持　% CC',
    ballRetentionOppHalfExplicit: 'ボールを保持し、相手のフィールド内で失われなかった回数の割合',
    finishing: 'フィニッシュ',
    finishingTooltip: 'ゴールで終わるシュートの割合',
    scoringContribution: '得点への貢献',
    scoringContributionTooltip: 'アシスト + ゴール',
    xgPerShot: 'シュート毎の xG',
    xgPerGoal: 'ゴール毎の xG ',
    headerPerCross: 'センタリングからのヘッド',
    completedCrosses: '成功したセンタリング',
    crossingPct: 'センタリング %',
    crossingEfficiency: 'センタリング有効性',
    crossingEfficiencyTooltip: 'センタリングの有効性 (質と量を測る)',
    longBalls: 'ロングパス',
    longPassing: 'ロングパス %',
    dribblingPct: 'ドリブル（抜く） %',
    throughBalls: 'スペースにパス',
    oppBoxTouches: '相手ペナルティーエリアでタッチ',
    oppBoxTouchesTooltip: '相手エリアでタッチ',
    openPlayKeyPasses: 'インプレーでのキーパス',
    openPlayKeyPassesTooltip: 'インプレーでのシュートに繋がったパス',
    xGBuildup: '組み立て xG',
    xGBuildupTooltip: '選手が参加したシュートで終わった一連のプレーの xG (シュートとパスの xG を除く)',
    Assists: 'アシスト',
    passPercentage: 'パスの %',
    passPerLongBall: 'ロングボール毎のパス',
    passPerLongBallExplicit: '各ロングボール毎のパス',
    nonPenaltyGoals: 'PKを除くゴール',
    xG: 'xG',
    xGExplicit: 'ゴール期待値',
    shots: 'シュート',
    xGShot: 'シュート毎の xG ',
    xGChain: 'xG 関与',
    xGChainTooltip: '選手が参加したシュートで終わった一連のプレーに関与した選手の xG',
    chancesCreated: '作ったチャンス',
    chances: 'チャンス',
    dribbles: 'ドリブル（抜く）',
    dribblesSuccessfull: '成功したドリブル（抜く）',
    touches: '相手ペナルティーエリアでタッチ数',
    xA: 'xA',
    xAExplicit: 'アシスト期待値',
    xAOpenPlay: 'xA OP',
    xAOpenPlayExplicit: 'インプレーでのアシスト期待値',
    passesOpponentBox: '相手ペナルティーエリアでのパス',
    passesOB: '相手ペナルティーエリアでのパス',
    passesFinalThirdTooltip: 'ピッチ最後の ⅓ でのパス',
    passesSuccessful: '成功したパス',
    passesSuccessfulTooltip: '成功したパス',
    ballProgressionPassing: 'パスによるボール進行',
    ballProgressionPassingTooltip: 'パスによるボール進行',
    ballProgressionDribbling: 'ドリブルによるボール進行',
    ballProgressionDribblingTooltip: 'ドリブルによるボール進行',
    passesTotal: 'パス',
    passesTotalTooltip: '出されたパスの総数',
    shortPassesSuccessful: '成功したショートパス',
    shortPassesSuccessfulTooltip: '成功したショートパス',
    shortPassesTotal: 'ショートパス',
    shortPassesTotalTooltip: '出されたショートパスの総数',
    tackles: 'タックル *',
    adjustedTackles: '成功したタックル',
    interceptions: 'インターセプト *',
    adjustedInterceptions: '成功したインターセプト',
    aerials: '空中戦',
    aerialsPercent: '空中戦 %',
    aerialEfficiency: '空中戦有効性',
    aerialEfficiencyTooltip: '空中戦有効性  (質と量を測る)',
    twd: 'タックル / 奪われた',
    tacklesWasDribbled: '守備1v1勝利数',
    fouls: 'ファール',
    indPressure: '個人のプレッシャー',
    pressure: 'プレッシャー',
    dispossessed: 'ボールロスト',
    recoveries: 'ボール奪取',
    primary: 'メインポジション',
    secondary: 'セカンドポジション',
    position: 'ポジション',
    nationality: '国籍',
    height: '身長(cm)',
    minHeight: '最低身長',
    maxHeight: '最高身長',
    age: '年齢',
    minAge: '最低年齢',
    maxAge: '最高年齢',
    games: '試合',
    minGames: '最低試合',
    maxGames: '最高試合',
    minutes: '時間',
    minMinutes: '最低時間',
    maxMinutes: '最高時間',
    minPercentMinutes: '最低時間の割合',
    dates: '日付',
    marketValue: '価値 (€)',
    teams: 'チーム',
    contractEnd: '契約終了',
    minValue: '最低価値',
    maxValue: '最価値',
    excludeTeams: 'チームを除外',
    recentSearches: '最後の検索',
    saveSearch: '検索を保存',
    loadSearch: '検索を読み込む',
    loadCollection: 'コレクションを読み込む',
    collection: 'コレクション',
    search: '検索',
    searchesList: '検索リスト',
    mySearches: '検索結果',
    mySearchesDescription: '以前に保存したもの',
    recentSearchesDescription: '最近実行した 10 件の検索',
    searchToLoad: '検索を読み込む',
    recentSearch: '最近の検索',
    saveSearchSuccess: '検索が正常に保存されました',
    removeSearch: '検索を削除',
    removeSearchMessage: '検索を削除してもよろしいですか?',
    updateSearch: '検索を更新する',
    updateSearchMessage: '検索を更新してもよろしいですか?',
    deleteSearchSuccess: '検索が正常に削除されました。',
    playersFound: '見つかった選手',
    addToCollection: 'コレクションに追加',
    npg: 'ペナルティ抜きのゴール',
    goals: 'ゴール',
    value: '価値',
    nationalTeams: '代表',
    gbeScore: 'GBE',
    dlIndex: 'スコア',
    minGbe: 'GBE min.',
    goalsConceded: '被ゴール',
    npgConceded: 'ペナルティ抜きの被ゴール',
    npgConcededTooltip: 'PKなしの失点',
    xGOTConceded: '被枠内シュートの xG ',
    xGOTConcededTooltip: '被枠内シュートの xG ',
    goalsPrevented: '回避されたゴール',
    xGFacedPerShotOnTarget: '枠内シュート毎 xG',
    xGFacedPerShotOnTargetTooltip: 'シュートごとの被 xG ',
    xGSavedPerxGFacedOnTarget: 'セーブ xG',
    xGSavedPerxGFacedOnTargetTooltip: 'xG を考慮したセーブ率',
    savesPct: 'セーブ%',
    savesOutOfBoxPct: 'ペナルティーエリア外からのセーブ%',
    savesInBoxPct: 'ペナルティーエリア内からのセーブ%',
    xGFacedPerGoal: '1ゴールあたりの被 xG ',
    xGFacedPerGoalTooltip: '1ゴールを決めるために必要な xG ',
    catchingPct: 'キャッチング%',
    catchingTooltip: 'ボールキャッチの割合',
    passingOwnHalfPct: '自陣でのパス%',
    passingOwnHalfPctTooltip: '自陣でのパス成功率',
    passingOppHalfPct: '敵陣でのパス %',
    passingOppHalfPctTooltip: '敵陣でのパス成功率',
    passingContribution: 'パスの貢献 %',
    passingContributionTooltip: 'パスを使って脅威になるプレーをする貢献度は平均以上。',
    shotsPerGoal: '1ゴールあたりのシュート数',
    passesFinalThird: 'ファイナルサードパス',
    passingFinalThird: 'ファイナルサードパス %',
    claimAccuracy: 'センタリングの精度',
    claimAccuracyTooltip: 'キャッチされたセンタリングは平均以上',
    highTurnovers: '危険なボールロスト',
    highTurnoversTooltip: 'ゴールから40メートルでのボールロスト',
    shotEndingHighTurnovers: 'PP とシュート',
    shotEndingHighTurnoversTooltip: 'シュートで終わった危険なボールロスト',
    goalEndingHighTurnovers: 'PP とゴール',
    goalEndingHighTurnoversTooltip: 'ゴールで終わった危険なボールロスト',
    avgCarriesProgress: 'ボール前進平均',
    avgCarriesProgressTooltip: 'ゴールに向かってボールを運んだ平均距離（メートル）',
    carriesChance: 'ボール運びとチャンス',
    carriesChanceTooltip: 'ボール運んでキーパス',
    carriesAssist: 'ボール運びとアシスト',
    carriesAssistTooltip: 'ボール運んでアシスト',
    carriesShot: 'ボールを運んでシュート',
    carriesShotTooltip: 'ボールを運んで続けてシュート',
    carriesGoal: 'ボールを運んでゴール',
    carriesGoalTooltip: 'ボールを運んでゴール',
    shotEndingSequence: 'シュートで終わる',
    shotEndingSequenceTooltip: '選手が参加したシュートで終わった一連のプレー',
    goalEndingSequence: 'ゴールで終わる',
    goalEndingSequenceTooltip: '選手が参加したゴールで終わった一連のプレー',
    gbeScoreTooltip: 'FA Football\'s Governing Body Endorsement',
    goalsPreventedTooltip: 'ゴールキーパーがセーブしたゴール (ペナルティを除く) (被 xG  - ペナルティ抜きの被ゴール )',
    freePlayers: 'フリーな選手',
    index: '指標',
    playerName: '名前',
    teamName: 'チーム',
    secondPos: '中等教育後',
    side: 'サイド',
    onlyOnLoan: 'レンタルのみ',
    dob: '生年月日',
    countryName: '国',
    secondCountryName: '2つ目の国',
    seasonYear: 'シーズン',
    assists: 'アシスト',
    placeholder: '画面を表示するには検索したい条件を選んでください',
    placeholder2: '検索ボタンをクリックすると結果が表示されます。',
    passesPct: 'パスの %',
    passingPct: 'パスの %',
    oppBoxPasses: '敵ペナルティーエリアでのパス',
    adjustedClearances: '正確なクリア',
    aerialsPct: '空中戦 %',
    leagueCountryCode: 'リーグの国コード',
    shooting: '枠内シュートの%',
    xtPassing: 'xT パス',
    xtPassingTooltip: 'パスにより脅威を追加',
    xtDribbling: 'ボール運び xT ',
    xtDribblingTooltip: 'ボール運びにより脅威を追加',
    foot: '利き足',
    aggressiveActions: '攻撃的なアクション',
    aggressiveActionsTooltip: 'ボールを失ってから2秒以内に行われたタックル',
    tacklesAttempted: '行われたタックル',
    highDefensiveActionPct: '高い位置でのディフェンシブアクション %',
    highDefensiveActionPctTooltip: '自身のゴールラインから40mを超える位置での防御アクション（タックル、インターセプト、ブロック、ファウル、及び1対1）の合計の割合',
    individualPressureOppHalf: '相手へのプレッシャー',
    individualPressureOppHalfTooltip: '選手が相手陣内でのプレッシングで成功した回数を数値化',
    xGBuildUp5Pass: '組み立て　5パス xG ',
    xGBuildUp5PassTooltip: '最後の5パスでの組み立て xG (シュートとシュートに至るパスを除く)',
    chancesCreatedOpenPlay: 'インプレーで生まれたチャンス',
    chancesCreatedOpenPlayTooltip: 'シュートで終わるインプレーのパスの数',
    fmf: {
      Defender: 'ディフェンス',
      aerial: '空中戦',
      goodDefender: '良いディフェンス',
      goodPresence: '存在感のある',
      playmaking: '創造性',
      Fullback: 'サイドバック',
      defensiveness: '守備',
      offensiveness: '攻撃',
      fast: '速さ',
      Forward: 'フォワード',
      goalChances: 'ゴールチャンス',
      goodDecissions: '良い決断',
      individualTechnique: 'テクニック',
      Goalkeeper: 'ゴールキーパー',
      footWork: 'フットワーク',
      leadership: 'リーダーシップ',
      Midfielder: '守備的ミッドフィールダー',
      balance: 'バランス',
      ballRetention: 'ボール保持力 %',
      offensivePasses: '攻撃的パス',
      recoveries: 'ボール奪取',
      shotToGoal: '枠内シュート',
      'Attacking-Midfielder': 'トップ下',
      defensiveGame: '守備的ゲーム',
      offensiveGame: '攻撃ゲーム',
      Winger: 'ウインガー',
      crossing: 'センタリング',
      deepProgressions: '進行',
      defendingEffort: '守備面での頑張り',
      facing: '対峙'
    },
    yellowCards: 'イエローカード',
    redCards: 'レッドカード',
    alert: '通知',
    yearOfBirth: '生年',
    minYearOfBirth: '最小生年',
    maxYearOfBirth: '最高生年',
    women: '女子',
    continental: 'コンチネンタル',
    countryCup: '国内カップ',
    statsName: '統計名',
    abbreviation: '略語',
    abbr: {
      position: 'POS',
      secondPos: 'SP',
      seasonYear: 'SY',
      marketValue: 'MV(€)',
      contractEnd: 'CE',
      height: 'H(cm)',
      side: 'SD',
      strongFoot: 'SF',
      games: 'G'
    },
    warningRegularSeason: '最後にプレーされたレギュラー シーズンのみを表示',
    gamesWith60PlusMinsTooltip: '60分を超える最低試合数',
    starts: '始まります',
    minGPI: 'Min. GPI',
    maxGPI: 'Max. GPI',
    tertiary: 'Tertiary'
  },
  playerComparison: {
    upTo5Players: '最大5人の選手を比較',
    requestReport: 'レポートを依頼する',
    searchBarPlaceholder: '選手またはチームを検索',
    allStats: 'すべての統計',
    placeholder: 'プレーヤーを追加することから始めることができます'
  },
  reports: {
    detailedInsights: '詳細情報を取得する',
    features: 'レポート内容',
    performance: 'パフォーマンス',
    evolution: '進化',
    compareWithMyTeam: '自分のチームと比較',
    similarPlayers: '似た選手',
    potentialTeams: 'ポテンシャルのあるチーム',
    requestSuccess: 'リクエストが正常に送信されました',
    requestAt: '申請済',
    reportConversation: '報告の会話',
    writeYourMessage: 'メッセージを書いてください',
    you: 'あなた'
  },
  state: {
    requested: '申請済',
    inProgress: '進行中',
    delivered: '届け済'
  },
  langs: {
    es: 'スペイン語',
    en: '英語',
    fr: 'フランス語',
    de: 'ドイツ語',
    it: 'イタリア語',
    pt: 'ポルトガル語',
    tr: 'トルコ語',
    jp: '日本語',
    cn: '中国語',
    sa: 'アラブ語',
    nl: 'オランダ語',
    pl: 'ポーランド語',
    sv: 'スウェーデン語',
    cs: 'チェコ語',
    ko: '韓国語',
    hu: 'ハンガリー語',
    ru: 'ロシア語'
  },
  langsArea: {
    europe: 'ヨーロッパ',
    asia: 'アジア',
    arabic: 'アラビア語'
  },
  inbox: {
    subtitle: '最新の状態に保つ',
    new_injury_alert: '怪我の新たな通知',
    new_contract_alert: '契約の新たな通知',
    new_team_alert: '新規署名アラート',
    new_marketValue_alert: '市場価格の新たな通知',
    new_game_alert: '新しいゲームプレイのアラート',
    receive_mail: 'メールを受信',
    receive_mail_subtitle: 'フィルターを満たすプレーヤーからの電子メールを毎日受信します',
    receive_notifications: '通知',
    receive_notifications_subtitle: 'フィルターを通過した選手の通知をアプリケーションで受け取る',
    changedTo: 'に変える',
    alerts: '通知',
    includedIn: 'に含まれる',
    noContract: '契約なし',
    newMessages: '新しいメッセージ',
    reply: {
      reply: 'Reply',
      replyTitle: 'Give feedback to the client:',
      replyPlaceholder: 'The user will receive the reply along with the status update'
    }
  },
  gameAnalysis: {
    subtitle: '最近の試合を掘り下げる',
    subtitle2: '次の7日間の試合を表示',
    subtitle3: '最新の試合から洞察を得て、次の試合を探る',
    seeDetail: '詳細を見る'
  },
  statsNaming: {
    Possession: 'ポゼッション',
    TimePossession: 'ボール支配時間',
    PassesPerShots: 'シュート毎のパス',
    PPDA: 'ピーピーディーエー',
    ExpectedPoints: 'ポイント期待値',
    Points: 'ポイント',
    Directness: '縦性',
    PassesPerLongBall: 'ロングボールごとのパス',
    CrossingPerXG: ' xG 毎のセンタリング',
    PenaltySavedPenaltyFaced: 'PKセーブ / 被PK',
    Goals: 'ゴール',
    PenaltyShots: 'PK数',
    PenaltyGoals: 'PKゴール',
    NonPenaltyGoals: 'PKを除くゴール',
    NPGOpenPlay: 'インプレーでのPKを除くゴール',
    NPGSetPiece: 'セットプレーでのPKを除くゴール',
    Shooting: '枠内シュート % ',
    Finishing: '仕上げ',
    xGEfficiency: 'xG 有効性',
    HeaderPerShot: 'シュートあたりのヘディングシュート',
    HeaderPerCross: 'センタリングあたりのヘディングシュート',
    HeadedGoals: '目指した目標',
    GoalsConceded: '失点数',
    SavesInBox: 'ボックスに保存',
    SavesOutBox: 'すぐに使える保存機能',
    Assists: 'アシスト',
    ThroughBalls: 'スルーパス',
    CrossEfficiency: 'センタリング有効性',
    ScoringContribution: '得点への貢献',
    xAssistsOpenPlay: 'インプレーでの xA ',
    xAssistsSetPiece: 'セットプレーでの xA ',
    xAssistsOpenPlayInTeam: 'インプレーでの チーム内 xA ',
    xAssistsSetPieceInTeam: 'セットプレーでの チーム内 xA ',
    xGBuildupFinalThird: 'ファイナルサードでの組み立て xG ',
    xGChainFinalThird: 'ファイナルサードでの関与 xG ',
    BallProgressionPassing: 'パスによるボール進行',
    BallProgressionDribbling: 'ドリブルによるボール進行',
    TacklesWasDribbled: 'タックル/ドリブルで抜かれた',
    TacklesSuccessful: '成功したタックル',
    Interceptions: 'インターセプト',
    Clearances: 'クリア',
    Fouls: 'ファール',
    Recoveries: 'ボール奪取',
    Shots: 'シュート',
    ShotsPerGoal: 'ゴール毎のシュート',
    ShortPassesSuccessful: '成功したショートパス',
    PassingSuccessForwardPct: '成功した前へのパス % ',
    PassingSuccessBackwardPct: '成功した後ろへのパス % ',
    PassingForwardBackwardPct: 'バックパスあたりの前へのパス %',
    LongBallPerPassesPct: '成功したパスごとのロングパスの % ',
    LongBallReceived: '受けたロングパス',
    LongBallReceivedOppHalf: '敵陣で受けたロングパス',
    OffensiveActions: '攻撃的なアクション',
    DribblesAttempted: '抜くドリブル数',
    SuccessfulDribblesPct: ' ドリブル成功 %',
    OffensiveTouchesOutBoxPct: 'ペナルティーエリア外での攻撃的なタッチ% ',
    BallRetention: 'ボール保持力 % ',
    PassingPct: 'パス % ',
    PassingOwnHalfPct: '自陣でのパス % ',
    PassingOppHalfPct: '敵陣でのパス % ',
    PassingFinalThird: 'ファイナルサードでのパス ',
    PassesFinalThirdTotal: '総パス数 決勝 1/3',
    PassingFinalThirdPct: 'ファイナルサードでのパス % ',
    LongBallSuccessful: 'ロングパス',
    LongBallPct: 'ロングパス % ',
    LongBallTotal: 'ロングボール総数',
    SavesPct: 'セーブ % ',
    SavesInBoxPct: 'ペナルティーエリア内でのセーブ % ',
    SavesOutOfBoxPct: 'ペナルティーエリア外でのセーブ% ',
    xGSavedPerXGFacedOnTarget: 'セーブ xG /被 xG ',
    xGFacedOnTargetPerGoalReceived: '1ゴールごとの被 xG ',
    xGFacedOnTargetEfficiency: '回避されたゴール',
    xGFacedOnTarget: '被 xG ',
    IndividualPressure: '個人でのプレッシャー',
    AerialEfficiency: '空中戦有効性',
    AerialWins: '空中戦勝利',
    AerialWinsPct: '空中戦勝利 % ',
    xG: 'ゴール期待値',
    xGDiff: 'xG 差',
    xGOpenPlay: 'xG インプレー',
    xGSetPiece: 'セットプレー xG ',
    xGPerShot: 'シュート毎の xG ',
    ChancesCreated: 'ゴールチャンスを演出',
    CompletedCrosses: '成功したセンタリング',
    Crossing: '成功したセンタリング % ',
    OpenPlayKeyPasses: 'インプレーでのキーパス',
    OpenPlayKeyPassesInTeam: 'オープンプレーでのキーパス',
    OpenPlayPassesIntoOpponentBox: 'インプレーでの相手のペナルティーエリア内でのパス',
    OpenPlayPassesIntoOpponentBoxSuccessful: 'インプレーでの相手のペナルティーエリア内でのパス',
    xAssists: 'アシスト期待値',
    xGChain: ' xG　関与',
    xGBuildup: 'ビルドアップ xG',
    xGBuildupInTeam: 'ビルドアップ in Team',
    BallProgression: 'ボールの進行',
    SuccessfulDribbles: 'ドリブル成功',
    Dispossessed: '奪われた',
    TouchesInOpponentBox: '相手ペナルティーエリア内のタッチ',
    xGSavedPerShot: 'シュート毎のセーブ xG ',
    BallRetentionOppHalf: '敵陣でのボール保持 % ',
    DeepProgression: '深さ',
    DeepProgressionFinalThird: 'ファイナルサードでの深さ',
    FoulsTaken: '被ファール',
    PenaltiesTaken: '被PK',
    BlockedCrosses: 'センタリングのインターセプション',
    BlockedShots: 'シュートのインターセプション',
    Blocks: 'ブロック',
    NonPenaltyGoalsAgainst: 'PKなしの被ゴール',
    Headers: 'ヘディングシュート',
    AveragePassDistance: '中距離パス',
    ProgressiveRuns: '前進的なボール運び',
    xT: '脅威期待値 (xT)',
    xTOpenPlay: 'インプレー xT ',
    xTSetPiece: 'セットプレー xT',
    xGOT: '枠内シュートのゴール期待値',
    BadActions: '悪い行為',
    BadActionsOwnHalf: '自陣でのボールロスト',
    AerialsWonOwnBox: '自分のペナルティーエリア内での空中戦勝利',
    AerialsWonOppBox: '敵ペナルティーエリア内での空中戦勝利',
    AerialsTotalOppBox: '自分のペナルティーエリア内での空中戦合計',
    AerialsTotalOwnBox: '敵ペナルティーエリア内での空中戦合計',
    FoulsOwnHalfPct: '自陣でのファウル %',
    RecoveriesOppHalf: '敵陣でのボール奪取',
    DuelsPct: 'デュエル成功 %',
    TacklesUnsuccessful: '失敗したタックル',
    TacklesWasDribbledFirstThird: 'タックル/ドリブルで抜かれた　ファーストサード',
    TacklesWasDribbledSecondThird: '守備1v1勝利数 ⅔',
    TacklesWasDribbledFinalThird: '守備1v1勝利数 終わり ⅓',
    BallProgressionFinalThird: 'ファイナルサードでのボールの前進',
    DuelsTotal: 'デュエル数',
    QuickRecoveries: '素早いボール奪取',
    ShotsPerNPG: 'ゴール毎のシュート、PK抜き',
    ShotsOutBox: 'ペナルティーエリア外からのシュート',
    GoalsOutBox: 'ペナルティーエリア外からのゴール',
    ShootingOutBox: 'ペナルティーエリア外からの枠外シュート %',
    HandPassing: '手でのパス %',
    Catching: 'キャッチング %',
    Caught: 'キャッチセーブ',
    ClaimAccuracy: 'センタリングの精度',
    HighTurnovers: '危険なボールロスト',
    ShotEndingHighTurnovers: 'シュートに繋がった危険なボールロスト',
    GoalEndingHighTurnovers: 'ゴールに繋がった危険なボールロスト',
    AverageCarriesProgress: '平均前進ドリブル',
    ChanceEndingCarries: 'ボールを運んでチャンス演出',
    AssistEndingCarries: 'ボールを運んでアシスト',
    ShotEndingCarries: 'ボールを運んでシュート',
    GoalEndingCarries: 'ボールを運んでゴール',
    ShotEndingSequence: '一連の流れをシュートで終える',
    GoalEndingSequence: '一連の流れをゴールで終える',
    xGPerNPG: 'PK抜きのゴール毎の xG',
    AerialWonOffensive: '攻撃的な空中戦勝利',
    AerialWonDefensive: '守備的な空中戦勝利',
    xGAgainst: '被 xG ',
    xGDiffAgainst: 'xG 差分失点',
    xGPerNPGAgainst: 'PK抜きの被ゴール毎の xG ',
    xGSetPieceAgainst: 'セットプレー被 xG ',
    xGOpenPlayAgainst: 'xG オープンプレーで失点',
    xGPerShotAgainst: 'シュート毎の被 xG ',
    ShotsAgainst: '被シュート',
    ShotsOnTargetAgainst: '被枠内シュート',
    ShotsOnTargetInBoxAgainst: 'ボックス内の枠内シュート数の失点',
    ShotsOnTargetOutBoxAgainst: '枠外シュート数 失点数',
    RivalPossession: '相手のポゼッション',
    AerialDefensivePct: 'ディフェンス空中戦勝率 %',
    HighRecoveries: '高い位置での奪取',
    HighDefensiveActions: '高い守備的アクション位置',
    HighDefensiveActionPct: '高い守備的アクション位置 %',
    HighDefensiveDistance: '守備の高さの距離',
    PassesPerPossession: 'ポゼッション毎のパス',
    LengthPerPossession: 'ポゼッション毎の距離',
    xTNet: 'xT 正味',
    AvgCarriesDistance: '平均ドリブル距離',
    PassesForwardPct: '前へのパス %',
    PassesForwardSuccessful: '成功したフォワードパス',
    PassesForwardTotal: '合計フォワードパス数',
    TacklesAttempted: 'タックル数',
    DuelsLost: '負けたデュエル',
    Carries: '運ぶドリブル',
    CarriesPct: '運ぶドリブル %',
    Aerials: '空中戦',
    ProgressivePassesReceivedIntoBox: 'ペナルティーエリアで受けた前へのパス',
    PassesOppHalf: '敵陣へのパス',
    ShotsOnTarget: '枠内シュート',
    AggressiveActions: '攻撃的なアクション',
    Crosses: 'センタリング',
    xGBuildup5pass: 'ビルドアップ xG 5パス',
    SpeedSequence: 'ポゼッション時のボール移動速度',
    Touches: 'タッチ',
    AerialsTotalOppHalf: '敵陣での空中戦合計',
    AerialsWonOppHalf: 'エアリアルで優勝半分',
    AerialsWonOppHalfPct: '敵陣での空中戦勝利 %',
    AerialsPctOppBox: '相手ペナルティーエリアでの空中戦勝利 %',
    AerialsPctOwnBox: '自陣ペナルティーエリアでの空中戦勝利 %',
    AerialDefensive: 'エアリアル・ディフェンス',
    AerialOffensive: 'エアリアル・オフェンス',
    AerialOffensivePct: '空中攻撃',
    IndividualPressureOppHalf: '相手へのプレッシャー',
    ChancesCreatedOP: 'インプレーで生まれたチャンス',
    TouchesPerShot: 'シュート毎のタッチ',
    PassesFinalThirdTotalPct: 'ファイナルサードでのパス %',
    xACrosses: 'センタリングの xA ',
    Passes: 'パス',
    PassesSuccessful: '成功したパス',
    TacklesWasDribbledFouls: '地上でのデュエル %',
    OffsidesCaught: 'オフサイド',
    ProgressivePassesReceivedFinalThird: 'ファイナルサードで受け取った前向きのパス',
    ProgressivePassesReceived: '受け取った前向きのパス',
    Breadth: 'Amplitud',
    DuelsDefTotal: '守備的なデュエル',
    DefensiveActions: '守備的なアクション',
    ProgressivePassesReceivedOppHalf: '敵陣で受け取った前向きのパス',
    CompletedCrossesOP: '成功したセンタリング',
    CrossingOP: '成功したセンタリング %',
    CrossesOP: 'オープンプレーでの合計クロス数',
    PassingContribution: 'パスの貢献 %',
    BallProgressionOppHalfInTeam: 'チーム全体での敵陣でのボールの進行 %',
    PassesOPIntoBoxInTeam: 'インプレーでのチーム全体での相手ペナルティーエリア内のパス %',
    TouchesOppBoxInTeam: 'チーム全体での相手ペナルティーエリア内のタッチ %',
    xGOPInTeam: 'インプレーでのチーム全体での xG %',
    DeepPasses: '深いパス',
    DeepPassesTotal: 'ディープパス',
    DefensiveDuelsPct: '守備的なデュエル %',
    DefensiveDistance: '守備の距離',
    QuickRecoveriesPct: '素早いボール奪取 %',
    DiffDefensiveDistanceTeam: 'チームとの守備の距離の差',
    xTPassing: 'xT パス',
    xTPassing100Passes: '100本中 パス xT  ',
    ProgressivePassesAccurate: '成功した前進のパス',
    PassAbility: 'スキルパス',
    OPPassesIntoOppBoxPct: 'インプレーでのペナルティーエリア内へのパス %',
    EntriesOppBox: 'ペナルティーエリアへの侵入',
    Crosses6yardBox: 'ゴールエリア内へのセンタリング',
    Cutbacks: 'ペナルティーエリアの侵入し、深い位置からマイナス方向へのクロス',
    xTDribbling: '仕掛けるドリブル xT ',
    AvgShotDistance: '平均シュート距離',
    xGOnTarget: '枠内 xG ',
    FinishingxGOT: '決定率 枠内シュートの xG ',
    DribblesWonOwnHalf: '自陣で成功した仕掛けるドリブル',
    DribblesOwnHalf: '自陣で仕掛けたドリブル',
    DribblesOwnHalfPct: '自陣で成功した仕掛けるドリブル %',
    DribblesWonOppHalf: '敵陣で成功した仕掛けるドリブル',
    DribblesOppHalf: '敵陣で仕掛けたドリブル',
    DribblesOppHalfPct: '敵陣で成功した仕掛けるドリブル %',
    DribblesWonFinalThird: 'ファイナルサードで成功した仕掛けるドリブル',
    DribblesFinalThird: 'ファイナルサードで仕掛けたドリブル',
    DribblesFinalThirdPct: 'ファイナルサードで成功した仕掛けるドリブル%',
    ShotEndingHighRecoveries: 'シュートで終わる高い位置でのボール奪取',
    PassingFinalThirdAgainst: 'ファイナルサードへのパス被成功数',
    OpenPlayPassesIntoOpponentBoxAgainst: 'オープンプレー中のボックス内被パス数',
    EntriesOppBoxAgainst: '相手のボックス侵入回数（被）',
    DeepProgressionAgainst: '被ディーププログレッション数',
    TouchesInOpponentBoxAgainst: 'ボックス内の被タッチ数',
    Score: 'スコア',
    PDScore: 'フィジカルスコア',
    OrlegiScore: 'Orlegi スコア',
    SirScore: 'Sirius スコア',
    ExcScore: 'Excelsior スコア',
    xTOPInTeam: 'インプレーでのチーム全体 xT ',
    YellowCards: 'イエローカード',
    RedCards: 'レッドカード',
    xTOpenPlayAgainst: 'インプレーで与えた xT ',
    xTSetPieceAgainst: '与えたセットプレー xT ',
    NPGOpenPlayAgainst: 'インプレーで与えた GSP ',
    NPGSetPieceAgainst: '与えたセットプレー GSP',
    PassesOppHalfPerPossession: 'ポゼッション毎の敵陣でのパス',
    AverageTimeRecovery: 'ボールを奪うまでの平均時間',
    ExpectedPassing: '合格見込み',
    NumPossession10Passes: 'ポゼッション 10パス',
    PassesReceived: 'パス獲得数',
    PassesReceivedFinalThird: '最終パス数 ⅓ 最終パス数 ⅓ 最終パス数 ⅓ 最終パス数',
    ProgressivePassesTotalPct: 'プログレッシブ・パス',
    ShortPassesPct: 'ショートパス',
    TouchesOppBoxOppTeam: '彼が出場時の自陣ペナルティエリア内被タッチ数',
    ShotsOnTargetOppTeam: '彼が出場時の被枠内シュート数',
    NPGOppTeam: '彼が出場時の相手チームのPK除くxG',
    ShotsOpenPlay: 'オープンプレーのシュート',
    xGSetPiecePerxG: 'xGに対するセットプレーxG',
    ShotsOpenPlayAgainst: 'オープンプレーで被ったシュート',
    ShotsFromDribble: 'ドリブル後のシュート',
    GoalsFromDribble: 'ドリブル後のゴール',
    PassesIntoFinalThird: 'ファイナルサードへのパス',
    PassesIntoFinalThirdTotal: 'ファイナルサードへのパス合計数',
    PassesInsideFinalThird: 'ファイナルサード内のパス',
    PassesInsideFinalThirdTotal: '決勝進出 1/3 以内のパスの合計',
    PassesFinalThirdNoArea: '決勝3位通過（ボックスなし）',
    PassesIntoOppBox: '相手ペナルティエリアへのパス',
    CarriesFinalThird: 'ファイナルサードへのドリブル',
    CarriesInsideFinalThird: 'ファイナルサード内のドリブル',
    CarriesFinalThirdNoBox: 'ファイナルサードをキャリー (ボックスなし)',
    CarriesIntoOppBox: '相手ペナルティエリアへのドリブル',
    TimePossessionAgainst: '相手のボール保持時間',
    TimePossessionTotal: '両チームのボール保持時間合計',
    PassesInBox: '自陣ペナルティエリア内のパス',
    LongThrowInSuccessful: '成功したロングスローイン',
    LongThrowInTotal: 'ロングスローインの総数',
    LongThrowInPct: '成功したロングスローインの割合',
    Games: 'プレイしたゲーム',
    PointsPerGame: 'ゲームあたりのポイント',
    ExpectedPointsDiff: '予想得点差',
    PassesTotalOwnHalf: '合計パス数は自分の半分',
    PassesOwnHalf: '自陣をパス',
    PassesTotalOppHalf: '合計 OPP 半分をパス',
    ProgressivePassesTotal: 'プログレッシブパスの総数',
    DuelsWon: 'デュエル勝利',
    NonPenaltySaves: 'ノンペナルティセーブ',
    BadActionsOppHalf: '悪いアクション OPP ハーフ',
    CarriesSuccessful: 'キャリー成功',
    ShotsOnTargetOutBox: '箱から出してすぐに枠内シュート',
    TotalDistance: '距離',
    DistanceIP: '距離 TIP',
    DistanceOOP: '距離 OTIP',
    SprintsNumber: 'スプリント数',
    SprintsDistance: 'スプリント距離',
    WalkingDistance: '歩行距離',
    JoggingDistance: 'ジョギング距離',
    RunningDistance: '走行距離',
    ExtremeAccelerations: '極端な加速',
    NumberOfRuns: '走行回数',
    HsrNumber: 'HSR数量',
    HsrDistance: 'HSR距離',
    SprintNumberDeclinePct: 'スプリント回数の減少 %',
    SprintDistanceDeclinePct: 'スプリント距離の減少 %',
    SprintNumberDecline: 'スプリント回数の減少',
    SprintDistanceDecline: 'スプリント距離の減少',
    HsrDistancePct: 'ハイスピードランニングの距離 %',
    SprintDistancePct: 'スプリント距離 %',
    Accelerations: '加速',
    ExplosiveDistance: 'エクスプローシブディスタンス ',
    MaxSpeed: '最高速度',
    AvgMaxSpeed: '平均最高速度',
    MaxAccelerations: '最高加速度',
    BypassedPlayersByPasses: '回避されたプレイヤー',
    BypassedDefendersByPasses: '回避されたディフェンダー',
    PassesBypassingPlayers: 'プレイヤーを回避するパス',
    PassesBypassingDefenders: 'ディフェンダーを回避するパス',
    BypassedPlayersPerPass: 'パスごとに回避されたプレイヤー',
    BypassedDefendersPerPass: 'パスごとに回避されたディフェンダー',
    LineBreakingPasses: 'ラインブレイクパス',
    LineBreakingPassesMD: 'ラインブレイクパス MD',
    LineBreakingPassesM: '',
    LineBreakingThroughBalls: 'ラインブレイクスルーパス',
    LineBreakingPassesPerPass: 'パスごとのライン間突破パスの割合',
    TotalPassesUnderStrongPressure: '強いプレッシャー下での総パス数',
    TotalPassesUnderLightPressure: '弱いプレッシャー下での総パス数',
    SuccessfulPassesUnderStrongPressure: '強いプレッシャー下のパス',
    SuccessfulPassesUnderLightPressure: '弱いプレッシャー下のパス',
    PassingUnderStrongPressure: '強いプレッシャー下のパス %',
    PassingUnderLightPressure: '弱いプレッシャー下のパス %',
    PassReceiptsInSpaceCompleted: 'スペース内でのパス（受けた/出した）',
    PassReceiptsInSpace: 'スペース内で受けたパス',
    PassReceiptsInSpaceCompletedFirstThird: 'スペースでの受け手（第1サード完了）',
    PassReceiptsInSpaceCompletedSecondThird: 'スペースでの受け手（第2サード完了）',
    PassReceiptsInSpaceCompletedFinalThird: 'スペースでの受け手（ファイナルサード完了）',
    PassReceiptsInSpaceCompletedOppHalfRight: '相手陣右側スペースでの受け手完了',
    PassReceiptsInSpaceCompletedOppHalfCenter: '相手陣中央スペースでの受け手完了',
    PassReceiptsInSpaceCompletedOppHalfLeft: '相手陣左側スペースでの受け手完了',
    PassReceiptsInSpaceFirstThird: '第1サードでのスペース受け取り',
    PassReceiptsInSpaceSecondThird: '第2サードでのスペース受け取り',
    PassReceiptsInSpaceFinalThird: 'ファイナルサードでのスペース受け取り',
    PassReceiptsInSpaceOppHalfRight: '相手陣右側でのスペース受け取り',
    PassReceiptsInSpaceOppHalfCenter: '相手陣中央でのスペース受け取り',
    PassReceiptsInSpaceOppHalfLeft: '相手陣左側でのスペース受け取り',
    TotalStrongOnBallPressures: 'ボールへの強いプレッシャー総数',
    TotalLightOnBallPressures: 'ボールへの弱いプレッシャー総数',
    SuccessfulStrongOnBallPressures: 'ボールへの強いプレッシャー',
    SuccessfulLightOnBallPressures: 'ボールへの弱いプレッシャー',
    StrongOnBallPressuresPct: '強いプレッシャーの割合 %',
    LightOnBallPressuresPct: '弱いプレッシャーの割合 %',
    TimesBypassedByPasses: 'パスによって突破された',
    TimesBypassedByCarries: 'ドリブルによって突破された',
    TimesBypassedByActions: 'アクションによって突破された',
    BypassedPlayersByCarries: 'ドリブルで突破された選手',
    BypassedDefendersByCarries: 'ドリブルで突破されたディフェンダー',
    BypassedPlayersByActions: 'アクションで突破された選手',
    BypassedDefendersByActions: 'アクションで突破されたディフェンダー',
    CarriesBypassingPlayers: '選手を突破するドリブル',
    CarriesBypassingDefenders: 'ディフェンダーを突破するドリブル',
    BypassedPlayersPerCarry: '1回のドリブルで突破された選手数',
    BypassedDefendersPerCarry: '1回のドリブルで突破されたディフェンダー数',
    LineBreakingCarries: 'ライン間のドリブル',
    LineBreakingCarriesMD: 'ディフェンスとミッドフィルダーの間のドリブル',
    LineBreakingCarriesM: 'ミッドフィルダーライン間のドリブル',
    LineBreakingCarriesD: 'ディフェンスライン間のドリブル',
    LineBreakingCarriesPerCarry: '1回のドリブルあたりのライン間ドリブル',
    LineBreakingActions: 'ライン間のアクション',
    LineBreakingActionsMD: 'ディフェンスとミッドフィルダーの間のアクション',
    LineBreakingActionsM: 'ミッドフィルダーラインのアクション',
    LineBreakingActionsD: 'ディフェンスラインのアクション',
    PassesPerLineBreakingPass: 'ライン間パスごとのパス数',
    CarriesPerLineBreakingCarry: 'ライン間ドリブルごとのドリブル数',
    LinesBrokenByPasses: 'パスによって破ったライン数',
    LinesBrokenByCarries: '運びによって破ったライン数',
    LinesBrokenByActions: 'アクションによって破ったライン数',
    LinesBrokenPerPass: '1パスあたりの突破ライン数',
    LinesBrokenPerCarry: '1運びあたりの突破ライン数',
    AvgLastDefenderDistanceIP: 'ラストディフェンダー距離 IP',
    AvgLastDefenderDistanceOOP: 'ラストディフェンダー距離 OOP',
    AvgDefensiveLineDistanceIP: 'ディフェンスライン距離 IP',
    AvgDefensiveLineDistanceOOP: 'ディフェンスライン距離 OOP',
    AvgRBDistanceIP: '右サイドバック距離 IP',
    AvgRBDistanceOOP: '右サイドバック距離 OOP',
    AvgLBDistanceIP: '左サイドバック距離 IP',
    AvgLBDistanceOOP: '左サイドバック距離 OOP',
    AvgBlockDistanceIP: 'ブロック距離 IP',
    AvgBlockDistanceOOP: 'ブロック距離 OOP',
    AvgBlockAreaIP: 'ブロックエリア IP',
    AvgBlockAreaOOP: 'ブロックエリア OOP',
    AvgDefensiveLineWidthOOP: 'ディフェンスライン幅 OOP',
    AvgOffensiveLineLastThirdWidthIP: 'オフェンスライン最終サード幅 IP',
    AvgLByIP: '左サイドバック位置 IP',
    AvgRByIP: '右サイドバック位置 IP',
    AvgOffensiveLineDistanceIP: 'オフェンスライン距離 IP',
    AvgOffensiveLineLastThirdDistanceIP: 'オフェンスライン最終サード距離 IP',
    AvgOffensiveLineWidthIP: 'オフェンスライン幅 IP',
    OffBallRuns: 'オフザボールの合計ラン',
    OffBallRunsOverlap: 'オーバーラップラン',
    OffBallRunsUnderlap: 'アンダーラップラン',
    OffBallRunsRunAhead: '前方へのラン',
    OffBallRunsRunBehind: '裏へのラン',
    OffBallRunsCrossReceiver: 'クロス受けラン',
    OffBallRunsSupport: 'サポートラン',
    OffBallRunsComingShort: 'ショートサポートラン',
    description: {
      Possession: 'チームポゼッション率',
      TimePossession: 'チームのボール支配時間',
      PassesPerShots: '1シュートあたりのパス数',
      PPDA: '守備アクションあたりのパス数。チームが1回の守備フェーズでボールを取り戻すまでに相手チームに与えたパスの数。PPDAが高いほど相手へのプレッシャーが低い。',
      Directness: '敵のゴールまでパスでつなぐ、チームのパスがどれだけ直接的であるかを測定します。',
      ExpectedPoints: '各試合で作られたゴール期待値、被ゴール期待値から計算された、チームの予想ポイント数。この計算は、チームが実際に達成したポイントと比較して、ゲーム (または累積ゲーム) でのチームのパフォーマンスによって知ることができます。',
      PassesPerLongBall: 'ロングパスごとのパス数',
      CrossingPerXG: 'ボックス内へのクロスからのゴール期待値の割合',
      PenaltySavedPenaltyFaced: '被PKごとの救われたPKの割合',
      Goals: '得点数',
      PenaltyShots: 'PKからの総シュート数',
      PenaltyGoals: 'PKからの総ゴール数',
      NonPenaltyGoals: 'PKを除く得点数',
      NPGOpenPlay: 'インプレーでの得点数',
      NPGSetPiece: 'PKを除く、セットプレーでの得点数',
      Shooting: '枠内シュートの％',
      Finishing: 'シュートがゴールに入った割合',
      xGEfficiency: '選手がゴールを決めるのに必要なゴール期待値数',
      HeaderPerShot: 'ヘディングシュート数',
      HeaderPerCross: 'チームが出したクロスの総数のうち、選手がヘディングした割合',
      Assists: 'アシスト数',
      ThroughBalls: 'スルーパス',
      CrossEfficiency: '試行されたセンタリングの総数のうち、繋がったセンタリングの数',
      ScoringContribution: 'プレーあたりのアシスト数とゴール数',
      xAssistsOpenPlay: '間のセットプレーからではなくプレーからのアシスト期待値',
      xAssistsSetPiece: '間のセットプレーからのアシスト期待値',
      xAssistsOpenPlayInTeam: 'チーム内分間のセットプレーからではなくプレーからのアシスト期待値',
      xAssistsSetPieceInTeam: 'チーム内分間のセットプレーからのアシスト期待値',
      xGChainFinalThird: 'ファイナルサードで関与した選手のゴール期待値',
      xGBuildupFinalThird: 'ファイナルサードで関与した選手のゴール期待値(その前のシュートとパスを除く)',
      BallProgressionPassing: 'パスによるボール進行',
      BallProgressionDribbling: 'ドリブルによるボール進行',
      TacklesWasDribbled: '選手がタックルでボールを取り戻した回数と、ドリブルで抜かれた、かわされた回数の割合を考慮した指標。 指標が高いほど良い。',
      TacklesSuccessful: 'プレーヤーが成功したタックルの数',
      Interceptions: 'パスをインターセプトした回数',
      Clearances: '選手のパスをクリアした回数',
      Fouls: '選手のファール数',
      Recoveries: '選手のボールを奪取した回数',
      Shots: '選手のシュート数',
      ShotsPerGoal: '選手がゴールを決めるのに必要なシュート数',
      ShortPassesSuccessful: 'あたりに完了したショートパス（12メートル未満）の数',
      PassingSuccessForwardPct: 'あたりに成功した前へのパスの割合',
      PassingSuccessBackwardPct: 'あたりに成功した後ろへのパスの割合',
      PassingForwardBackwardPct: '後方パスに比べて前方パスの比率',
      LongBallPerPassesPct: '総パス数に対するロングボールの割合',
      LongBallReceived: '32メートル以上の受けたロングパス',
      LongBallReceivedOppHalf: '間に敵陣で受けたロングパス数',
      OffensiveActions: '攻撃的な行為',
      DribblesAttempted: 'ドリブル試行回数',
      SuccessfulDribblesPct: '成功したドリブル数 / ドリブル試行の総数',
      OffensiveTouchesOutBoxPct: 'すぐに使える攻撃的なタッチの割合',
      BallRetention: 'ボールを保持し、最終的にボールを失うことのなかった回数の割合',
      PassingPct: '選手が行ったパスの総数のうち、成功したパスの割合',
      PassingOwnHalfPct: '自陣で終わるパスの成功率',
      PassingOppHalfPct: '敵陣で終わるパスの成功率',
      PassingFinalThird: 'クロス、セットプレー、コーナー、スローインを除き、ファイナルサード内で開始される成功したパス',
      PassesFinalThirdTotal: 'クロス、セットプレー、コーナー、スローインを除き、ファイナルサードで終了するパス試行回数の合計',
      PassingFinalThirdPct: '選手の全パスのうち、ファイナルサード内から始まったパスの成功率',
      LongBallSuccessful: '間で32メートル以上のパスを成功させた回数',
      LongBallPct: '成功したロングパス (32メートル以上) の割合',
      LongBallTotal: '32メートルを超えるパスの総数',
      SavesPct: '総被弾数に対するセーブの割合',
      SavesInBoxPct: 'ペナルティーエリア内からのシュートのセーブ率',
      SavesOutOfBoxPct: 'ペナルティーエリア外からのシュートのセーブ率',
      xGSavedPerXGFacedOnTarget: 'ゴールキーパーによって止められた予想 xG のパーセンテージを示す。 1に近づくほど得点が難しくなる',
      xGFacedOnTargetPerGoalReceived: 'ゴールキーパーに対してゴールを決めるために必要なゴール期待値を示す。 この指標は、このゴールキーパー相手にゴールを決めるには高い xG が必要であることを意味します。',
      xGFacedOnTargetEfficiency: 'ゴールキーパーによって妨げられたゴールの数。ゴール期待値 (ゴールへのシュートのみ) からゴールキーパーが許したゴール数を差し引いたもの。 ゴールキーパーのおかげで妨げられたゴールの数を示します。',
      xGFacedOnTarget: 'ゴールキーパーが受けた総 xG (セーブと失点)',
      IndividualPressure: 'ボールを持たない選手が相手に与えるプレッシャーを数値化したモデル。このモデルは、ボールがリカバーされたかどうかにかかわらず、守備チームのプレーヤーがフィールドの最後の5分の3で対戦相手に対して行ったプレッシャーの数を測定します。プレッシャーの数値が高いほど、対戦相手ができることが少なくなります。',
      AerialEfficiency: '空中戦の成功率と空中戦の勝数を合わせたモデル',
      AerialWins: '選手が勝利した空中戦の数',
      AerialWinsPct: '行われた空中戦の合計のうち、勝った空中戦の数',
      xG: 'ごとに生成されるゴール期待値。この指標はシュートのさまざまな変数に基づいて、シュートがゴールで終わる確率のパーセンテージを測定します。',
      xGDiff: 'xG と得点の差',
      xGOpenPlay: 'インプレーで作られたゴール期待値',
      xGSetPiece: 'セットプレーのみで生み出されるゴール期待値',
      xGPerShot: 'シュートあたりのゴール期待値。この指標は、被シュートの平均的な危険度を測定します。高いほどシュートがゴールになる可能性が高くなります。 高い値はプレーヤーがエリア内からシュートを放ちゴールに向かうように、シュートまでうまく運んでいることを意味します。',
      ChancesCreated: '味方選手がシュートで終わるパスを出した数',
      CompletedCrosses: '間での成功したセンタリング',
      Crossing: '成功したセンタリングの割合',
      OpenPlayKeyPasses: 'シュート（アシストを除く）につながるインプレーでの成功したパス数',
      OpenPlayKeyPassesInTeam: 'チーム内でのオープンプレー中に選手がパスを完了した割合',
      OpenPlayPassesIntoOpponentBox: '間での敵ペナルティーエリア内への成功したパス数',
      OpenPlayPassesIntoOpponentBoxSuccessful: '間での敵ペナルティーエリア内への成功したパス数',
      xAssists: 'アシスト期待値(xA)とは、試合中に味方が”シュート”か”得点”に繋がるパスの質を数 値化したものです。 ※アシスト数は、パスを受けてからシュートを決める味方選手の質が関係するため、xAの正しい測定が出来ないため、以下の項目を考慮してパスの質を数値化します。「パスを出した場所・パスの種類(クロスボール・スルーパス・セットプレーからのパス...etc)・試合の状態(人数・天候...etc) など」',
      xGChain: '参加した選手のゴール期待値数。 選手がシュートで終了するプレーに参加した場合、プレーの xG がこの指標に追加されます',
      xGBuildup: 'xG 参加と同様ですが、プレーの流れの最後の2人のプレーヤー (最後のパサーとシュートを打った選手) は含みません。',
      xGBuildupInTeam: 'ビルドアップ in Team',
      BallProgression: 'パスとドリブルの両方、または両方の組み合わせで、選手が10メートル以上前進した回数（間）',
      SuccessfulDribbles: 'ドリブル成功数',
      Dispossessed: 'プレーヤーのボールロスト数',
      TouchesInOpponentBox: '間の選手の敵ペナルティーエリア内でのアクションの回数',
      xGSavedPerShot: '被枠内シュートの平均危険度',
      BallRetentionOppHalf: '相手陣内でボールを保持し、ボールを失うことがなかった回数の割合',
      DeepProgression: 'プレーヤーがフィールドの最後の5分の1に到達した回数と、プレーヤーが最後の5分の1でボールをコントロールした回数を足した数。',
      DeepProgressionFinalThird: 'プレーヤーがフィールドのファイナルサードに到達した回数と、プレーヤーがファイナルサードでボールをコントロールした回数を足した数。',
      FoulsTaken: '間の被ファール数',
      PenaltiesTaken: '誘発したPK',
      BlockedCrosses: 'ブロックされたセンタリング',
      BlockedShots: 'ブロックされたシュート',
      NonPenaltyGoalsAgainst: '失点（PKを除く）',
      GoalsConceded: '間のプレーあたりの失点数',
      Headers: 'ヘディングシュート',
      HeadedGoals: 'プレー時間当たりのヘッドによるゴール数',
      Points: 'チームが達成したポイント数',
      SavesInBox: '間のプレー当たりのボックス内シュートのセーブ数',
      SavesOutBox: '間のプレー当たりのボックス外シュートによるセーブ数',
      ShotsOnTargetInBoxAgainst: '間のプレー当たりのボックス内からの枠内シュートの失点数',
      ShotsOnTargetOutBoxAgainst: '間のプレー当たりのボックス外からの枠内シュートの失点数',
      AveragePassDistance: '平均パス距離',
      ProgressiveRuns: '相手エリアに近づく行動。選手が自陣で開始および終了するときには30メートルの前進、自陣で始まり敵陣で終わる時は15メートルの前進、敵陣で開始および終了するときには10メートルの前進、これらを前進と見なします。',
      xT: '脅威期待値(xT)、これは選手がドリブルとパスの両方で、ポゼッションがゴールになる可能性が高いエリアにボールを持っていき、相手チームにもたらす脅威を測定する指標です。',
      xTOpenPlay: '間のセットプレーからではなく、インプレーからの脅威期待値',
      xTSetPiece: '間のインプレーからではなく、セットプレーからの脅威期待値',
      xGOT: '枠内シュートのゴール期待値。ゴールキーパーが直面するゴール期待値。この指標では枠内シュートのみが考慮されます。(枠外シュートとバー、ポストへのシュートは除外)。',
      BadActions: '犯したすべての悪行の合計',
      BadActionsOwnHalf: '自陣でのボールロスト',
      AerialsWonOwnBox: '自ペナルティーエリアで空中戦勝利',
      AerialsWonOppBox: '相手ペナルティーエリアで空中戦勝利',
      AerialsTotalOppBox: '自ペナルティーエリアで空中戦数',
      AerialsTotalOwnBox: '相手ペナルティーエリアで空中戦数',
      FoulsOwnHalfPct: '自陣でのファール %',
      RecoveriesOppHalf: '敵陣で選手が間に奪取したボールの数',
      DuelsPct: 'デュエル成功 %',
      TacklesUnsuccessful: '相手がドリブルで突破したにもかかわらず、プレーヤーがボールを奪えなかった回数',
      TacklesWasDribbledFirstThird: 'ファイナルサードでタックル/ドルブルで抜かれた',
      TacklesWasDribbledSecondThird: '守備1v1勝利数 ⅔',
      TacklesWasDribbledFinalThird: '守備1v1勝利数 終わり ⅓',
      BallProgressionFinalThird: 'ファイナルサードでのボールの前進',
      DuelsTotal: '間に犯したタックル、エアリアル、ボールタッチ、ドリブル、ファウルの総数',
      QuickRecoveries: '自ゴールから40メートル以上離れて場所で、ボールを失ってから5秒以内にリカバリー',
      ShotsPerNPG: 'PK抜きのゴールごとのシュート数',
      ShotsOutBox: '間でのペナルティーエリア外からのショット',
      GoalsOutBox: '間でのペナルティーエリア外からのゴール',
      ShootingOutBox: 'ペナルティーエリアからの枠内シュート率',
      HandPassing: 'ハンドでパスを成功させた割合',
      Catching: 'キャッチの割合',
      Caught: 'ゴールキーパーがボールをキャッチして保持した場所をセーブし、セカンドプレーを防ぎます',
      ClaimAccuracy: 'ゴールキーパーが空中でどれだけ優れているかを測定します。1より大きい数値は、ゴールキーパーが予想よりも多くの空中ボールをインターセプトしたことを示します。',
      HighTurnovers: '自ゴールから40メートル以内でのボールロスト',
      ShotEndingHighTurnovers: '自ゴールから40メートル以内で、シュートで終わったボールロスト',
      GoalEndingHighTurnovers: '自ゴールから40メートル以内で、ゴールに繋がったボールロスト',
      AverageCarriesProgress: '縦へのボール運びの平均距離 (メートル)',
      ChanceEndingCarries: 'パスで終わりその後シュートに繋がった7メートル以上のドリブルでの運び',
      AssistEndingCarries: 'ゴールアシストのパスで終えた7メートル以上のドリブルでの運び',
      ShotEndingCarries: 'シュートで終了する少なくとも7メートルのドリブルでの運び',
      GoalEndingCarries: 'ゴールで終了する少なくとも7メートルのドリブルでの運び',
      ShotEndingSequence: '選手が参加したシュートで終わった一連のプレー',
      GoalEndingSequence: '選手が参加したゴールで終わった一連のプレー',
      xGPerNPG: '各ゴールあたりのPKを含まないゴール期待値',
      AerialWonOffensive: '攻撃での空中戦での勝利数',
      AerialWonDefensive: '守備での空中戦での勝利数',
      xGAgainst: '相手のゴール期待値',
      xGDiffAgainst: '予想失点数と失点数の違い',
      xGPerNPGAgainst: '各ゴールあたりのPKを含まない被ゴール期待値',
      xGSetPieceAgainst: 'セットプレーでの被ゴール期待値',
      xGOpenPlayAgainst: 'オープンプレーで生成される予想ゴール数 失点数',
      xGPerShotAgainst: '各被シュートの平均 xG ',
      ShotsAgainst: '間の被シュート',
      ShotsOnTargetAgainst: '間の被枠内シュート',
      RivalPossession: '相手のポゼッション',
      AerialDefensivePct: 'ディフェンス空中戦勝率 %',
      HighRecoveries: '相手ペナルティーエリアから40メートル以内でのボール奪取',
      HighDefensiveActions: '自身のゴールラインから40mを超える位置での守備アクション (タックル、インターセプト、ブロック、ファウル、および1対1) の合計の割合',
      HighDefensiveActionPct: '自身のゴールラインから40mを超える位置での守備アクション (タックル、インターセプト、ブロック、ファウル、および1対1) の合計の割合',
      HighDefensiveDistance: '自身のゴールから全守備アクション位置までの平均距離',
      PassesPerPossession: 'ポゼッション毎のパス',
      LengthPerPossession: 'ポゼッション毎の距離',
      xTNet: '脅威期待値 正味',
      AvgCarriesDistance: '平均ドリブル距離',
      PassesForwardPct: '合計に対する前へのパスの割合',
      PassesForwardSuccessful: '成功したフォワードパス',
      PassesForwardTotal: '合計フォワードパス数',
      TacklesAttempted: 'タックル回数',
      DuelsLost: '間のデュエル負け数',
      Carries: '間のドリブル',
      CarriesPct: 'ドリブル %',
      Aerials: '間の空中戦',
      ProgressivePassesReceivedIntoBox: 'ペナルティーエリア内で受けた前へのパス',
      PassesOppHalf: '相手のフィールドで終了する成功したパスの合計数',
      ShotsOnTarget: 'での枠内シュート',
      AggressiveActions: 'ボールを失ってから2秒以内にタックルを試みた',
      Crosses: '間の合計センタリング',
      xGBuildup5pass: '最後の5パスでの xG ビルドアップ (シュートとシュートに至るまでのパスを除く)',
      DefensiveDistance: '自ゴールから守備デュエルが行われた位置までの距離の平均',
      SpeedSequence: 'ポゼッション時のボール移動速度',
      Touches: '選手のタッチ数',
      AerialsTotalOppHalf: '間での敵陣で空中戦の合計',
      AerialsWonOppHalf: '間のプレーごとに相手陣内への空中決闘が成功した',
      AerialsWonOppHalfPct: '敵陣で行われた空中戦の総数に対する空中戦の勝率',
      AerialsPctOppBox: '相手ペナルティーエリア内で行われた空中戦の総数に対する空中戦の勝率',
      AerialsPctOwnBox: '自ペナルティーエリア内で行われた空中戦の総数に対する空中戦の勝率',
      AerialDefensive: '相手チームがポゼッションしているときの空中戦の総数',
      AerialOffensive: '自チームがポゼッションしているときの空中戦の総数',
      AerialOffensivePct: '自チームがポゼッションしているときに獲得した空中戦の割合',
      IndividualPressureOppHalf: '選手が相手陣内でプレッシャーをかけ成功した回数を数値化するモデル',
      ChancesCreatedOP: '間での枠内シュートで終わったインプレーのパスの数',
      TouchesPerShot: '各シュートで実行されるタッチ数',
      PassesFinalThirdTotalPct: 'ファイナルサードで行われたパス (成功および失敗) の割合',
      xACrosses: 'センタリングから生まれるアシスト期待値',
      Passes: 'パスの総数',
      PassesSuccessful: '成功したパス',
      TacklesWasDribbledFouls: 'タックルと犯したファウルの合計と比べて、勝ったタックルの割合',
      OffsidesCaught: 'オフサイド',
      ProgressivePassesReceivedFinalThird: 'ファイナルサードで受け取った前向きのパス',
      ProgressivePassesReceived: '受け取った前向きのパス',
      Breadth: 'サイドでのタックル、受けたドリブル、インターセプト、犯したファウルの合計数',
      DuelsDefTotal: '合計タックル、守備的な空中戦、犯したファウルの合計',
      DefensiveActions: '守備的なアクション',
      ProgressivePassesReceivedOppHalf: '敵陣で受けた前向きなパス',
      CompletedCrossesOP: 'インプレーで成功したクロス',
      CrossingOP: 'インプレーで成功したクロスの割合',
      CrossesOP: 'オープンプレー中のクロス総数',
      PassingContribution: 'レシーバーの位置を考慮してパスの価値を加え出した、脅威度を測る割合。',
      BallProgressionOppHalfInTeam: 'チームの合計に対して、相手のフィールドでのボールの進行率',
      PassesOPIntoBoxInTeam: 'チームの合計に対して、相手のフィールドでのインプレーでのパスの割合',
      TouchesOppBoxInTeam: 'チームの合計に対して、相手のフィールドでのボールタッチの割合',
      xGOPInTeam: 'インプレーで生まれたチームの合計のゴール期待値の割合',
      DeepPasses: '相手ゴールから半径20メートルの外側からのその内側へのパス',
      DeepPassesTotal: '相手ゴールの半径 20 メートルの外側から試みられ、そのエリア内で終了したパスの合計',
      DefensiveDuelsPct: '守備デュエルの合計と勝利の割合',
      QuickRecoveriesPct: 'タックル成功でのクイックリカバリーの割合',
      DiffDefensiveDistanceTeam: '選手とチームの守備距離差',
      xTPassing: 'パスだけで生まれる脅威期待値',
      xTPassing100Passes: 'パスのみ、100回ごとの脅威期待値',
      ProgressivePassesAccurate: '相手ゴールの方向に向かって成功させた10メートル以上のパス',
      PassAbility: '成功したパスとパス期待値(xP)の比率',
      OPPassesIntoOppBoxPct: 'インプレーでの相手ペナルティーエリアのパス成功と合計の割合',
      EntriesOppBox: '相手ペナルティーエリアへのパスとドリブルの合計',
      Crosses6yardBox: 'ゴールエリアに上がったセンタリングの総数',
      Cutbacks: 'ゴールライン際からのペナルティーエリアへマイナスパス',
      xTDribbling: 'ドリブルのみから生まれる xT ',
      AvgShotDistance: 'シュートの合計の平均距離',
      xGOnTarget: '枠内シュートのゴール期待値。ゴール期待値と異なり、このモデルはシュートの方向を考慮して、枠内シュートがゴールに終わる確率を測定します。',
      FinishingxGOT: '枠内シュートのゴール期待値を使用しての、ゴールにつながった枠内シュートの割合。この指標は、枠内へのシュートとゴールの割合の測定から、ストライカーがシュートの質によってどれだけの価値を加えたかを表します。',
      DribblesWonOwnHalf: '自陣でのドリブル成功数',
      DribblesOwnHalf: '自陣でのドリブル試行回数',
      DribblesOwnHalfPct: '自陣での合計ドリブル数に対するドリブル成功率',
      DribblesWonOppHalf: '敵陣でのドリブル成功数',
      DribblesOppHalf: '敵陣でのドリブル試行回数',
      DribblesOppHalfPct: '敵陣での合計ドリブル数に対するドリブル成功率',
      DribblesWonFinalThird: 'ファイナルサードでのドリブル成功数',
      DribblesFinalThird: 'ファイナルサードでのドリブル試行回数',
      DribblesFinalThirdPct: 'ファイナルサードでの合計ドリブル数に対するドリブル成功率',
      ShotEndingHighRecoveries: 'シュートで終わるハイリカバリー（相手ゴールから40メートル以内でのボール奪取）',
      PassingFinalThirdAgainst: '相手のファイナルサードへの成功したパス',
      OpenPlayPassesIntoOpponentBoxAgainst: 'オープンプレー中に相手が自陣ボックス内に試みたパスの総数',
      EntriesOppBoxAgainst: '相手による自陣ボックスへのパスとドリブルの回数',
      DeepProgressionAgainst: '相手がボールを運んで最終5分の1に到達した回数＋自陣5分の1でのボール保持回数',
      TouchesInOpponentBoxAgainst: '相手が自陣ボックス内でボールを保持した回数',
      Score: 'さまざまな指標に基づくプレーヤーのパフォーマンス',
      PDScore: 'さまざまな身体的指標に基づく選手の身体的パフォーマンス',
      OrlegiScore: 'さまざまな指標に基づくプレーヤーのパフォーマンス',
      SirScore: 'さまざまな指標に基づくプレーヤーのパフォーマンス',
      ExcScore: 'さまざまな指標に基づくプレーヤーのパフォーマンス',
      xTOPInTeam: 'チームの合計に対して、インプレーで生まれる脅威期待値 (xT)',
      YellowCards: '受けたイエローカード ',
      RedCards: '受けたレッドカード',
      xTOpenPlayAgainst: 'セットプレーではなく、インプレーで与えた脅威期待値',
      xTSetPieceAgainst: 'インプレーではなく、セットプレーで与えた脅威期待値',
      NPGOpenPlayAgainst: 'インプレーでのPKを除く被ゴール',
      NPGSetPieceAgainst: 'セットプレーでのPKを除く被ゴール',
      PassesOppHalfPerPossession: 'ポゼッションによる敵陣へのパス',
      AverageTimeRecovery: 'ボール奪取の平均時間',
      ExpectedPassing: '合格見込み',
      NumPossession10Passes: 'ポゼッション 10パス',
      PassesReceived: 'パス獲得数',
      PassesReceivedFinalThird: '最終パス数 ⅓ 最終パス数 ⅓ 最終パス数 ⅓ 最終パス数',
      ProgressivePassesTotalPct: 'プログレッシブ・パス',
      ShortPassesPct: 'ショートパス',
      TouchesOppBoxOppTeam: '選手が出場している間に自陣ペナルティエリア内で許した相手のアクション数',
      ShotsOnTargetOppTeam: '選手が出場している間に被シュート（枠内）数',
      NPGOppTeam: '選手が出場している間に被ゴール（PK除く）数',
      xGSetPiecePerxG: '1つのxGを生むために必要なセットプレーからのxG',
      ShotsOpenPlay: 'オープンプレーからのシュート数',
      ShotsOpenPlayAgainst: 'オープンプレーで受けたシュート数',
      ShotsFromDribble: '相手をドリブルで抜いた後に行われたシュート',
      GoalsFromDribble: '相手をドリブルで抜いた後に決めたゴール',
      PassesIntoFinalThird: 'ファイナルサードからの成功したパス',
      PassesIntoFinalThirdTotal: '外側から始まりファイナルサード内側で終わる試みられたパスの合計数',
      PassesInsideFinalThird: 'ファイナルサード内で開始・終了する成功したパス',
      PassesInsideFinalThirdTotal: 'ファイナル 3 分の 1 以内に試行されたパスの合計 (ファイナル 3 分の 1 で開始および終了)',
      PassesFinalThirdNoArea: '決勝3位通過（ボックスなし）',
      PassesIntoOppBox: '相手のペナルティエリアで終わる成功したパス',
      CarriesFinalThird: 'ファイナルサードで終わる7メートル以上のドリブル',
      CarriesInsideFinalThird: 'ファイナルサード内で開始・終了する7メートル以上のドリブル',
      CarriesFinalThirdNoBox: 'ファイナルサードをキャリー (ボックスなし)',
      CarriesIntoOppBox: '相手ペナルティエリアで終わる7メートル以上のドリブル',
      TimePossessionAgainst: '相手チームのボール保持時間',
      TimePossessionTotal: '両チームのボール保持時間合計',
      PassesInBox: '相手のペナルティエリア内から始まる成功したパス',
      LongThrowInSuccessful: 'タッチラインから20メートル以上の距離を狙った成功したロングスロー',
      LongThrowInTotal: 'タッチラインからの20メートル以上のロングスローの総数',
      LongThrowInPct: '成功したロングスロー（20メートル以上）の割合',
      Games: 'プレイしたゲーム',
      PointsPerGame: 'ゲームあたりのポイント',
      ExpectedPointsDiff: '予想得点差',
      PassesTotalOwnHalf: '自陣からのパスの総数',
      PassesOwnHalf: '自陣からのパス成功数',
      PassesTotalOppHalf: '敵陣からのパスの総数',
      ProgressivePassesTotal: 'X軸10メートル以上のパスの合計数',
      DuelsWon: 'デュエルの成功（タックル、エアリアル、ボールタッチ、ドリブル、ファウルの成功）',
      NonPenaltySaves: 'ペナルティショットを除いたセーブ数',
      BadActionsOppHalf: '相手陣内で犯されたすべての不正行為の合計（パス失敗、テイクアップ失敗、ポゼッション、オフサイドパス、ボールタッチ失敗）',
      CarriesSuccessful: 'イベントが成功して終了した少なくとも7メートルのキャリーの数',
      ShotsOnTargetOutBox: 'ボックス外から枠内シュートを放った',
      TotalDistance: '試合中に選手が移動した総距離',
      WalkingDistance: '試合中に選手が2 m/s（7.2 km/h）未満の速度で移動した総距離',
      JoggingDistance: '試合中に選手が2 m/s（7.2 km/h）から4 m/s（14.4 km/h）の速度でジョギングした総距離',
      RunningDistance: '試合中に選手が4 m/s（14.4 km/h）から5.5 m/s（19.8 km/h）の速度で走った総距離',
      ExtremeAccelerations: '選手が3 m/s²以上で加速した回数',
      NumberOfRuns: '試合中に選手が4 m/s（14.4 km/h）から5.5 m/s（19.8 km/h）の速度で完了した走行の回数',
      DistanceIP: '試合中、選手がポゼッションを持って移動した距離（チームがポゼッション時）',
      DistanceOOP: '試合中、選手がポゼッションを持たずに移動した距離（相手チームがポゼッション時）',
      HsrNumber: '試合中に選手が少なくとも1秒間に5.5 m/s（19.8 km/h）以上かつ7 m/s（25.2 km/h）未満の速度で移動した回数',
      HsrDistance: '試合中に選手が5.5 m/s（19.8 km/h）以上かつ7 m/s（25.2 km/h）未満の速度で移動した総距離',
      HsrDistancePct: '総移動距離に対する高速走行（HSR）の距離の割合',
      SprintsNumber: '試合中に選手が少なくとも1秒間に7 m/s（25.2 km/h）以上の速度で移動した回数',
      SprintsDistance: '試合中に選手が7 m/s（25.2 km/h）以上の速度でスプリントした総距離',
      SprintNumberDeclinePct: '試合の後半と比較したスプリント数の減少率',
      SprintDistanceDeclinePct: '試合の後半と比較したスプリント中の走行距離の減少率',
      SprintNumberDecline: '試合の後半に比べて、スプリントの回数が減少しました。',
      SprintDistanceDecline: 'スプリント中の走行距離が、試合の後半に比べて減少した。',
      SprintDistancePct: '総移動距離に対するスプリント距離の割合',
      Accelerations: '試合中に選手が1.5 m/s²から3 m/s²の間で加速した回数',
      ExplosiveDistance: '爆発的な距離',
      MaxSpeed: '選手が記録した最高速度',
      AvgMaxSpeed: '選手が記録した平均最高速度',
      MaxAccelerations: '選手が記録した最大加速度（メートル/秒²）',
      BypassedPlayersByPasses: 'タッチイベントの開始時にボール保持者よりゴール側にいる選手数から、タッチイベント終了時にゴール側にいる選手数を引いた数',
      BypassedDefendersByPasses: 'タッチイベントの開始時にボール保持者よりゴール側にいる守備選手の数から、終了時の守備選手の数を引いた数',
      PassesBypassingPlayers: '選手を突破したパスの数',
      PassesBypassingDefenders: '守備選手を突破したパスの数',
      BypassedPlayersPerPass: 'パスごとに突破された選手の合計数',
      BypassedDefendersPerPass: 'パスごとに突破された守備選手の合計数',
      LineBreakingPasses: 'ボールを相手ゴールに少なくとも10%近づけ、近接する守備選手のペアを交差する、または守備ラインを超えるパスの数',
      LineBreakingPassesMD: '中盤ラインと最終ラインを突破した成功パス',
      LineBreakingPassesM: '中盤ラインを突破した成功パス',
      LineBreakingThroughBalls: '最終ラインを突破した成功パス',
      LineBreakingPassesPerPass: 'パスごとに突破したラインの数',
      TotalPassesUnderStrongPressure: '強いプレッシャー下で行われたパスの合計数(相手選手から0～2メートル以内）',
      TotalPassesUnderLightPressure: '軽いプレッシャー下で行われたパスの合計数（相手選手から2～5メートル以内）',
      SuccessfulPassesUnderStrongPressure: '強いプレッシャー下で成功したパスの数（相手選手から0～2メートル以内）',
      SuccessfulPassesUnderLightPressure: '軽いプレッシャー下で成功したパスの数（相手選手から2～5メートル以内）',
      PassingUnderStrongPressure: '強いプレッシャー下での成功パスの割合（相手選手から0～2メートル以内）',
      PassingUnderLightPressure: '軽いプレッシャー下での成功パスの割合（相手選手から2～5メートル以内）',
      PassReceiptsInSpaceCompleted: '受け手が攻撃側ハーフ内でゴール方向に5メートル以内に守備選手がいない場合のパス',
      PassReceiptsInSpace: '攻撃側ハーフ内でゴール方向に5メートル以内に守備選手がいない場合に受け取ったパス',
      PassReceiptsInSpaceCompletedFirstThird: '受け手が第1サードにいて、ゴール方向に5メートル以内にディフェンダーがいないパス',
      PassReceiptsInSpaceCompletedSecondThird: '受け手が第2サードにいて、ゴール方向に5メートル以内にディフェンダーがいないパス',
      PassReceiptsInSpaceCompletedFinalThird: '受け手がファイナルサードにいて、ゴール方向に5メートル以内にディフェンダーがいないパス',
      PassReceiptsInSpaceCompletedOppHalfRight: '受け手が相手陣右側にいて、ゴール方向に5メートル以内にディフェンダーがいないパス',
      PassReceiptsInSpaceCompletedOppHalfCenter: '受け手が相手陣中央にいて、ゴール方向に5メートル以内にディフェンダーがいないパス',
      PassReceiptsInSpaceCompletedOppHalfLeft: '受け手が相手陣左側にいて、ゴール方向に5メートル以内にディフェンダーがいないパス',
      PassReceiptsInSpaceFirstThird: '第1サードで受け手がゴール方向に5メートル以内にディフェンダーがいないパス',
      PassReceiptsInSpaceSecondThird: '第2サードで受け手がゴール方向に5メートル以内にディフェンダーがいないパス',
      PassReceiptsInSpaceFinalThird: 'ファイナルサードで受け手がゴール方向に5メートル以内にディフェンダーがいないパス',
      PassReceiptsInSpaceOppHalfRight: '相手陣右側で受け手がゴール方向に5メートル以内にディフェンダーがいないパス',
      PassReceiptsInSpaceOppHalfCenter: '相手陣中央で受け手がゴール方向に5メートル以内にディフェンダーがいないパス',
      PassReceiptsInSpaceOppHalfLeft: '相手陣左側で受け手がゴール方向に5メートル以内にディフェンダーがいないパス',
      TotalStrongOnBallPressures: '強いプレッシャー（ボール保持者から0～2メートル以内）の数',
      TotalLightOnBallPressures: 'プレッシャー（ボール保持者から2～5メートル以内）の数',
      SuccessfulStrongOnBallPressures: '成功した強いプレッシャー（ボール保持者から0～2メートル以内）の数',
      SuccessfulLightOnBallPressures: '成功したプレッシャー（ボール保持者から2～5メートル以内）の数',
      StrongOnBallPressuresPct: '成功した強いプレッシャーの割合（ボール保持者から0～2メートル以内）',
      LightOnBallPressuresPct: '成功したプレッシャーの割合（ボール保持者から2～5メートル以内）',
      TimesBypassedByPasses: 'パスによって突破された合計回数',
      TimesBypassedByCarries: 'ドリブルによって突破された合計回数',
      TimesBypassedByActions: 'パスとドリブルの合計で突破された合計回数',
      BypassedPlayersByCarries: 'ドリブルで突破された相手（DFとMF）の合計人数',
      BypassedDefendersByCarries: 'ドリブルで突破された相手（DF）の合計人数',
      BypassedPlayersByActions: 'パスとドリブルの合計で突破された相手（DFとMF）の合計人数',
      BypassedDefendersByActions: 'パスとドリブルの合計で突破された相手（DF）の合計人数',
      CarriesBypassingPlayers: '相手選手を突破したドリブルの回数',
      CarriesBypassingDefenders: 'DFを突破したドリブルの回数',
      BypassedPlayersPerCarry: '1回のドリブルで突破した相手選手の平均数',
      BypassedDefendersPerCarry: '1回のドリブルで突破したDFの平均数',
      LineBreakingCarries: '守備ラインを突破したドリブルの回数',
      LineBreakingCarriesMD: 'MFラインとDFラインを突破したドリブルの回数',
      LineBreakingCarriesM: 'MFラインを突破したドリブルの回数',
      LineBreakingCarriesD: 'DFラインを突破したドリブルの回数',
      LineBreakingCarriesPerCarry: 'ドリブルごとのライン間突破率',
      LineBreakingActions: '守備ラインを突破したパスとドリブルの合計回数',
      LineBreakingActionsMD: 'MFラインとDFラインを突破したパスとドリブルの合計回数',
      LineBreakingActionsM: 'MFラインを突破したパスとドリブルの合計回数',
      LineBreakingActionsD: 'DFラインを突破したパスとドリブルの合計回数',
      PassesPerLineBreakingPass: 'ライン間突破パス1本あたりの全パス数の比率',
      CarriesPerLineBreakingCarry: 'ライン間突破ドリブル1本あたりの全ドリブル数の比率',
      LinesBrokenByPasses: 'パスで突破したラインの合計数',
      LinesBrokenByCarries: 'ドリブルで突破したラインの合計数',
      LinesBrokenByActions: 'パスとドリブルの合計で突破したラインの合計数',
      LinesBrokenPerPass: '1本のパスで突破したラインの平均数',
      LinesBrokenPerCarry: '1本のドリブルで突破したラインの平均数',
      AvgLastDefenderDistanceIP: '最後のディフェンダー（自陣ゴールに最も近い選手）とゴールラインの距離（ボール保持時）',
      AvgLastDefenderDistanceOOP: '最後のディフェンダー（自陣ゴールに最も近い選手）とゴールラインの距離（非保持時）',
      AvgDefensiveLineDistanceIP: '最も深いディフェンスラインとゴールの距離（ボール保持時）',
      AvgDefensiveLineDistanceOOP: '最も深いディフェンスラインとゴールの距離（非保持時）',
      AvgRBDistanceIP: '右サイドバックと自陣ゴールの距離（ボール保持時）',
      AvgRBDistanceOOP: '右サイドバックと自陣ゴールの距離（非保持時）',
      AvgLBDistanceIP: '左サイドバックと自陣ゴールの距離（ボール保持時）',
      AvgLBDistanceOOP: '左サイドバックと自陣ゴールの距離（非保持時）',
      AvgBlockDistanceIP: '最も後方と最も前方のフィールドプレーヤー間の距離（ボール保持時）',
      AvgBlockDistanceOOP: '最も後方と最も前方のフィールドプレーヤー間の距離（非保持時）',
      AvgBlockAreaIP: '全フィールドプレーヤーを囲むバウンディングボックスの面積（チームの占有スペース）ボール保持時',
      AvgBlockAreaOOP: '全フィールドプレーヤーを囲むバウンディングボックスの面積（チームの占有スペース）非保持時',
      AvgDefensiveLineWidthOOP: '最も後方の選手ラインの横幅（非保持時）',
      AvgOffensiveLineLastThirdWidthIP: '最終サードにおけるオフェンスラインの横幅（ボール保持時）',
      AvgLByIP: '左サイドバックの位置（ボール保持時）',
      AvgRByIP: '右サイドバックの位置（ボール保持時）',
      AvgOffensiveLineDistanceIP: '自陣ゴールとオフェンスライン間の距離（ボール保持時）',
      AvgOffensiveLineLastThirdDistanceIP: '自陣ゴールと最終サードのオフェンスラインの距離（ボール保持時）',
      AvgOffensiveLineWidthIP: 'オフェンスラインの横幅（ボール保持時）',
      OffBallRuns: '攻撃をサポートする意図的なオフザボールの動き（ラン）',
      OffBallRunsOverlap: '味方がボールを持っている際に、サイドライン側（外側）を回って走る動き',
      OffBallRunsUnderlap: '味方の内側（ピッチ中央側）を通って走る動き',
      OffBallRunsRunAhead: 'ボール保持者を追い越して前に出るが、最終ラインより手前で止まる動き',
      OffBallRunsRunBehind: '最終ディフェンスラインを突破し、ディフェンダーとゴールキーパーの間に入る動き',
      OffBallRunsCrossReceiver: 'クロスを受けるためにエリア内に走り込む動き',
      OffBallRunsSupport: 'ボール保持者に並ぶ位置へ走り、近くでパスの選択肢となる動き',
      OffBallRunsComingShort: 'ボール保持者に近づいてサポートやパスの受け手となる動き',
      AerialsOppHalf: '間での敵陣で繰り広げられる空中戦',
      xP: 'パス期待値 (xP) は、パスが終了するフィールドの部分に基づいてパスの品質を測定します',
      CarriesIntoFinalThird: '外側から最後の 3 分の 1 の内側まで少なくとも 7 メートルのパイプライン',
      SpeedScore: 'さまざまなスピード指標に基づいたプレーヤーの身体パフォーマンス',
      EnduranceScore: 'さまざまな指標に基づいたプレーヤーの持久力の身体パフォーマンス',
      SwitchPlaySuccessful: 'ボールの横方向の変位が相手ゴールに向かう変位よりも大きい、32 メートルを超える完了したパスの数',
      SwitchPlayTotal: 'ボールの横方向の変位が相手ゴールに向かう変位よりも大きい、32 メートルを超えるパスの試行回数の合計',
      PassesInsideOppHalf: '相手陣内で開始および終了するパスの合計数',
      PassesInsideOppHalfSuccessful: '相手陣内で開始および終了するパスの完了数',
      TacklesAttemptedFirstThird: 'ピッチの最初の 3 分の 1 で試行されたタックルの合計数',
      TacklesAttemptedSecondThird: 'ピッチの 2/3 分の 2 で試行されたタックルの合計数',
      TacklesFirstThird: 'ピッチの最初の 3 分の 1 で成功したタックルの数',
      TacklesSecondThird: 'ピッチの 2/3 分の 2 で成功したタックルの数',
      FoulsOwnHalf: '自陣で犯したファウルの数',
      TouchesOppHalf: '敵陣でのボールタッチ数',
      TacklesAttemptedNotAdjusted: 'ポゼッション調整なしのタックル試行の合計数',
      TacklesSuccessfulNotAdjusted: '成功したタックルの総数（ポゼッション調整なし）',
      AvgTop5MaxSpeed: 'プレーヤーの最高 5 つの最大速度の平均',
      LBPReceived: '受信した改行パスの数。これらは、ボールを相手ゴールに少なくとも 10% 近づけ、至近距離で 2 人のディフェンダーと交差するか、ディフェンス ラインを越える完了したパスです。',
      LBPMReceived: '相手の中盤ラインを突破したパスを受けた数',
      LBPMDReceived: '相手の中盤とディフェンスラインの両方を突破したパスを受けた数',
      ThroughBallReceived: '相手の最終ディフェンスラインを突破したパスの受領数',
      HsrDistanceIP: 'ポゼッション時のスプリント距離 > 21 km/h',
      HsrDistanceOOP: 'ポゼッション時以外のスプリント距離 > 21 km/h',
      JoggingDistanceIP: '保有ジョギング距離',
      JoggingDistanceOOP: '所有権外のジョギング距離',
      RunningDistanceIP: '所持時の走行距離',
      RunningDistanceOOP: 'ポゼッション外の走行距離',
      SprintsDistanceIP: 'ポゼッション時のスプリント距離 > 24 km/h',
      SprintsDistanceOOP: 'ポゼッション時以外のスプリント距離 > 24 km/h',
      WalkingDistanceIP: '所持時の歩行距離',
      WalkingDistanceOOP: '所有権外の歩行距離',
      RunningNumberIP: 'Number of times that the Player is moving at a speed between 4 m/s (14.4 km/h) and 5.5 m/s (19.8 km/h) for a time period of at least 1 second with possession',
      RunningNumberOOP: 'Number of times that the Player is moving at a speed between 4 m/s (14.4 km/h) and 5.5 m/s (19.8 km/h) for a time period of at least 1 second without possession',
      RunningDistancePctIP: 'Percentage of Running Distance with respect to total distance travelled with possession',
      RunningDistancePctOOP: 'Percentage of Running Distance with respect to total distance travelled without possession',
      RunningDistancePct: 'Percentage of Running Distance with respect to total distance travelled',
      HsrNumberIP: 'Number of times that the Player is moving at a speed that is greater than or equal to 5.5 m/s (19.8 km/h) but less than 7 m/s (25.2 km/h) for a time period of at least 1 second with possession',
      HsrNumberOOP: 'Number of times that the Player is moving at a speed that is greater than or equal to 5.5 m/s (19.8 km/h) but less than 7 m/s (25.2 km/h) for a time period of at least 1 second without possession',
      SprintsNumberIP: 'Number of times that the Player is moving at a speed that is greater than or equal to 7 m/s (25.2 km/h) for a time period of at least 1 second with possession',
      SprintsNumberOOP: 'Number of times that the Player is moving at a speed that is greater than or equal to 7 m/s (25.2 km/h) for a time period of at least 1 second without possession',
      SprintsDistancePctIP: 'Percentage of Sprint Distance with respect to total distance travelled with possession',
      SprintsDistancePctOOP: 'Percentage of Sprint Distance with respect to total distance travelled without possession',
      SprintsDistancePct: 'Percentage of Sprint Distance with respect to total distance travelled',
      PossessionRegain: '相手にボールを奪われた回数',
      HandPassesSuccessful: 'ハンドによる成功したパス (ゴールキーパーまたはセットプレーでのスロー)',
      HandPassesTotal: 'ハンドで行われたパスの総数 (ゴールキーパーまたはセットプレーでのスロー)',
      InterceptionsNotAdjusted: 'Number of times the player intercepts a pass to prevent the ball reaching its target',
      ClearancesNotAdjusted: 'Number of times the player hits the ball clear of the defensive zone',
      RecoveriesNotAdjusted: 'Number of balls recovered by a player'
    },
    subtitles: {
      Possession: 'チームのポゼッション率',
      TimePossession: 'チームのボール支配時間',
      PassesPerShots: '各シュートのパス数',
      PPDA: '相手チームのボールポゼッションを失うまでのパス数',
      Directness: '縦性。チームがパスでどれだけ直接的であるか',
      ExpectedPoints: '期待ゴール数に基づいて計算された、チームが期待するポイント数',
      PassesPerLongBall: '各ロングパスごとのパス数',
      CrossingPerXG: 'ペナルティーエリア内からのクロスでのゴール期待値の割合',
      PenaltySavedPenaltyFaced: '被PKごとの救われたPKの割合',
      Goals: '得点数',
      PenaltyShots: 'PKからの総シュート数',
      PenaltyGoals: 'PKからの総ゴール数',
      NonPenaltyGoals: '得点数 (PKを除く)',
      AerialWins: '間での空中戦勝利',
      AerialEfficiency: '間の空中戦勝利数と空中戦の合計を組み合わせたモデル',
      AerialWinsPct: '空中戦勝率',
      Assists: 'アシスト数',
      Catching: 'ゴールキーパーがボールをキャッチした割合',
      Caught: 'ゴールキーパーがボールをキャッチして保持した場所をセーブし、セカンドプレーを防ぎます',
      ChancesCreated: 'シュートで終わるパスの数',
      ClaimAccuracy: 'センタリングに対しての守りの有効性',
      CompletedCrosses: '間での成功したセンタリング',
      Crossing: '成功したセンタリングの割合',
      Dispossessed: '間での非ポゼッション時間',
      Finishing: 'ゴールで終わるシュートの割合',
      xGEfficiency: '選手がゴールを決めるのに必要なゴール期待値',
      Fouls: '間で犯したファウル',
      DeepProgression: 'ボールを運ぶことによってピッチの最後の 5 分の 1 に到達した回数と、ボールを保持した時間が最後の 5 分の 1 の回数を足したもの',
      DeepProgressionFinalThird: 'プレーヤーがファイナルサードでボールを保持した回数',
      FoulsTaken: '間で受けたファウル',
      IndividualPressure: '間で成功したプレッシャー数',
      Interceptions: '間でのインターセプション',
      LongBallPct: '成功した32メートル以上のパスの割合',
      LongBallTotal: '32メートルを超えるパスの総数',
      LongBallSuccessful: '間で成功した32メートル以上のパス',
      NPGOpenPlay: 'インプレーでの得点数',
      NPGSetPiece: 'セットプレーでの得点数。(PKを除く)',
      OpenPlayKeyPasses: 'インプレーでのシュートで終わるパス (アシストを除く) ',
      OpenPlayKeyPassesInTeam: 'チーム内でのオープンプレー中に選手がパスを完了した割合',
      PassingFinalThird: 'クロス、セットプレー、コーナー、スローインを除き、ファイナルサード内で開始される成功したパス',
      PassesFinalThirdTotal: 'クロス、セットプレー、コーナー、スローインを除き、ファイナルサードで終了するパス試行回数の合計',
      PassingFinalThirdPct: '選手の全パスのうち、ファイナルサード内から始まったパスの成功率',
      PassingOppHalfPct: '敵陣での成功したパスの割合',
      PassingOwnHalfPct: '自陣での成功したパスの割合',
      PassingPct: '成功したパスの割合',
      Recoveries: '間でのボール奪取数',
      SavesInBoxPct: 'ペナルティーエリア内でのセーブ率',
      SavesOutOfBoxPct: 'ペナルティーエリア外でのセーブ率',
      SavesPct: 'セーブ率',
      ScoringContribution: 'プレーあたりのアシスト数とゴール数',
      xAssistsOpenPlay: '間のインプレーでのアシスト期待値',
      xAssistsSetPiece: '間のセットプレーでのアシスト期待値',
      xAssistsOpenPlayInTeam: 'チーム内分間のセットプレーからではなくプレーからのアシスト期待値',
      xAssistsSetPieceInTeam: 'チーム内分間のセットプレーからのアシスト期待値',
      xGChainFinalThird: 'ファイナルサードで関与した選手のゴール期待値数',
      xGBuildupFinalThird: 'ファイナルサードで関与した選手のゴール期待値数 (その前のシュートとパスを除く)',
      BallProgressionPassing: 'パスによるボール進行',
      BallProgressionDribbling: 'ドリブルによるボール進行',
      Shooting: '枠内シュートの割合（PKを除く）',
      Shots: '合計シュート数（PKを除く）',
      ShotsPerGoal: 'ゴールを決めるための平均枠内シュート数',
      SuccessfulDribbles: '間での成功したドリブル',
      TacklesSuccessful: '間の合計タックル数',
      TacklesWasDribbled: 'タックルでデュエルに勝った割合',
      ThroughBalls: '最終ディフェンスライン越えたパス数',
      TouchesInOpponentBox: '相手ペナルティーエリアでのボールタッチ数',
      xAssists: 'アシスト期待値',
      xG: 'ゴール期待値',
      xGDiff: 'xG と得点の差',
      xGOpenPlay: 'インプレーで生まれるゴール期待値',
      xGSetPiece: 'セットプレーのみで生み出されるゴール期待値',
      xGBuildup: '間のビルドアップ xG ',
      xGBuildupInTeam: 'ビルドアップ in Team',
      BallProgression: '間での10メートルを超えるパスまたはドリブルによる進行',
      xGChain: '間の関与 xG ',
      xGPerNPG: 'ゴールを決めるのに必要な平均 xG (PKを除く)',
      xGPerShot: 'シュートごとの平均 xG ',
      xGSavedPerShot: 'シュートごとの平均 xG セーブ',
      xGSavedPerXGFacedOnTarget: '被枠内 xG 毎の平均 xG セーブ',
      xGFacedOnTargetPerGoalReceived: 'ゴールキーパーにゴールを決めるために必要なゴール期待値',
      xGFacedOnTargetEfficiency: 'ゴールキーパーによって妨げられたゴールの数',
      xGFacedOnTarget: '間にゴールキーパーが受けた総 xG (セーブと失点)',
      HighTurnovers: '自ゴールから40メートル以内でのロスト',
      OpenPlayPassesIntoOpponentBox: '間にインプレーで相手ペナルティーエリアで成功したパス',
      OpenPlayPassesIntoOpponentBoxSuccessful: '間にインプレーで相手ペナルティーエリアで成功したパス',
      ChancesCreatedOP: '間のインプレーでゴールへのシュートで終わったプレーのパスの数',
      PenaltiesTaken: '間でのPK誘発回数',
      BlockedCrosses: '間でのセンタリングブロック数',
      BlockedShots: 'での止められたシュート数',
      NonPenaltyGoalsAgainst: '間での被ゴール数(PKを除く)',
      Headers: 'ヘディングシュート',
      AveragePassDistance: '平均パス距離',
      ProgressiveRuns: '間の相手エリアに近づくドリブル',
      xT: '間でのボールを危険な場所に移動させて発生する脅威',
      xTOpenPlay: '間のセットプレーからではなく、インプレーから脅威期待値',
      xTSetPiece: '間のインプレーからではなく、セットプレーから脅威期待値',
      xGOT: '枠内シュートのゴール期待値。ゴールキーパーが直面するゴール期待値。この測定基準では、枠内へのシュートのみが考慮されます。(外とポスト、バーへのシュートは除外)',
      BadActions: '犯したすべての悪行の合計',
      BadActionsOwnHalf: '自陣でのボールロスト',
      AerialsWonOwnBox: '自ペナルティーエリアでの空中戦勝利',
      AerialsWonOppBox: '相手ペナルティーエリアでの空中戦勝利',
      AerialsTotalOppBox: '自ペナルティーエリアでの合計空中戦数',
      AerialsTotalOwnBox: '相手ペナルティーエリアでの合計空中戦数',
      FoulsOwnHalfPct: '自陣でのファール %',
      RecoveriesOppHalf: '間に選手が敵陣でボールを奪った数',
      DuelsPct: '成功したデュエル %',
      TacklesUnsuccessful: '相手がドリブルで追い抜いたにもかかわらず、プレーヤーがボールを奪えなかった回数',
      TacklesWasDribbledFirstThird: 'ファイナルサードでのタックル/抜かれたドルブル',
      TacklesWasDribbledSecondThird: '守備1v1勝利数 ⅔',
      TacklesWasDribbledFinalThird: '守備1v1勝利数 終わり ⅓',
      BallProgressionFinalThird: 'ファイナルサードでのボール進行',
      DuelsTotal: '間に犯したタックル、エアリアル、ボールタッチ、ドリブル、ファウルの総数',
      QuickRecoveries: '自ゴールから40メートル以上の場所でボールロストから5秒以内に取り返した',
      ShotsPerNPG: 'PKなしのゴールごとのシュート数',
      ShotsOutBox: 'ペナルティーエリア外からのシュート',
      GoalsOutBox: 'ペナルティーエリア外からのゴール',
      ShootingOutBox: 'ペナルティーエリア外からの枠内シュート率',
      HandPassing: '手で成功したパスの割合',
      ShotEndingHighTurnovers: '自ゴールから40メートル以内の場所でシュートで終わったボールロス',
      GoalEndingHighTurnovers: '自ゴールから40メートル以内の場所でゴールで終わったボールロス',
      AverageCarriesProgress: 'ドリブルでの前進の平均距離 (メートル)',
      ChanceEndingCarries: 'パスからシュートで終わる 7 メートル以上のドリブル',
      AssistEndingCarries: 'アシストで終わる7メートル以上のドリブル',
      ShotEndingCarries: 'シュートで終わる少なくとも7メートルのボール運び',
      GoalEndingCarries: 'ゴールで終わる少なくとも7メートルのボール運び',
      ShotEndingSequence: '選手が参加したシュートで終わった一連のプレー',
      GoalEndingSequence: '選手が参加したゴールで終わった一連のプレー',
      AerialWonOffensive: '攻撃での空中戦での勝利数',
      AerialWonDefensive: '守備での空中戦での勝利数',
      xGAgainst: '相手のゴール期待値',
      xGDiffAgainst: '予想失点数と失点数の違い',
      xGPerNPGAgainst: 'PKを除く失点ごとの被ゴール期待値',
      xGOpenPlayAgainst: 'オープンプレーの失点によって予想されるゴール数',
      xGSetPieceAgainst: 'セットプレーからの被ゴール期待値',
      xGPerShotAgainst: '各シュートの平均 xG ',
      ShotsAgainst: '間の被シュート',
      ShotsOnTargetAgainst: '間の被枠内シュート',
      RivalPossession: '相手のポゼッション',
      AerialDefensivePct: 'ディフェンス空中戦勝率 %',
      HighRecoveries: '相手ペナルティーエリアから40メートル以内でのボール奪取',
      HighDefensiveActions: '自身のゴールラインから40mを超える位置での守備アクション (タックル、インターセプト、ブロック、ファウル、および1対1) の合計の割合',
      HighDefensiveActionPct: '自身のゴールラインから40mを超える位置での合計守備アクション (タックル、インターセプト、ブロック、犯したファウル、および 1v1) の割合',
      HighDefensiveDistance: '自ゴールから全守備アクションまでの平均距離',
      PassesPerPossession: 'ポゼッションあたりのパス',
      LengthPerPossession: 'ポゼッションあたりの距離',
      xTNet: '脅威期待値 正味',
      AvgCarriesDistance: '平均ドリブル距離',
      PassesForwardPct: '合計に対する前へのパスの割合',
      PassesForwardSuccessful: '成功したフォワードパス',
      PassesForwardTotal: '合計フォワードパス数',
      TacklesAttempted: 'タックル数',
      DuelsLost: '間で負けたデュエル',
      Carries: '間でのドリブル',
      CarriesPct: '間でのドリブル %',
      Aerials: '間での空中戦',
      ProgressivePassesReceivedIntoBox: 'ペナルティーエリアで受け取った前進のパス',
      PassesOppHalf: '相手フィールドで終了した成功したパスの合計数',
      LongBallReceived: '32メートル以上の受け取ったパス',
      ShotsOnTarget: '間での枠内シュート',
      AggressiveActions: 'ボールロストから2秒以内に行ったタックル',
      Crosses: '間での合計センタリング数',
      xGBuildup5pass: '最後の5パスでの xG ビルドアップ (シュートとシュートに至るまでのパスを除く)',
      DefensiveDistance: '自ゴールから守備デュエルが行われた位置までの距離の平均',
      SpeedSequence: 'ポゼッション時のボール移動速度',
      Touches: '選手のタッチ数',
      AerialsTotalOppHalf: '間での敵陣で空中戦の合計',
      AerialsWonOppHalf: '間のプレーごとに相手陣内への空中決闘が成功した',
      AerialsWonOppHalfPct: '敵陣で行われた空中戦の総数に対する空中戦の勝率',
      AerialsPctOppBox: '相手ペナルティーエリア内で行われた空中戦の総数に対する空中戦の勝率',
      AerialsPctOwnBox: '自ペナルティーエリア内で行われた空中戦の総数に対する空中戦の勝率',
      AerialDefensive: '相手チームがポゼッションしているときの空中戦の総数',
      AerialOffensive: '自チームがポゼッションしているときの空中戦の総数',
      AerialOffensivePct: '自チームがポゼッションしているときに獲得した空中戦の割合',
      IndividualPressureOppHalf: '選手が相手陣内でプレッシャーをかけ成功した回数を数値化するモデル',
      TouchesPerShot: '各シュートで実行されるタッチ数',
      PassesFinalThirdTotalPct: 'ファイナルサードで行われたパス (成功および失敗) の割合',
      xACrosses: 'センタリングから生まれるアシスト期待値',
      Passes: '合計パス数',
      PassesSuccessful: '成功したパス',
      TacklesWasDribbledFouls: 'タックルと犯したファウルの合計と比べて、勝ったタックルの割合',
      OffsidesCaught: 'オフサイド',
      ProgressivePassesReceivedFinalThird: 'ファイナルサードで受け取った前向きのパス',
      ProgressivePassesReceived: '受け取った前向きのパス',
      Breadth: 'サイドでのタックル、受けたドリブル、インターセプト、犯したファウルの合計数',
      DuelsDefTotal: '合計タックル、守備的な空中戦、犯したファウルの合計',
      DefensiveActions: '守備的なアクション',
      ProgressivePassesReceivedOppHalf: '敵陣で受けた前向きなパス',
      CompletedCrossesOP: 'インプレーで成功したクロス',
      CrossingOP: 'インプレーで成功したクロスの割合',
      CrossesOP: 'オープンプレー中のクロス総数',
      PassingContribution: 'レシーバーの位置を考慮してパスの価値を加え出した、脅威度を測る割合。',
      BallProgressionOppHalfInTeam: 'チームの合計に対して、相手のフィールドでのボールの進行率',
      PassesOPIntoBoxInTeam: 'チームの合計に対して、相手のフィールドでのインプレーでのパスの割合',
      TouchesOppBoxInTeam: 'チームの合計に対して、相手のフィールドでのボールタッチの割合',
      xGOPInTeam: 'インプレーで生まれたチームの合計のゴール期待値の割合',
      DeepPasses: '相手ゴールから半径20メートルの外側からのその内側へのパス',
      DeepPassesTotal: '相手ゴールの半径 20 メートルの外側から試みられ、そのエリア内で終了したパスの合計',
      DefensiveDuelsPct: '守備デュエルの合計と勝利の割合',
      QuickRecoveriesPct: 'タックル成功でのクイックリカバリーの割合',
      DiffDefensiveDistanceTeam: '選手とチームの守備距離差',
      xTPassing: 'パスだけで生まれる脅威期待値',
      xTPassing100Passes: 'パスのみ、100回ごとの脅威期待値',
      ProgressivePassesAccurate: '相手ゴールの方向に向かって成功させた10メートル以上のパス',
      PassAbility: '成功したパスとパス期待値(xP)の比率',
      OPPassesIntoOppBoxPct: 'インプレーでの相手ペナルティーエリアのパス成功と合計の割合',
      EntriesOppBox: '相手ペナルティーエリアへのパスとドリブルの合計',
      Crosses6yardBox: 'ゴールエリアに上がったセンタリングの総数',
      Cutbacks: 'ゴールライン際からのペナルティーエリアへマイナスパス',
      xTDribbling: 'ドリブルのみから生まれる xT ',
      AvgShotDistance: 'シュートの合計の平均距離',
      xGOnTarget: '枠内シュートのゴール期待値',
      FinishingxGOT: '枠内シュートがゴールに終わる確率',
      DribblesWonOwnHalf: '自陣でのドリブル成功数',
      DribblesOwnHalf: '自陣でのドリブル試行回数',
      DribblesOwnHalfPct: '自陣での合計ドリブル数に対するドリブル成功率',
      DribblesWonOppHalf: '敵陣でのドリブル成功数',
      DribblesOppHalf: '敵陣でのドリブル試行回数',
      DribblesOppHalfPct: '敵陣での合計ドリブル数に対するドリブル成功率',
      DribblesWonFinalThird: 'ファイナルサードでのドリブル成功数',
      DribblesFinalThird: 'ファイナルサードでのドリブル試行回数',
      DribblesFinalThirdPct: 'ファイナルサードでの合計ドリブル数に対するドリブル成功率',
      ShotEndingHighRecoveries: 'シュートで終わるハイリカバリー（相手ゴールから40メートル以内でのボール奪取）',
      PassingFinalThirdAgainst: '相手のファイナルサードへの成功したパス',
      OpenPlayPassesIntoOpponentBoxAgainst: 'オープンプレー中に相手が自陣ボックス内に試みたパスの総数',
      EntriesOppBoxAgainst: '相手による自陣ボックスへのパスとドリブルの回数',
      DeepProgressionAgainst: '相手がボールを運んで最終5分の1に到達した回数＋自陣5分の1でのボール保持回数',
      TouchesInOpponentBoxAgainst: '相手が自陣ボックス内でボールを保持した回数',
      Score: 'さまざまな指標に基づくプレーヤーのパフォーマンス',
      PDScore: 'さまざまな身体的指標に基づく選手の身体的パフォーマンス',
      OrlegiScore: 'さまざまな指標に基づくプレーヤーのパフォーマンス',
      SirScore: 'さまざまな指標に基づくプレーヤーのパフォーマンス',
      ExcScore: 'さまざまな指標に基づくプレーヤーのパフォーマンス',
      xTOPInTeam: '間のチームの合計に対して、インプレーで生まれた脅威期待値 (xT)',
      YellowCards: '受けたイエローカード',
      RedCards: '受けたレッドカード',
      xTOpenPlayAgainst: '間のセットプレーではなく、インプレーから与えられる脅威期待値',
      xTSetPieceAgainst: '間のインプレーではなく、セットプレーから与えられる脅威期待値',
      NPGOpenPlayAgainst: '間のインプレーで与えたゴール、PKは除く',
      NPGSetPieceAgainst: '間のセットプレーで与えたゴール、PKは除く',
      PassesOppHalfPerPossession: 'ポゼッション毎の敵陣でのパス',
      AverageTimeRecovery: 'ボールを奪うまでの平均時間',
      ExpectedPassing: '合格見込み',
      NumPossession10Passes: 'ポゼッション 10パス',
      PassesReceived: 'パス獲得数',
      PassesReceivedFinalThird: '最終パス数 ⅓ 最終パス数 ⅓ 最終パス数 ⅓ 最終パス数',
      ProgressivePassesTotalPct: 'プログレッシブ・パス',
      ShortPassesPct: 'ショートパス',
      TouchesOppBoxOppTeam: '選手が出場している間に自陣ペナルティエリア内で許した相手のアクション数',
      ShotsOnTargetOppTeam: '選手が出場している間に被シュート（枠内）数',
      NPGOppTeam: '選手が出場している間に被ゴール（PK除く）数',
      xGSetPiecePerxG: '1つのxGを生むために必要なセットプレーからのxG',
      ShotsOpenPlay: 'オープンプレーからのシュート数',
      ShotsOpenPlayAgainst: 'オープンプレーで受けたシュート数',
      ShotsFromDribble: '相手をドリブルで抜いた後に行われたシュート',
      GoalsFromDribble: '相手をドリブルで抜いた後に決めたゴール',
      PassesIntoFinalThird: 'ファイナルサードからの成功したパス',
      PassesIntoFinalThirdTotal: '外側から始まりファイナルサード内側で終わる試みられたパスの合計数',
      PassesInsideFinalThird: 'ファイナルサード内で開始・終了する成功したパス',
      PassesInsideFinalThirdTotal: 'ファイナル 3 分の 1 以内に試行されたパスの合計 (ファイナル 3 分の 1 で開始および終了)',
      PassesFinalThirdNoArea: '決勝3位通過（ボックスなし）',
      PassesIntoOppBox: '相手のペナルティエリアで終わる成功したパス',
      CarriesFinalThird: 'ファイナルサードで終わる7メートル以上のドリブル',
      CarriesInsideFinalThird: 'ファイナルサード内で開始・終了する7メートル以上のドリブル',
      CarriesFinalThirdNoBox: 'ファイナルサードをキャリー (ボックスなし)',
      CarriesIntoOppBox: '相手ペナルティエリアで終わる7メートル以上のドリブル',
      TimePossessionAgainst: '相手チームのボール保持時間',
      TimePossessionTotal: '両チームのボール保持時間合計',
      PassesInBox: '相手のペナルティエリア内から始まる成功したパス',
      LongThrowInSuccessful: 'タッチラインから20メートル以上の距離を狙った成功したロングスロー',
      LongThrowInTotal: 'タッチラインからの20メートル以上のロングスローの総数',
      LongThrowInPct: '成功したロングスロー（20メートル以上）の割合',
      Games: 'プレイしたゲーム',
      PointsPerGame: 'ゲームあたりのポイント',
      ExpectedPointsDiff: '予想得点差',
      PassesTotalOwnHalf: '自陣からのパスの総数',
      PassesOwnHalf: '自陣からのパス成功数',
      PassesTotalOppHalf: '敵陣からのパスの総数',
      ProgressivePassesTotal: 'X軸10メートル以上のパスの合計数',
      DuelsWon: 'デュエルの成功（タックル、エアリアル、ボールタッチ、ドリブル、ファウルの成功）',
      NonPenaltySaves: 'ペナルティショットを除いたセーブ数',
      BadActionsOppHalf: '相手陣内で行われたすべての悪い行為の合計',
      CarriesSuccessful: 'イベントが成功して終了した少なくとも7メートルのキャリーの数',
      ShotsOnTargetOutBox: 'ボックス外から枠内シュートを放った',
      TotalDistance: '総走行距離',
      WalkingDistance: 'プレーヤーが試合中に 2 m/s (7.2 km/h) 未満の速度で移動した合計距離',
      JoggingDistance: 'プレーヤーが試合中に 2 m/s (7.2 km/h) ～ 4 m/s (14.4 km/h) の速度で移動した合計距離',
      RunningDistance: 'プレーヤーが試合中に 4 m/s (14.4 km/h) ～ 5.5 m/s (19.8 km/h) の速度で移動した合計距離',
      ExtremeAccelerations: 'プレーヤーが 3 m/s を超えて加速した回数<sup>2</sup>',
      NumberOfRuns: '14.4 km/h ～ 19.8 km/h の速度で完了した走行回数',
      HsrDistance: '速度 19.8 km/h 以上の距離',
      HsrNumber: '速度 19.8 km/h 以上のスプリント回数',
      HsrDistancePct: '合計距離に対する速度 19.8 km/h 以上の距離の %',
      SprintsNumber: '速度 25.2 km/h 以上のスプリント回数',
      SprintsDistance: '速度 25.2 km/h 以上の距離',
      SprintNumberDeclinePct: '前後半でのスプリント数の % の差',
      SprintDistanceDeclinePct: '前後半でのスプリント距離の % の差',
      SprintNumberDecline: '試合の後半に比べて、スプリントの回数が減少しました。',
      SprintDistanceDecline: 'スプリント中の走行距離が、試合の後半に比べて減少した。',
      SprintDistancePct: '総距離に対するスプリントした距離の割合',
      Accelerations: '加速量',
      MaxSpeed: '試合のある時点で到達した最大速度',
      AvgMaxSpeed: '選手が記録した平均最高速度',
      MaxAccelerations: '選手が記録した最大加速度（メートル/秒²）',
      BypassedPlayersByPasses: 'パスによって回避された対戦相手 (ディフェンダーとミッドフィールダー) の総数',
      BypassedDefendersByPasses: 'タッチイベントの開始時にボール保持者よりゴール側にいる守備選手の数から、終了時の守備選手の数を引いた数',
      PassesBypassingPlayers: '選手を突破したパスの数',
      PassesBypassingDefenders: '守備選手を突破したパスの数',
      BypassedPlayersPerPass: 'パスごとに突破された選手の合計数',
      BypassedDefendersPerPass: 'パスごとに突破された守備選手の合計数',
      LineBreakingPasses: 'ボールを相手ゴールに少なくとも10%近づけ、近接する守備選手のペアを交差する、または守備ラインを超えるパスの数',
      LineBreakingPassesMD: '中盤ラインと最終ラインを突破した成功パス',
      LineBreakingPassesM: '中盤ラインを突破した成功パス',
      LineBreakingThroughBalls: '最終ラインを突破した成功パス',
      LineBreakingPassesPerPass: 'パスごとに突破したラインの数',
      TotalPassesUnderStrongPressure: '強いプレッシャー下で行われたパスの合計数（相手選手から0～2メートル以内）',
      TotalPassesUnderLightPressure: '軽いプレッシャー下で行われたパスの合計数（相手選手から2～5メートル以内）',
      SuccessfulPassesUnderStrongPressure: '強いプレッシャー下で成功したパスの数（相手選手から0～2メートル以内）',
      SuccessfulPassesUnderLightPressure: '軽いプレッシャー下で成功したパスの数（相手選手から2～5メートル以内）',
      PassingUnderStrongPressure: '強いプレッシャー下での成功パスの割合（相手選手から0～2メートル以内）',
      PassingUnderLightPressure: '軽いプレッシャー下での成功パスの割合（相手選手から2～5メートル以内）',
      PassReceiptsInSpaceCompleted: '受け手が攻撃側ハーフ内でゴール方向に5メートル以内に守備選手がいない場合のパス',
      PassReceiptsInSpace: '攻撃側ハーフ内でゴール方向に5メートル以内に守備選手がいない場合に受け取ったパス',
      PassReceiptsInSpaceCompletedFirstThird: '受け手が第1サードにいて、ゴール方向に5メートル以内にディフェンダーがいないパス',
      PassReceiptsInSpaceCompletedSecondThird: '受け手が第2サードにいて、ゴール方向に5メートル以内にディフェンダーがいないパス',
      PassReceiptsInSpaceCompletedFinalThird: '受け手がファイナルサードにいて、ゴール方向に5メートル以内にディフェンダーがいないパス',
      PassReceiptsInSpaceCompletedOppHalfRight: '受け手が相手陣右側にいて、ゴール方向に5メートル以内にディフェンダーがいないパス',
      PassReceiptsInSpaceCompletedOppHalfCenter: '受け手が相手陣中央にいて、ゴール方向に5メートル以内にディフェンダーがいないパス',
      PassReceiptsInSpaceCompletedOppHalfLeft: '受け手が相手陣左側にいて、ゴール方向に5メートル以内にディフェンダーがいないパス',
      PassReceiptsInSpaceFirstThird: '第1サードで受け手がゴール方向に5メートル以内にディフェンダーがいないパス',
      PassReceiptsInSpaceSecondThird: '第2サードで受け手がゴール方向に5メートル以内にディフェンダーがいないパス',
      PassReceiptsInSpaceFinalThird: 'ファイナルサードで受け手がゴール方向に5メートル以内にディフェンダーがいないパス',
      PassReceiptsInSpaceOppHalfRight: '相手陣右側で受け手がゴール方向に5メートル以内にディフェンダーがいないパス',
      PassReceiptsInSpaceOppHalfCenter: '相手陣中央で受け手がゴール方向に5メートル以内にディフェンダーがいないパス',
      PassReceiptsInSpaceOppHalfLeft: '相手陣左側で受け手がゴール方向に5メートル以内にディフェンダーがいないパス',
      TotalStrongOnBallPressures: '強いプレッシャー（ボール保持者から0～2メートル以内）の数',
      TotalLightOnBallPressures: 'プレッシャー（ボール保持者から2～5メートル以内）の数',
      SuccessfulStrongOnBallPressures: '成功した強いプレッシャー（ボール保持者から0～2メートル以内）の数',
      SuccessfulLightOnBallPressures: '成功したプレッシャー（ボール保持者から2～5メートル以内）の数',
      StrongOnBallPressuresPct: '成功した強いプレッシャーの割合（ボール保持者から0～2メートル以内）',
      LightOnBallPressuresPct: '成功したプレッシャーの割合（ボール保持者から2～5メートル以内）',
      TimesBypassedByPasses: 'パスによって突破された合計回数',
      TimesBypassedByCarries: 'ドリブルによって突破された合計回数',
      TimesBypassedByActions: 'パスとドリブルの合計で突破された合計回数',
      BypassedPlayersByCarries: 'ドリブルで突破された相手（DFとMF）の合計人数',
      BypassedDefendersByCarries: 'ドリブルで突破された相手（DF）の合計人数',
      BypassedPlayersByActions: 'パスとドリブルの合計で突破された相手（DFとMF）の合計人数',
      BypassedDefendersByActions: 'パスとドリブルの合計で突破された相手（DF）の合計人数',
      CarriesBypassingPlayers: '相手選手を突破したドリブルの回数',
      CarriesBypassingDefenders: 'DFを突破したドリブルの回数',
      BypassedPlayersPerCarry: '1回のドリブルで突破した相手選手の平均数',
      BypassedDefendersPerCarry: '1回のドリブルで突破したDFの平均数',
      LineBreakingCarries: '守備ラインを突破したドリブルの回数',
      LineBreakingCarriesMD: 'MFラインとDFラインを突破したドリブルの回数',
      LineBreakingCarriesM: 'MFラインを突破したドリブルの回数',
      LineBreakingCarriesD: 'DFラインを突破したドリブルの回数',
      LineBreakingCarriesPerCarry: 'ドリブルごとのライン間突破率',
      LineBreakingActions: '守備ラインを突破したパスとドリブルの合計回数',
      LineBreakingActionsMD: 'MFラインとDFラインを突破したパスとドリブルの合計回数',
      LineBreakingActionsM: 'MFラインを突破したパスとドリブルの合計回数',
      LineBreakingActionsD: 'DFラインを突破したパスとドリブルの合計回数',
      PassesPerLineBreakingPass: 'ライン間突破パス1本あたりの全パス数の比率',
      CarriesPerLineBreakingCarry: 'ライン間突破ドリブル1本あたりの全ドリブル数の比率',
      LinesBrokenByPasses: 'パスで突破したラインの合計数',
      LinesBrokenByCarries: 'ドリブルで突破したラインの合計数',
      LinesBrokenByActions: 'パスとドリブルの合計で突破したラインの合計数',
      LinesBrokenPerPass: '1本のパスで突破したラインの平均数',
      LinesBrokenPerCarry: '1本のドリブルで突破したラインの平均数',
      AvgLastDefenderDistanceIP: '最後のディフェンダー（自陣ゴールに最も近い選手）とゴールラインの距離（ボール保持時）',
      AvgLastDefenderDistanceOOP: '最後のディフェンダー（自陣ゴールに最も近い選手）とゴールラインの距離（非保持時）',
      AvgDefensiveLineDistanceIP: '最も深いディフェンスラインとゴールの距離（ボール保持時）',
      AvgDefensiveLineDistanceOOP: '最も深いディフェンスラインとゴールの距離（非保持時）',
      AvgRBDistanceIP: '右サイドバックと自陣ゴールの距離（ボール保持時）',
      AvgRBDistanceOOP: '右サイドバックと自陣ゴールの距離（非保持時）',
      AvgLBDistanceIP: '左サイドバックと自陣ゴールの距離（ボール保持時）',
      AvgLBDistanceOOP: '左サイドバックと自陣ゴールの距離（非保持時）',
      AvgBlockDistanceIP: '最も後方と最も前方のフィールドプレーヤー間の距離（ボール保持時）',
      AvgBlockDistanceOOP: '最も後方と最も前方のフィールドプレーヤー間の距離（非保持時）',
      AvgBlockAreaIP: '全フィールドプレーヤーを囲むバウンディングボックスの面積（チームの占有スペース）ボール保持時',
      AvgBlockAreaOOP: '全フィールドプレーヤーを囲むバウンディングボックスの面積（チームの占有スペース）非保持時',
      AvgDefensiveLineWidthOOP: '最も後方の選手ラインの横幅（非保持時）',
      AvgOffensiveLineLastThirdWidthIP: '最終サードにおけるオフェンスラインの横幅（ボール保持時）',
      AvgLByIP: '左サイドバックの位置（ボール保持時）',
      AvgRByIP: '右サイドバックの位置（ボール保持時）',
      AvgOffensiveLineDistanceIP: '自陣ゴールとオフェンスライン間の距離（ボール保持時）',
      AvgOffensiveLineLastThirdDistanceIP: '自陣ゴールと最終サードのオフェンスラインの距離（ボール保持時）',
      AvgOffensiveLineWidthIP: 'オフェンスラインの横幅（ボール保持時）',
      OffBallRuns: '攻撃をサポートする意図的なオフザボールの動き（ラン）',
      OffBallRunsOverlap: '味方がボールを持っている際に、サイドライン側（外側）を回って走る動き',
      OffBallRunsUnderlap: '味方の内側（ピッチ中央側）を通って走る動き',
      OffBallRunsRunAhead: 'ボール保持者を追い越して前に出るが、最終ラインより手前で止まる動き',
      OffBallRunsRunBehind: '最終ディフェンスラインを突破し、ディフェンダーとゴールキーパーの間に入る動き',
      OffBallRunsCrossReceiver: 'クロスを受けるためにエリア内に走り込む動き',
      OffBallRunsSupport: 'ボール保持者に並ぶ位置へ走り、近くでパスの選択肢となる動き',
      OffBallRunsComingShort: 'ボール保持者に近づいてサポートやパスの受け手となる動き',
      AerialsOppHalf: '間での敵陣で繰り広げられる空中戦',
      xP: 'パス期待値 (xP) は、パスが終了するフィールドの部分に基づいてパスの品質を測定します',
      DribblesAttempted: 'ドリブル試行回数',
      CarriesIntoFinalThird: '外側から最後の 3 分の 1 の内側まで少なくとも 7 メートルのパイプライン',
      SpeedScore: 'さまざまなスピード指標に基づいたプレーヤーの身体パフォーマンス',
      EnduranceScore: 'さまざまな指標に基づいたプレーヤーの持久力の身体パフォーマンス',
      GoalsConceded: '失点数',
      HeadedGoals: '頭で決めたゴール数',
      SavesInBox: 'ボックス内シュートのセーブ数',
      SavesOutBox: 'ボックス外シュートのセーブ数',
      ShotsOnTargetInBoxAgainst: '失点したボックス内からの枠内シュートの数',
      ShotsOnTargetOutBoxAgainst: 'ボックス外からの枠内シュートの失点数',
      SwitchPlaySuccessful: 'ボールの横方向の変位が相手ゴールに向かう変位よりも大きい、32 メートルを超える完了したパスの数',
      SwitchPlayTotal: 'ボールの横方向の変位が相手ゴールに向かう変位よりも大きい、32 メートルを超えるパスの試行回数の合計',
      PassesInsideOppHalf: '相手陣内で開始および終了するパスの合計数',
      PassesInsideOppHalfSuccessful: '相手陣内で開始および終了するパスの完了数',
      TacklesAttemptedFirstThird: 'ピッチの最初の 3 分の 1 で試行されたタックルの合計数',
      TacklesAttemptedSecondThird: 'ピッチの 2/3 分の 2 で試行されたタックルの合計数',
      TacklesFirstThird: 'ピッチの最初の 3 分の 1 で成功したタックルの数',
      TacklesSecondThird: 'ピッチの 2/3 分の 2 で成功したタックルの数',
      FoulsOwnHalf: '自陣で犯したファウルの数',
      TouchesOppHalf: '敵陣でのボールタッチ数',
      TacklesAttemptedNotAdjusted: 'ポゼッション調整なしのタックル試行の合計数',
      TacklesSuccessfulNotAdjusted: '成功したタックルの総数（ポゼッション調整なし）',
      AvgTop5MaxSpeed: 'プレーヤーの最高 5 つの最大速度の平均',
      LBPReceived: '受信した改行パスの数',
      LBPMReceived: '相手の中盤ラインを突破したパスを受けた数',
      LBPMDReceived: '相手の中盤とディフェンスラインの両方を突破したパスを受けた数',
      ThroughBallReceived: '相手の最終ディフェンスラインを突破したパスの受領数',
      ShortPassesSuccessful: 'ショートパス（12メートル未満）の成功数',
      PassingSuccessForwardPct: 'フォワードパス成功率',
      PassingSuccessBackwardPct: 'バックワードパスの成功率',
      PassingForwardBackwardPct: '前方パスと後方パスの比率',
      LongBallPerPassesPct: 'パス総数に対するロングボールの割合',
      LongBallReceivedOppHalf: 'ライバルフィールドでのロングボールレシーブ数',
      OffensiveActions: '攻撃的な行為',
      SuccessfulDribblesPct: 'ドリブル成功数/ドリブル試行回数の合計',
      OffensiveTouchesOutBoxPct: 'ボックス外でのオフェンスタッチの割合（%）',
      HsrDistanceIP: 'ポゼッション時のスプリント距離 > 21 km/h',
      HsrDistanceOOP: 'ポゼッション時以外のスプリント距離 > 21 km/h',
      JoggingDistanceIP: '保有ジョギング距離',
      JoggingDistanceOOP: '所有権外のジョギング距離',
      RunningDistanceIP: '所持時の走行距離',
      RunningDistanceOOP: 'ポゼッション外の走行距離',
      SprintsDistanceIP: 'ポゼッション時のスプリント距離 > 24 km/h',
      SprintsDistanceOOP: 'ポゼッション時以外のスプリント距離 > 24 km/h',
      WalkingDistanceIP: '所持時の歩行距離',
      WalkingDistanceOOP: '所有権外の歩行距離',
      PossessionRegain: '相手にボールを奪われた回数',
      HandPassesSuccessful: 'ハンドによる成功したパス (ゴールキーパーまたはセットプレーでのスロー)',
      HandPassesTotal: 'ハンドで行われたパスの総数 (ゴールキーパーまたはセットプレーでのスロー)',
      InterceptionsNotAdjusted: 'Number of times the player intercepts a pass to prevent the ball reaching its target',
      Clearances: 'Number of times the player hits the ball clear of the defensive zone',
      ClearancesNotAdjusted: 'Number of times the player hits the ball clear of the defensive zone',
      RecoveriesNotAdjusted: 'Number of balls recovered by a player (via Tackles or Interceptions)'
    },
    abbr: {
      Possession: 'POS%',
      TimePossession: 'TP',
      PassesPerShots: 'PPS',
      PPDA: 'PPDA',
      ExpectedPoints: 'XP',
      Points: 'P',
      Directness: 'DIR',
      PassesPerLongBall: 'PPLB',
      CrossingPerXG: 'CPxG',
      PenaltySavedPenaltyFaced: 'PSPF',
      Goals: 'GOA',
      PenaltyShots: 'PS',
      PenaltyGoals: 'PG',
      NonPenaltyGoals: 'NPG',
      NPGOpenPlay: 'NPGOP',
      NPGSetPiece: 'NPGSP',
      Shooting: 'SHO%',
      Finishing: 'FIN%',
      xGEfficiency: 'xGE',
      HeaderPerShot: 'HPS',
      HeaderPerCross: 'HPC',
      Assists: 'ASS',
      ThroughBalls: 'TB',
      CrossEfficiency: 'CE',
      ScoringContribution: 'SC',
      xAssistsOpenPlay: 'xAOP',
      xAssistsSetPiece: 'xASP',
      xAssistsOpenPlayInTeam: 'xAOPiT',
      xAssistsSetPieceInTeam: 'xASPiT',
      xGBuildupFinalThird: 'xGBUPFT',
      xGChainFinalThird: 'xGCFT',
      BallProgressionPassing: 'BPP',
      BallProgressionDribbling: 'BPD',
      TacklesWasDribbled: 'TWD%',
      TacklesSuccessful: 'STA',
      Interceptions: 'INT',
      Clearances: 'CLE',
      Fouls: 'FOU',
      Recoveries: 'REC',
      Shots: 'SHO',
      ShotsPerGoal: 'SPG',
      ShortPassesSuccessful: 'SPS',
      PassingSuccessForwardPct: 'PSF%',
      PassingSuccessBackwardPct: 'PSB%',
      PassingForwardBackwardPct: 'PFB%',
      LongBallPerPassesPct: 'LBP%',
      LongBallReceived: 'LBR',
      LongBallReceivedOppHalf: 'LBROH',
      OffensiveActions: 'OA',
      DribblesAttempted: 'DAT',
      SuccessfulDribblesPct: 'SD%',
      OffensiveTouchesOutBoxPct: 'OTOB%',
      BallRetention: 'BR',
      PassingPct: 'PA%',
      PassingOwnHalfPct: 'POH%',
      PassingOppHalfPct: 'POPH%',
      PassingFinalThird: 'PFT',
      PassesFinalThirdTotal: 'PFTT',
      PassingFinalThirdPct: 'PT%',
      LongBallSuccessful: 'LBS',
      LongBallPct: 'LB%',
      LongBallTotal: 'TLB',
      SavesPct: 'S%',
      SavesInBoxPct: 'SIB%',
      SavesOutOfBoxPct: 'SOOB%',
      xGSavedPerXGFacedOnTarget: 'xGSPFOT',
      xGFacedOnTargetPerGoalReceived: 'xGFOTPGR',
      xGFacedOnTargetEfficiency: 'xGFOTE',
      xGFacedOnTarget: 'xGFOT',
      IndividualPressure: 'IP',
      AerialEfficiency: 'AE',
      AerialWins: 'AEW',
      AerialWinsPct: 'AE%',
      xG: 'xG',
      xGDiff: 'xGD',
      xGOpenPlay: 'xGOP',
      xGSetPiece: 'xGSP',
      xGPerShot: 'xGPS',
      ChancesCreated: 'CC',
      CompletedCrosses: 'SCR',
      Crossing: 'CR%',
      OpenPlayKeyPasses: 'OPKP',
      OpenPlayKeyPassesInTeam: 'OPKPiT%',
      OpenPlayPassesIntoOpponentBox: 'OPPOPPB',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'OPPOPPBS',
      xAssists: 'xA',
      xGChain: 'xGC',
      xGBuildup: 'xGBUP',
      xGBuildupInTeam: 'xGBUPiT',
      BallProgression: 'BP',
      SuccessfulDribbles: 'SDR',
      Dispossessed: 'TOV',
      TouchesInOpponentBox: 'TOB',
      xGSavedPerShot: 'xGSS',
      BallRetentionOppHalf: 'BROPPH',
      DeepProgression: 'DP',
      DeepProgressionFinalThird: 'DPFT',
      FoulsTaken: 'FOUR',
      PenaltiesTaken: 'PT',
      BlockedCrosses: 'BC',
      BlockedShots: 'BS',
      Blocks: 'BLO',
      NonPenaltyGoalsAgainst: 'NPGC',
      Headers: 'HEA',
      AveragePassDistance: 'APD',
      ProgressiveRuns: 'PRC',
      xT: 'xT',
      xTOpenPlay: 'xTOP',
      xTSetPiece: 'xTSP',
      xGOT: 'xGOT',
      BadActions: 'BA',
      BadActionsOwnHalf: 'BAOH',
      AerialsWonOwnBox: 'AWOB',
      AerialsWonOppBox: 'AWOPPB',
      AerialsTotalOppBox: 'ATOPPB',
      AerialsTotalOwnBox: 'ATOB',
      FoulsOwnHalfPct: 'FOH%',
      RecoveriesOppHalf: 'ROH',
      DuelsPct: 'D%',
      TacklesUnsuccessful: 'UTA',
      TacklesWasDribbledFirstThird: 'TWDFT',
      TacklesWasDribbledSecondThird: 'TWDST',
      TacklesWasDribbledFinalThird: 'TWDFT',
      BallProgressionFinalThird: 'BPFT',
      DuelsTotal: 'DT',
      QuickRecoveries: 'QR',
      ShotsPerNPG: 'SPNPG',
      ShotsOutBox: 'SOB',
      GoalsOutBox: 'GOB',
      ShootingOutBox: 'SOB%',
      HandPassing: 'HP',
      Catching: 'CAT',
      Caught: 'CAU',
      ClaimAccuracy: 'CA',
      HighTurnovers: 'HTOV',
      ShotEndingHighTurnovers: 'SEHT',
      GoalEndingHighTurnovers: 'GEHT',
      AverageCarriesProgress: 'ACP',
      ChanceEndingCarries: 'CEC',
      AssistEndingCarries: 'AEC',
      ShotEndingCarries: 'SEC',
      GoalEndingCarries: 'GEC',
      ShotEndingSequence: 'SES',
      GoalEndingSequence: 'GES',
      xGPerNPG: 'xGPNPG',
      AerialWonOffensive: 'AWO',
      AerialWonDefensive: 'AWD',
      xGAgainst: 'xGC',
      xGDiffAgainst: 'xGDC',
      xGPerNPGAgainst: 'xGPNPGA',
      xGOpenPlayAgainst: 'xGOPC',
      xGSetPieceAgainst: 'xGSPC',
      xGPerShotAgainst: 'xGSC',
      ShotsAgainst: 'STC',
      ShotsOnTargetAgainst: 'SOTC',
      RivalPossession: 'RP',
      AerialDefensivePct: 'AD%',
      HighRecoveries: 'HR',
      HighDefensiveActions: 'HDA',
      HighDefensiveActionPct: 'HDA%',
      HighDefensiveDistance: 'HDD',
      PassesPerPossession: 'PPP',
      LengthPerPossession: 'LPP',
      xTNet: 'xTN',
      AvgCarriesDistance: 'ACD',
      PassesForwardPct: 'PF%',
      PassesForwardSuccessful: 'SFP',
      PassesForwardTotal: 'TFP',
      TacklesAttempted: 'ATA',
      DuelsLost: 'DL',
      Carries: 'CARR',
      CarriesPct: 'CARR%',
      Aerials: 'AER',
      ProgressivePassesReceivedIntoBox: 'PPRIB',
      PassesOppHalf: 'POPH',
      ShotsOnTarget: 'SOT',
      AggressiveActions: 'AA',
      Crosses: 'CRO',
      xGBuildup5pass: 'xGBUP5',
      DefensiveDistance: 'DD',
      SpeedSequence: 'SS',
      Touches: 'TOU',
      AerialsTotalOppHalf: 'ATOPPH',
      AerialsWonOppHalf: 'AWOPPH',
      AerialsWonOppHalfPct: 'AWOH%',
      AerialsPctOppBox: 'AOPPB%',
      AerialsPctOwnBox: 'AOB%',
      AerialDefensive: 'AD',
      AerialOffensive: 'AO',
      AerialOffensivePct: 'AO%',
      IndividualPressureOppHalf: 'IPOPPH',
      ChancesCreatedOP: 'CCOP',
      TouchesPerShot: 'TPS',
      PassesFinalThirdTotalPct: 'PFT%',
      xACrosses: 'xAC',
      Passes: 'PAS',
      PassesSuccessful: 'SPA',
      TacklesWasDribbledFouls: 'TWDF',
      OffsidesCaught: 'OC',
      ProgressivePassesReceivedFinalThird: 'PPRFT',
      ProgressivePassesReceived: 'PPR',
      Breadth: 'BRD',
      DuelsDefTotal: 'DDT',
      DefensiveActions: 'DA',
      ProgressivePassesReceivedOppHalf: 'PPROH',
      CompletedCrossesOP: 'CCOP',
      CrossingOP: 'COP',
      CrossesOP: 'COP',
      PassingContribution: 'PC',
      BallProgressionOppHalfInTeam: 'BPOPPHiT',
      PassesOPIntoBoxInTeam: 'POBIT',
      TouchesOppBoxInTeam: 'TOBIT',
      xGOPInTeam: 'xGOPiT',
      DeepPasses: 'DP',
      DeepPassesTotal: 'DPCT',
      DefensiveDuelsPct: 'DD%',
      QuickRecoveriesPct: 'QR%',
      DiffDefensiveDistanceTeam: 'DDDT',
      xTPassing: 'xTP',
      xTPassing100Passes: 'xTP100',
      ProgressivePassesAccurate: 'APP',
      xP: 'xP',
      PassAbility: 'PA',
      OPPassesIntoOppBoxPct: 'OPPIOB%',
      EntriesOppBox: 'EOPPB',
      Crosses6yardBox: 'C6YB',
      Cutbacks: 'CUT',
      xTDribbling: 'xTD',
      AvgShotDistance: 'ASD',
      xGOnTarget: 'xGOT',
      FinishingxGOT: 'FxGOT',
      DribblesWonOwnHalf: 'DWOH',
      DribblesOwnHalf: 'DOH',
      DribblesOwnHalfPct: 'DOH%',
      DribblesWonOppHalf: 'DWOPH',
      DribblesOppHalf: 'DOPH',
      DribblesOppHalfPct: 'DOPH%',
      DribblesWonFinalThird: 'DWFT',
      DribblesFinalThird: 'DFT',
      DribblesFinalThirdPct: 'DFT%',
      ShotEndingHighRecoveries: 'SEHR',
      PassingFinalThirdAgainst: 'PFTC',
      OpenPlayPassesIntoOpponentBoxAgainst: 'OPPOBC',
      EntriesOppBoxAgainst: 'EOBC',
      DeepProgressionAgainst: 'DPC',
      TouchesInOpponentBoxAgainst: 'TOBC',
      Score: 'SCO',
      PDScore: 'SCO',
      OrlegiScore: 'SCO',
      SirScore: 'SCO',
      ExcScore: 'SCO',
      xTOPInTeam: 'xTOPiT',
      YellowCards: 'YC',
      RedCards: 'RC',
      xTOpenPlayAgainst: 'xTOPC',
      xTSetPieceAgainst: 'xTSPC',
      NPGOpenPlayAgainst: 'NPG OPC',
      NPGSetPieceAgainst: 'NPG SPC',
      PassesOppHalfPerPossession: 'POHP',
      AverageTimeRecovery: 'ATR',
      ExpectedPassing: 'xP%',
      NumPossession10Passes: 'P10P',
      PassesReceived: 'PR',
      PassesReceivedFinalThird: 'PRLFT',
      ProgressivePassesTotalPct: 'PP%',
      ShortPassesPct: 'SP%',
      TouchesOppBoxOppTeam: 'TOBOT',
      ShotsOnTargetOppTeam: 'SOTOT',
      NPGOppTeam: 'NPGOT',
      xGSetPiecePerxG: 'xGSPPxG',
      ShotsOpenPlay: 'SOP',
      ShotsOpenPlayAgainst: 'SOPA',
      ShotsFromDribble: 'SFD',
      GoalsFromDribble: 'GFD',
      PassesIntoFinalThird: 'PIFT',
      PassesIntoFinalThirdTotal: 'PIFTT',
      PassesInsideFinalThird: 'PINSFT',
      PassesInsideFinalThirdTotal: 'PINSFTT',
      PassesFinalThirdNoArea: 'PFTNA',
      PassesIntoOppBox: 'PIOB',
      CarriesFinalThird: 'CFT',
      CarriesInsideFinalThird: 'CINSFT',
      CarriesFinalThirdNoBox: 'CFTNB',
      CarriesIntoOppBox: 'CIOB',
      TimePossessionAgainst: 'TPA',
      TimePossessionTotal: 'TPT',
      PassesInBox: 'PIB',
      LongThrowInSuccessful: 'LTInS',
      LongThrowInTotal: 'LTInT',
      LongThrowInPct: 'LTIn%',
      Games: 'GAM',
      PointsPerGame: 'PPG',
      ExpectedPointsDiff: 'XPD',
      PassesTotalOwnHalf: 'PTOH',
      PassesOwnHalf: 'POH',
      PassesTotalOppHalf: 'プトップフ',
      ProgressivePassesTotal: 'TPP',
      DuelsWon: 'DW',
      NonPenaltySaves: 'NPS',
      BadActionsOppHalf: 'バオップ',
      CarriesSuccessful: 'CS',
      ShotsOnTargetOutBox: 'ソトブ',
      TotalDistance: 'DST',
      WalkingDistance: 'WLKD',
      JoggingDistance: 'JOGD',
      RunningDistance: 'RUND',
      ExtremeAccelerations: 'XACC',
      NumberOfRuns: 'RUNQ',
      HsrDistance: 'HSRD',
      HsrNumber: 'HSRQ',
      HsrDistancePct: 'HSRD%',
      SprintsNumber: 'SPRQ',
      SprintsDistance: 'SPRD',
      SprintNumberDeclinePct: 'SQD%',
      SprintDistanceDeclinePct: 'SDD%',
      SprintNumberDecline: 'SQD',
      SprintDistanceDecline: 'SDD',
      SprintDistancePct: 'SPRD%',
      Accelerations: 'ACC',
      MaxSpeed: 'MS',
      AvgMaxSpeed: 'AvgMS',
      MaxAccelerations: 'MACC',
      HeadedGoals: 'HG',
      GoalsConceded: 'GC',
      SavesInBox: 'SIB',
      SavesOutBox: 'SOB',
      BypassedPlayersByPasses: 'ByPP',
      BypassedDefendersByPasses: 'ByPD',
      PassesBypassingPlayers: 'PByPP',
      PassesBypassingDefenders: 'PByPD',
      BypassedPlayersPerPass: 'ByPPPP',
      BypassedDefendersPerPass: 'ByPDPP',
      LineBreakingPasses: 'LBP',
      LineBreakingPassesMD: 'LBPMD',
      LineBreakingPassesM: 'LBPM',
      LineBreakingThroughBalls: 'LBTB',
      LineBreakingPassesPerPass: 'LBPP',
      TotalPassesUnderStrongPressure: 'TPUSP',
      TotalPassesUnderLightPressure: 'TPUP',
      SuccessfulPassesUnderStrongPressure: 'SPUSP',
      SuccessfulPassesUnderLightPressure: 'SPULP',
      PassingUnderStrongPressure: 'PUSP%',
      PassingUnderLightPressure: 'PULP%',
      PassReceiptsInSpaceCompleted: 'PRMS',
      PassReceiptsInSpace: 'PRS',
      PassReceiptsInSpaceCompletedFirstThird: 'PRSC1T',
      PassReceiptsInSpaceCompletedSecondThird: 'PRSC2T',
      PassReceiptsInSpaceCompletedFinalThird: 'PRSC3T',
      PassReceiptsInSpaceCompletedOppHalfRight: 'PRSCOHR',
      PassReceiptsInSpaceCompletedOppHalfCenter: 'PRSCOHC',
      PassReceiptsInSpaceCompletedOppHalfLeft: 'PRSCOHL',
      PassReceiptsInSpaceFirstThird: 'PRS1T',
      PassReceiptsInSpaceSecondThird: 'PRS2T',
      PassReceiptsInSpaceFinalThird: 'PRS3T',
      PassReceiptsInSpaceOppHalfRight: 'PRSOHR',
      PassReceiptsInSpaceOppHalfCenter: 'PRSOHC',
      PassReceiptsInSpaceOppHalfLeft: 'PRSOHL',
      TotalStrongOnBallPressures: 'TSBP',
      TotalLightOnBallPressures: 'TBP',
      SuccessfulStrongOnBallPressures: 'SSBP',
      SuccessfulLightOnBallPressures: 'SLBP',
      StrongOnBallPressuresPct: 'SBP%',
      LightOnBallPressuresPct: 'BP%',
      TimesBypassedByPasses: 'ByPPAS',
      TimesBypassedByCarries: 'ByPC',
      TimesBypassedByActions: 'ByPA',
      BypassedPlayersByCarries: 'ByPPC',
      BypassedDefendersByCarries: 'ByPDC',
      BypassedPlayersByActions: 'ByPPA',
      BypassedDefendersByActions: 'ByPDA',
      CarriesBypassingPlayers: 'CByPP',
      CarriesBypassingDefenders: 'CByPD',
      BypassedPlayersPerCarry: 'ByPPPC',
      BypassedDefendersPerCarry: 'ByPDPC',
      LineBreakingCarries: 'LBC',
      LineBreakingCarriesMD: 'LBCMD',
      LineBreakingCarriesM: 'LBCM',
      LineBreakingCarriesD: 'LBCD',
      LineBreakingCarriesPerCarry: 'LBCC%',
      LineBreakingActions: 'LBA',
      LineBreakingActionsMD: 'LBAMD',
      LineBreakingActionsM: 'LBAM',
      LineBreakingActionsD: 'LBAD',
      PassesPerLineBreakingPass: 'PPLBP',
      CarriesPerLineBreakingCarry: 'CPLBC',
      LinesBrokenByPasses: 'LBByP',
      LinesBrokenByCarries: 'LBByC',
      LinesBrokenByActions: 'LBByA',
      LinesBrokenPerPass: 'LBPP',
      LinesBrokenPerCarry: 'LBPC',
      AvgLastDefenderDistanceIP: 'ALDDIP',
      AvgLastDefenderDistanceOOP: 'ALDDIP',
      AvgDefensiveLineDistanceIP: 'ALDDIP',
      AvgDefensiveLineDistanceOOP: 'ALDDIP',
      AvgRBDistanceIP: 'ARBDIP',
      AvgRBDistanceOOP: 'ARBDOOP',
      AvgLBDistanceIP: 'ALBDIP',
      AvgLBDistanceOOP: 'ALBDOOP',
      AvgBlockDistanceIP: 'ABDIP',
      AvgBlockDistanceOOP: 'ABDOOP',
      AvgBlockAreaIP: 'ABAIP',
      AvgBlockAreaOOP: 'ABAOOP',
      AvgDefensiveLineWidthOOP: 'ADLWOOP',
      AvgOffensiveLineLastThirdWidthIP: 'AOLLTWIP',
      AvgLByIP: 'ALBIP',
      AvgRByIP: 'ARBIP',
      AvgOffensiveLineDistanceIP: 'AOLDIP',
      AvgOffensiveLineLastThirdDistanceIP: 'AOLTDIP',
      AvgOffensiveLineWidthIP: 'AOLWIP',
      OffBallRuns: 'OBR',
      OffBallRunsOverlap: 'OBRO',
      OffBallRunsUnderlap: 'OBRU',
      OffBallRunsRunAhead: 'OBRA',
      OffBallRunsRunBehind: 'OBRB',
      OffBallRunsCrossReceiver: 'OBRCR',
      OffBallRunsSupport: 'OBRS',
      OffBallRunsComingShort: 'OBRCS',
      AerialsOppHalf: 'AOPPH',
      SpeedScore: 'SSCO',
      EnduranceScore: 'ESCO',
      HeadedShots: 'HS',
      CarriesIntoFinalThird: 'CIF⅓',
      SwitchPlaySuccessful: 'SPS',
      SwitchPlayTotal: 'SPT',
      PassesInsideOppHalf: 'PiOH',
      PassesInsideOppHalfSuccessful: 'PiOHS',
      TacklesAttemptedFirstThird: 'TAF⅓',
      TacklesAttemptedSecondThird: 'TAS⅓',
      TacklesFirstThird: 'TF⅓',
      TacklesSecondThird: 'TS⅓',
      FoulsOwnHalf: 'FOH',
      TouchesOppHalf: 'TOPPH',
      TacklesAttemptedNotAdjusted: 'TANA',
      TacklesSuccessfulNotAdjusted: 'TSNA',
      AvgTop5MaxSpeed: 'AT5MS',
      LBPReceived: 'LBPR',
      LBPMReceived: 'LBPMR',
      LBPMDReceived: 'LBPMDR',
      ThroughBallReceived: 'TBR',
      DistanceIP: 'DST IP',
      WalkingDistanceIP: 'WLKD IP',
      JoggingDistanceIP: 'JOGD IP',
      RunningDistanceIP: 'RUND IP',
      HsrDistanceIP: 'HSRD IP',
      SprintsDistanceIP: 'SPRD IP',
      RunningNumberIP: 'RUNQ IP',
      HsrNumberIP: 'HSRQ IP',
      SprintsNumberIP: 'SPRQ IP',
      DistanceOOP: 'DST OOP',
      WalkingDistanceOOP: 'WLKD OOP',
      JoggingDistanceOOP: 'JOGD OOP',
      RunningDistanceOOP: 'RUND OOP',
      HsrDistanceOOP: 'HSRD OOP',
      SprintsDistanceOOP: 'SPRD OOP',
      RunningNumberOOP: 'RUNQ OOP',
      HsrNumberOOP: 'HSRQ OOP',
      SprintsNumberOOP: 'SPRQ OOP',
      PossessionRegain: 'PR',
      HandPassesSuccessful: 'SHP',
      HandPassesTotal: 'THP',
      InterceptionsNotAdjusted: 'INT',
      ClearancesNotAdjusted: 'CLE',
      RecoveriesNotAdjusted: 'REC'
    },
    AerialsOppHalf: '敵陣での空中戦',
    xP: 'パス成功期待値',
    CarriesIntoFinalThird: '最後まで 1/3 までドライブ',
    scoreDifference: 'スコアの差: このゲームのパフォーマンスがシーズン平均を上回ったか下回ったかを示します。',
    SpeedScore: 'スピードパワースコア',
    EnduranceScore: '耐久スコア',
    HeadedShots: 'ヘディングショット',
    HeadedXG: '頭付きxG',
    HeadedSetPieceTooltip: 'セットプレーからヘディングシュートを決めた選手のみを表示',
    SwitchPlaySuccessful: 'スイッチプレイが成功しました',
    SwitchPlayTotal: 'スイッチプレイ合計',
    PassesInsideOppHalf: 'オップハーフ内にパス',
    PassesInsideOppHalfSuccessful: 'OPP 内へのパスが半分成功',
    TacklesAttemptedFirstThird: '最初に試みたタックル 1/3',
    TacklesAttemptedSecondThird: 'タックル試行数 2 番目 1/3',
    TacklesFirstThird: '最初にタックル成功 1/3',
    TacklesSecondThird: 'タックル成功 2 番目 1/3',
    FoulsOwnHalf: 'オウンハーフのファウル',
    TouchesOppHalf: 'オップハーフにタッチ',
    TacklesAttemptedNotAdjusted: '試行したタックルは調整されていない',
    TacklesSuccessfulNotAdjusted: '成功したタックルは調整されていません',
    AvgTop5MaxSpeed: '平均トップ 5 最大速度',
    LBPReceived: 'ラインブレイクパスの受信数',
    LBPMReceived: 'ラインブレイクパス (M ライン) の受信数',
    LBPMDReceived: '受信した改行パス (MD ライン)',
    ThroughBallReceived: 'スルーボールレシーブ',
    recoveriesRate: '回収率',
    turnoversRate: '損失率',
    HsrDistanceIP: 'HSR 距離 IP',
    HsrDistanceOOP: 'HSR 距離 OOP',
    JoggingDistanceIP: 'ジョギング距離 IP',
    JoggingDistanceOOP: 'ジョギング距離 OOP',
    RunningDistanceIP: '走行距離IP',
    RunningDistanceOOP: '走行距離OOP',
    SprintsDistanceIP: 'スプリント距離IP',
    SprintsDistanceOOP: 'スプリント距離 OOP',
    WalkingDistanceIP: '歩行距離IP',
    WalkingDistanceOOP: '徒歩距離 OOP',
    PossessionRegain: 'ポゼッションを取り戻す',
    HandPassesSuccessful: 'ハンドパスの成功',
    HandPassesTotal: 'ハンドパス',
    SprintsNumberIP: 'スプリント数量IP',
    SprintsNumberOOP: 'スプリント数量 OOP',
    RunningNumberIP: '実行数量IP',
    RunningNumberOOP: '実行数量 OOP',
    HsrNumberIP: 'HSR 数量 IP',
    HsrNumberOOP: 'HSR 数量 OOP',
    InterceptionsNotAdjusted: 'Interceptions',
    ClearancesNotAdjusted: '',
    RecoveriesNotAdjusted: 'Recoveries'
  },
  team: {
    title: 'チームシート',
    subtitle: 'チームの特徴や統計をより深く知る',
    averageAge: '平均年齢',
    transferBalance: '移籍収支',
    roster: '登録選手',
    stadium: 'スタジアム',
    coach: 'コーチ',
    transfers: '移籍',
    trends: 'トレンド',
    loans: 'レンタル移籍',
    loanFrom: 'レンタル',
    loanTo: 'レンタル',
    latestGames: '最近の試合',
    latestXGames: '最近の {0} 試合',
    playingFor: 'Juega para',
    overview: '概要',
    visualization: '視覚化',
    location: '位置',
    outcome: '結果',
    beeswarm: 'グラフ',
    parentTeam: '最初のチーム',
    childTeam: '下年代のチーム',
    preferredFormation: 'よく使うフォーメーション',
    mostFrecuentFormations: '最も多いフォーメーション',
    viewType: 'ビュータイプ',
    overviewTab: {
      axisXTotal: 'トータル',
      axisXper90: '90で\'',
      dataPerGameText: '試合毎のデータ',
      season: 'シーズン',
      last: '最後の',
      current: '現在',
      TeamStyle: 'スタイル',
      TeamDefensive: '守備',
      TeamOffensive: '攻撃',
      TeamCustom1: 'カスタム 1',
      TeamCustom2: 'カスタム 2',
      TeamCustom3: 'カスタム 3',
      TeamCustom4: 'カスタム 4',
      coach: 'コーチ',
      groups: {
        Goals: {
          name: 'ゴール',
          desc: 'すべてのゴールが表示されます。(インプレーとセットプレーの両方、PK含む)'
        },
        Assists: {
          name: 'アシスト',
          desc: '今シーズン最も多くのアシストをした選手。(インプレーとセットプレー) '
        },
        xG: {
          name: 'ゴール期待値',
          desc: 'インプレーとセットプレーでのゴール期待値。合計 xG の降順で表示します。'
        },
        xA: {
          name: 'アシスト期待値',
          desc: 'インプレーとセットプレーでのアシスト期待値。'
        },
        Finishing: {
          name: 'フィニッシング',
          desc: 'シュートがゴールに入った割合'
        },
        ScoringContribution: {
          name: 'ゴールへの貢献',
          desc: 'チームのアシスト数とゴール数'
        },
        xT: {
          name: '脅威期待値',
          desc: 'インプレーとセットプレー、ネガティブで生まれた脅威期待値'
        }
      },
      stats: {
        openPlay: 'インプレー',
        setPiece: 'セットプレー',
        negative: 'ネガティブ',
        npg: 'PK抜きのゴール',
        goalsPenalty: 'PKでのゴール',
        npgOpenPlay: 'インプレーでのゴール（PK抜き）',
        npgSetPiece: 'セットプレーでのゴール（PK抜き）',
        assists: 'アシスト',
        assistsConceded: '失球アシスト数',
        assistsOpenPlay: 'インプレーでのアシスト',
        assistsSetPiece: 'セットプレーでのアシスト',
        xGOpenPlay: 'インプレー xG ',
        xGSetPiece: 'セットプレー xG ',
        xAOpenPlay: 'インプレー xA ',
        xASetPiece: 'セットプレー xA ',
        xAConceded: '失球xA数',
        nonPenaltyShots: 'PKを除くシュート数',
        penaltyShots: 'PKでのシュート',
        xT: '脅威期待値',
        xTOpenPlay: 'インプレー xT ',
        xTSetPiece: 'セットプレー xT ',
        xTNeg: 'ネガティブ xT ',
        totalFinishing: 'フィニッシング',
        nonPenaltyFinishing: 'PK抜きのフィニッシング',
        goalsPenaltyFinishing: 'PKでのフィニッシング',
        goal: 'ゴール',
        notGoal: '目標ではない',
        chance: 'チャンス',
        finished: '終了した',
        notFinished: '未完了',
        walkingDistance: '歩行',
        joggingDistance: 'ジョギング',
        runningDistance: 'ランニング',
        hsrDistance: 'HSR',
        sprintsDistance: 'スプリント',
        runningNumber: '走行回数',
        hsrNumber: 'HSRスプリント回数',
        sprintsNumber: 'スプリント回数',
        maxSpeed: '最高速度',
        accelerations: '加速',
        extremeAccelerations: '極端な加速',
        maxAcceleration: '最大加速度'
      }
    },
    teamAnalysis: 'チーム分析',
    agentView: {
      positions: {
        gk: 'ゴールキーパー',
        leftFullback: '左サイドバック',
        centralDefender: 'センターバック',
        rightFullback: '右サイドバック',
        midfielder: 'ミッドフィールダー',
        attackingMidfielder: 'トップ下',
        leftWinger: '左ウインガー',
        rightWinger: '右ウインガー',
        fw: 'フォワード'
      },
      groups: {
        contractEnd: '月',
        age: '年',
        availability: '使用可能'
      },
      placer: {
        legend: '年齢、契約、プレー時間、パフォーマンスに基づく強さ'
      }
    },
    transfersTab: {
      valueMovements: '価値変動',
      valueTransfers: '移籍の価値',
      valueLoans: 'レンタル移籍の価値',
      avgAgeMovements: '平均年齢変動',
      avgAgeTransfers: '移籍の平均年齢',
      avgAgeLoans: 'レンタル移籍の平均年齢',
      operations: {
        buys: {
          buy: '購入',
          loan: 'レンタル',
          'end of loan': 'レンタル終了',
          'free transfer': 'フリー移籍',
          free: 'フリー',
          'loan transfer': 'レンタル移籍',
          other: 'その他'
        },
        sells: {
          buy: '売却',
          loan: 'レンタル',
          'end of loan': 'レンタル終了',
          'free transfer': 'フリー移籍',
          free: 'フリー',
          'loan transfer': 'レンタル移籍',
          other: 'その他',
          retired: '撤退'
        }
      }
    },
    trendsTab: {
      streaks: '最近の結果',
      wins: '勝利',
      cleanSheets: 'クリーンシート',
      goalPeriods: '得点した期間',
      concededGoalPeriods: '失点した期間',
      comebacks: '逆転',
      avgTime: '平均時間',
      kindOfGoals: 'ゴールの種類',
      percentWinning: '勝っている %',
      percentDrawing: '引き分けている %',
      percentLosing: '負けている %',
      totalOf: 'の合計',
      minutes: '時間',
      before: '前',
      after: '後',
      playedOn: '日付',
      scored: 'スコア',
      conceded: '与えた',
      ownGoals: 'オウンゴール',
      phasesOfGame: 'プレーの局面',
      intensityLabel: 'ゾーン強度',
      intensityByTeam: 'チーム別 %',
      intensityByLeagueAvg: 'リーグ平均別 %',
      buildup: 'ビルドアップ',
      midfieldProgression: '中盤の前進',
      attackOpposition: '相手への攻撃',
      attackingTransition: '攻撃への切り替え',
      highPress: 'ハイプレス',
      midBlock: 'ミッドブロック',
      lowBlock: 'ローブロック',
      defensiveTransition: '守備への切り替え',
      draws: '引き分け',
      losts: '負け',
      chokes: 'チョーク',
      zoneTooltip: '各ブロックのカラー グラデーションに使用される基準を決定します。',
      teamPctTooltip: '各ゾーンでチームがプレーした合計時間の割合に基づきます。',
      leagueAvgPctTooltip: '各ゾーンのチームのパーセンテージとリーグ平均を比較します。',
      leagueAvgMinsTooltip: 'リーグに対して同じ比較基準を適用しますが、パーセンテージではなく合計時間を分単位で評価します。',
      losses: '損失',
      results: '結果',
      kindOfConcededGoals: '失点の種類',
      showMinutes: '議事録を表示'
    },
    onOff: 'On/Off',
    dragUpToXPlayers: '最大5人のプレイヤーをドラッグ{x}',
    selectUpToXPlayers: '最大5人のプレイヤーを選択{x}',
    onOffTab: {
      G90: 'ゴール 90',
      GA90: '被ゴール 90',
      diffG90: 'ゴール差 90',
      XG90: 'xG 90',
      XGA90: '被 xG 90',
      diffXG90: '差 xG 90',
      playersOn: 'コンビネーション ON',
      playersOff: 'コンビネーション OFF',
      ground: 'グラウンド',
      playersOnThePitch: 'フィールド上の選手',
      playersOffThePitch: 'フィールド外の選手',
      attackTitle: '攻撃',
      attackSubTitle: '攻撃的戦術',
      defenseTitle: 'ディフェンス',
      defenseSubTitle: '守備的戦術',
      associationTitle: '連携',
      associationSubTitle: '連携的戦術',
      comboOn: 'コンビネーションON',
      comboOff: 'コンビネーションOFF',
      diffGoals90: 'ゴール差 90',
      goals90: 'PK除くゴール 90',
      goalsAgainst90: 'PK除く被ゴール 90',
      xgAgainstPer90: '被 xG 90',
      xgDiffPer90: 'xG 差 90',
      xgPer90: 'xG 90',
      xt90: 'xT 90',
      shotsOnTarget90: '90分での枠内シュート',
      touchesOppBox90: 'ペナルティーエリア内タッチ 90',
      shotsOnTargetAgainst90: '90分での被枠内シュート',
      ppda90: 'PPDA 90',
      xa90: 'xA 90',
      directness90: '縦性 90',
      possession: 'ポゼッション %',
      pctPasses: 'パス %',
      pctPassesFinalThird: 'ファイナルサードパス %',
      placeholder: 'チームを選択して開始',
      subtitle: 'ラインアップから選手を追加または削除してチームの指標を最適化'
    },
    terms: {
      short: '短期間',
      mid: '中期間',
      long: '長期間'
    },
    report: {
      title: 'チームレポート',
      selectedPeriod: '選択期間',
      stackedCharts: '積み上げグラフ',
      radars: 'レーダー',
      generalData: '一般データ',
      scoringChances: '得点チャンス',
      areasReport: 'エリアレポート',
      setPieceReport: 'セットプレーレポート',
      corners: 'コーナー',
      cornersAgainst: '被コーナー',
      indirectFreeKicks: '間接フリーキック',
      indirectFreeKicksAgainst: '被間接フリーキック',
      freeKicks: 'フリーキック',
      freeKicksAgainst: '被フリーキック',
      penaltys: 'ペナルティ',
      freeKicksContribution: 'フリーキック貢献',
      shotsContribution: 'シュート貢献',
      topXPlayersByStats: 'トップ {x} 選手の統計',
      lastShotZone: '最後のシュートゾーン',
      throwSide: 'スローイン側',
      kindOfThrow: 'スローインの種類',
      scored: '得点',
      against: '被得点',
      perGame: '1試合あたり',
      total: '合計',
      efficiency: '効率',
      organizedAttack: '組織的攻撃',
      offTransition: '攻撃の切り替え',
      chances: 'チャンス',
      chancesScored: '得点チャンス成功',
      chancesAgainst: '被チャンス',
      goalsScored: '得点数',
      goalsAgainst: '被得点数',
      goalsOrganizedAttack: '組織的攻撃の得点',
      goalsOffTransition: '切り替え攻撃の得点',
      goalsSetPiece: 'セットプレーの得点',
      goalsOrganizedAttackScored: '組織的攻撃の得点成功',
      goalsOrganizedAttackAgainst: '組織的攻撃の被得点',
      goalsOffTransitionScored: '切り替え攻撃の得点成功',
      goalsOffTransitionAgainst: '切り替え攻撃の被得点',
      goalsSetPieceScored: 'セットプレーの得点成功',
      goalsSetPieceAgainst: 'セットプレーの被得点',
      crossSide: 'クロスの側',
      externalShot: 'ミドルシュート',
      innerPlay: 'インナープレー',
      throwIn: 'スローイン',
      box: 'ペナルティエリア',
      zone2: 'ゾーン2',
      goalsPerPhases: 'フェーズごとの得点'
    },
    minutesAlert: '*450分以上プレーしたプレイヤーのみを表示',
    minutesException: '450分以上プレーした選手はいません。すべての選手が表示されます。',
    analysis: '分析',
    substitutions: '交代',
    attackZones: 'アタッキングゾーン',
    formations: 'フォーメーション',
    shotZones: 'シュートゾーン',
    crossings: 'センタリング',
    byTime: '時間で',
    byPosition: 'ポジションで',
    byPlayer: '選手で',
    W: '勝っている',
    D: '引き分けている',
    L: '負けている',
    substitutionsByGame: '試合ごとの交代',
    substitutionsShort: '交代',
    avgSeasonShort: 'シーズン平均',
    startingAt: 'で始まる',
    endingAt: 'で終わる',
    startingAtInfo: '最初のイベントの位置に基づいた所有権の割合を示します',
    endingAtInfo: '最後のイベントの位置に基づいた所有権の割合を示します',
    endingWithShot: 'シュートで終える',
    endingInBox: 'ペナルティーエリアで終わる',
    pfX: '基本フォーメーション {x}',
    bySide: 'サイドで',
    cornerKicks: 'コーナーキック',
    included: '含む',
    excluded: '除く',
    onlyCorner: 'コーナーのみ',
    sizeByMarketValue: '市場価値によるサイズ',
    timeInTeam: 'チームでの季節',
    newSignings: '新しい補強選手',
    sizeBy: '大きさで',
    connections: 'コネクション',
    assistant: 'アシストした選手',
    finisher: 'シュートした選手',
    playersMinutesAlert: '選択したシーズンで出場時間がある選手のみを表示',
    strategyFilterTooltip: 'セットプレー中またはオープンプレー中に発生したイベントを表示します',
    sideFilterTooltip: '選択した側（左または右）から始まるセットピースのみを表示します',
    teamMinutesAlert: '※プレイ時間450分以上のチームのみを表示',
    homeCoach: 'ホームコーチ',
    awayCoach: 'アウェイコーチ'
  },
  leagueTable: {
    subtitle: 'リーグがどのように発展するかを分析する'
  },
  leagueMatchdays: {
    byRound: 'ラウンド別',
    byDate: '日付別',
    byTeam: 'チーム別'
  },
  teamStats: {
    subtitle: 'チームのパフォーマンスを比較する',
    xGDiffPerGame: 'xG 差',
    xGDiffPerGameExplicit: 'ゴール期待値とゴールの差',
    expectedPointsDiff: 'xP 差',
    expectedPointsDiffExplicit: 'ポイント期待値とポイントの差',
    games: '試合',
    gamesExplicit: '行われた試合',
    pointsPerGame: '試合毎のポイント',
    pointsPerGameExplicit: '試合毎のポイント'
  },
  roles: {
    ROLE_USER: 'ユーザー',
    ROLE_ADMIN: '管理者',
    ROLE_REPORTS: 'レポート',
    ROLE_API: 'Driblab API',
    ROLE_PHYSICAL_DATA: '物理データ',
    ROLE_VIDEO: 'Capture',
    ROLE_EVENTING_DATA: 'Driblab XY',
    ROLE_DRIBLAB_HUB: 'Driblab Hub',
    ROLE_TRACKING: 'トラッキング ',
    ROLE_ARRIGO: 'Arrigo',
    ROLE_API_description: '選手、チーム、試合、リーグ情報をJSON形式で簡単に抽出。',
    ROLE_EVENTING_DATA_description: 'レーダーチャート、選手ランキング、マップなど、+100のパフォーマンス指標に基づいた統計に深く入り込もう。',
    ROLE_PHYSICAL_DATA_description: 'フィットネスデータにアクセスし、さまざまなパフォーマンス指標（距離、スピード、スプリント、加速度など）で選手をフィルタリング。',
    ROLE_VIDEO_description: 'ビデオやラインアップを提供し、詳細な分析のためにイベントや統計でタグ付けされたゲームを取得します。',
    ROLE_DRIBLAB_HUB_description: 'カレンダー、メモ、アラート、ドキュメント共有により、スカウティングタスクを効率的に追跡・管理。',
    ROLE_TRACKING_description: 'APIを通じて試合中の全選手のポジションデータを受け取り、包括的な分析を行う。',
    ROLE_ARRIGO_description: 'イベントデータとトラッキングデータを組み合わせ、従来を超えた革新的な指標を作成し、あらゆるアクションに価値を加えます。',
    ROLE_REPORTS_description: '私たちのアナリストチームから詳細なスカウティングレポートをリクエストして、完璧なチームや選手を見つけましょう。',
    ROLE_RAW_EVENTING: '生のイベンティング'
  },
  administration: {
    pageSubtitle: 'アプリケーションの運用管理',
    newClient: '新しいクライアント',
    clientDuplicateName: 'この名前のクライアントは既に存在します。一覧からそのクライアントを選択し、「新規ユーザー」でユーザーを追加してください。',
    newUser: '新しいユーザー',
    editClient: 'クライアントを編集',
    editUser: 'ユーザーを編集',
    clientName: '名前',
    permissions: '権限',
    releaseUser: 'ユーザーを解除',
    connectAsUser: 'として接続',
    releaseModalTitle: 'ユーザー解除の確認',
    releaseModalMessage: 'ユーザーには新しいアカウント情報がメールで通知されます。本当に通知してもよろしいですか？',
    clientType: {
      Driblab: 'Driblab',
      Team: 'チーム',
      Brand: 'ブランド',
      Federation: '連盟',
      Media: 'メディア',
      Agency: '代理店',
      Individual: '個人'
    },
    userType: {
      Ownership: '所有者',
      SportingDirector: 'スポーツディレクター',
      Brand: 'ブランド',
      Federation: '連盟',
      Media: 'メディア',
      Agency: '代理人',
      Individual: '個人',
      Scout: 'スカウト',
      Coach: 'コーチ',
      supervision: {
        title: '監督階層',
        subtitle: '監視は下方向にのみ流れます。同レベルの監督は認められない。',
        supervisesLowerLevels: '以下のすべての役割を監督します',
        ruleNoSameLevel: '同じレベルのロールは相互に監視できません。',
        ruleOnlyDownwards: '監督は上位の役割から下位の役割へのみ許可されます。',
        ruleLevel3NoSupervision: '最下位レベルには監視権限がありません。',
        currentUserType: '現在のユーザータイプ'
      }
    },
    visibleYears: '表示される年',
    areaModalTitle: 'リーグの有効化/無効化の確認',
    areaModalMessage: '選択したエリア内のすべてのリーグを有効化/無効化してもよろしいですか？',
    countStats: '統計をカウント',
    userClientModalTitle: 'ユーザーはすでに別のクライアントに存在します',
    eventing: 'Eventing',
    hub: 'Hub',
    contract: '契約',
    contracts: '契約一覧',
    invoiceName: '請求書名',
    contractFee: '契約料金',
    renewal: '更新',
    consultancy: 'コンサルティング',
    deleteContract: 'クライアント契約を削除',
    deleteContractMessage: '契約は完全に削除されます。本当によろしいですか？',
    activeVsHired: 'アクティブ vs 採用済み',
    requestedVsHired: 'リクエスト済み vs 採用済み',
    activeVsHiredWithPlaceholder: '{0} アクティブ vs {1} 採用',
    requestedVsHiredWithPlaceholder: '{0} リクエスト vs {1} 採用',
    salesRepresentative: '営業担当者',
    periodicities: {
      periodicity: '期間',
      annual: '年次',
      biannual: '半年ごと',
      quarterly: '四半期ごと',
      monthly: '毎月',
      bimonthly: '2か月ごと',
      onePayment: '一回払い',
      fourmonthly: '4か月ごと'
    },
    paymentMethods: {
      payment: '支払い',
      method: '方法',
      transfer: '振込',
      mandate: '自動引き落とし'
    },
    marketingOptions: {
      marketing: 'マーケティング',
      socialMediaAdd: 'ソーシャルメディア広告',
      videoWithFeedback: 'フィードバック付きビデオ'
    },
    status: {
      status: 'ステータス',
      pending: '保留中',
      active: 'アクティブ',
      expiringSoon: 'まもなく期限切れ',
      expired: '期限切れ',
      expiringSoonWithDays: '契約が間もなく期限切れになります: 残り {0} 日'
    },
    updates: {
      roleAdded: '<b>{0}</b> が <b>{2}</b> に役割 <b>{1}</b> を追加しました。',
      roleRemoved: '<b>{0}</b> が <b>{2}</b> から役割 <b>{1}</b> を削除しました。',
      leagueAdded: '<b>{0}</b> が <b>{1}</b> をリーグ <b>{2}</b> に追加しました。',
      leagueRemoved: '<b>{0}</b> が <b>{1}</b> をリーグ <b>{2}</b> から削除しました。',
      seasonAdded: '<b>{0}</b> が <b>{1}</b> をシーズン <b>{2}</b> に追加しました。',
      seasonRemoved: '<b>{0}</b> が <b>{1}</b> をシーズン <b>{2}</b> から削除しました。',
      updateNotesPlaceholder: '変更内容の背景や関連するメモをここに記入してください...',
      updates: '更新',
      products: 'プロダクト'
    },
    clients: 'クライアント',
    trials: '試練',
    activeClients: 'アクティブなクライアント',
    activeTrials: 'アクティブなトライアル',
    activeTrialUsers: 'アクティブなトライアル ユーザー',
    activeContracts: '有効な契約',
    expiration: '有効期限',
    clientWarnings: {
      activeContractInactiveClient: '有効な契約を結んでいるが、有効なユーザーがいないクライアント',
      activeContractTrialUsers: '契約が有効な間に試用ユーザーがいるクライアント',
      activeUsersWithoutContract: '有効な非試用ユーザーがいるが有効な契約を持っていないクライアント',
      upcomingExpirations: '今後の有効期限',
      renewedContracts: '更新契約中のお客様',
      clientsWithWarnings: '注意が必要なお客様',
      enabledUsersWithoutContract: '「有効な契約を結んでいない有効な非試用ユーザー」',
      trialUsersWithContract: '有効な契約にもかかわらず試用モードのユーザー',
      activeContractInactiveUsers: 'クライアントはアクティブな契約を結んでいますが、すべてのユーザーは非アクティブです',
      activeContract: 'このクライアントには有効な契約があります',
      noEnabledUsers: 'このクライアントには有効なユーザーがいません',
      ongoingTrialInactiveUsers: 'トライアル中だが有効なユーザーがいないクライアント',
      neverLoggedIn: 'ログインしたことがないクライアント'
    },
    daysLeft: '残り日数',
    expiringSoon: 'もうすぐ期限切れになります',
    loggedThisWeek: '今週ログインしました',
    withWarnings: '警告あり',
    ofActiveClients: 'アクティブなクライアントの数',
    endingIn30Days: '30日後に終了',
    neverLogged: 'ログインしたことがない',
    ofActiveTrials: 'アクティブなトライアルの',
    activeClientsWithoutTrial: 'アクティブなクライアント (トライアルを除く)',
    renewals: 'リニューアル',
    ofActiveContracts: 'アクティブな契約の'
  },
  dashboards: {
    lastGame: '最後の試合の分析',
    lastGameSimple: '最後の試合',
    seeAllGameInfo: 'すべての情報を見る',
    nextGame: '次の試合',
    myTeam: '自分のチーム',
    lastMatchdayGames: '前節の試合',
    lastAdded: '最新の追加',
    myFavorites: '私のお気に入り',
    seeAllFavorites: 'すべてのお気に入りを見る',
    placeholderFavorites: 'プレーヤーの詳細から、お気に入りに追加できます',
    placeholderTeamFavorites: 'チームの詳細から、お気に入りに追加できます',
    placeholderLeagueFavorites: 'リーグの詳細から、お気に入りに追加できます',
    myCollections: '私のコレクション',
    placeholderCollections: 'コレクションが作成されていません',
    lastCreated: '最新の作成',
    seeAllCollections: 'すべてのコレクションを見る',
    seeRival: 'ライバルチームをみる',
    seeMyTeam: '自分のチームをみる',
    title: 'スコア表',
    subtitle: 'ようこそ',
    recentPlayers: '最近のプレーヤー',
    lastScouted: '最近の検索',
    scout: '検索',
    reportsRequested: 'レポート',
    lastRequested: '最近のリクエスト',
    goInbox: '受信箱へ行く',
    placeholderLastScouted: '左のバーまたは検索ツールでプレイヤーを検索できます',
    placeholderReports: 'プレイヤーの詳細からレポートをリクエストできます',
    nationalPlayers: '他国で最も価値のある自国の選手',
    lastGames: '最近の試合',
    nationalPlayersShort: '他のリーグでプレーしている自国の選手',
    nextMatchdayGames: '次節の試合',
    injuredPlayers: '負傷中の選手',
    atPresent: '現時点では',
    seeAllPlayers: '全て見る',
    suspendedPlayers: '出場停止選手',
    placeholderInjured: '負傷中の選手はいません',
    teamValueImpacted: 'チーム価値への影響',
    placeholderSuspended: '出場停止の選手はいません',
    placeholderNextGame: '試合がありません',
    placeholderNoGames: 'まだ試合がありません',
    placeholderLastMatchDayNotFound: '前節は見つかりません。',
    placeholderNextMatchDayNotFound: '次節は見つかりません。',
    usersMostSearch: '最も検索数の多いユーザー',
    lastTwoDays: '最後の2日間',
    searchesHistory: '検索履歴',
    dayByDay: '一日ずつ',
    activeUsersTitle: 'アクティブユーザー',
    activeUsersSubtitle: '過去 1 か月以内に接続したことがある',
    onlineUsersTitle: 'オンラインのユーザー',
    onlineUsersSubtitle: '過去1時間以内に検索しました',
    searchesPerformed: '実行された検索',
    onlyClients: '顧客のみ',
    activeClientsTitle: '活動中の顧客',
    activeClientsSubtitle: '少なくとも1人のユーザーはアクティブです',
    last24Hours: '過去24時間',
    activityHistory: '活動履歴',
    loginHistory: 'アクセス履歴',
    failLogins: 'アクセスの失敗',
    successLogins: 'アクセス成功',
    clientStats: '顧客スタッツ',
    playersMostSearch: '最も検索されている選手',
    toolsMoreUsed: '最も使用されているツール',
    hotPlayers: '傑出した選手',
    last_month: '前の月',
    last_week: '前週',
    last_day: '過去24時間',
    nClients: '顧客ナンバー',
    userDashboard: 'ユーザー・ダッシュボード',
    userDashboardSubtitle: '口座活動の概要',
    offlineDaysOfClient: '各クライアントのオフライン日数',
    hideNoConnected: '未接続を非表示',
    onlyTrial: '試用クライアントのみ',
    daysWithoutLogin: 'ログインしていない日数',
    trialDays: '試用日数'
  },
  faq: {
    subtitle: 'Driblab PROとは？',
    categories: {
      playerMetrics: 'プレーヤーの指標',
      teamMetrics: 'チームの指標',
      positions: 'チームポジション',
      tools: 'ツール',
      api: 'API',
      videos: 'チュートリアル',
      playerPositions: 'ポジション名の設定',
      userTypes: 'ユーザーの種類'
    },
    positions: {
      GK: 'ゴールキーパー',
      DR: '右サイドバック',
      DC: 'センターバック',
      DL: '左サイドバック',
      DMR: '右ウイングバック',
      DMC: '守備的ミッドフィールダー',
      DML: '左ウイングバック',
      MR: '右ミッドフィールダー',
      MC: 'ミッドフィールダー',
      ML: '左ミッドフィールダー',
      AMR: '右インサイドハーフ',
      AMC: 'トップ下',
      AML: '左インサイドハーフ',
      FWR: '右ウインガー',
      FW: 'フォワード',
      FWL: '左ウインガー'
    },
    metrics: {
      categories: {
        Association: '協力',
        Saving: 'セーブ',
        Shooting: 'シュート',
        Defending: 'ディフェンシング',
        Passing: 'パス',
        BallHandling: 'ボールコントロール',
        Aerial: '空中',
        Physical: 'フィジカル',
        Predictive: '予測',
        Arrigo: 'アリゴ',
        Score: 'スコア',
        Turnovers: 'ボールロスト',
        Carries: 'ドリブル',
        SequenceInvolvement: 'ポゼッションへの参加',
        Crosses: 'センタリング',
        Distance: '距離',
        Sprint: 'スプリント',
        Acceleration: '加速',
        MaxAcceleration: '最大加速度',
        Speed: 'スピード',
        OutPlay: 'アウトプレイ',
        LineBreakingPasses: 'ラインブレイクパス',
        LineBreakingCarries: 'ラインブレイクキャリー',
        LineBreakingActions: 'ライン間アクション',
        PassUnderPressure: 'プレッシャー下のパス',
        BallReceived: 'ボールを受けた',
        PassesUnderPressure: 'プレッシャーを乗り越える',
        OnBallPressureReceived: 'ボール保持中のプレッシャー',
        OnBallPressure: 'ボール保持者へのプレッシャー',
        BallReceiptsInSpace: 'スペースでのボール受信',
        SpatialCoverage: 'スペースカバレッジ',
        OffBallPressure: 'オフボール時のプレッシャー',
        OffBallRuns: 'オフ・ザ・ボールラン',
        NoCategory: 'その他',
        subcategories: {
          Quality: 'クオリティ',
          Quantity: 'クオンティティ',
          TeamComparison: 'チーム比較',
          Receptions: 'レシーブ',
          LongBalls: 'ロングボール',
          Efficiency: '効率',
          Ratio: '比率',
          Defensive: 'ディフェンス',
          Offensive: 'オフェンス',
          Foot: '足',
          Progression: '進行',
          TopValue: '最高値',
          Predictive: '予測',
          Distance: '距離',
          Aerial: '空中',
          Crosses: 'センタリング',
          NoCategory: 'その他'
        },
        desc: {
          Association: '協力',
          Saving: 'セーブ',
          Shooting: 'シュート',
          Defending: 'ディフェンシング',
          Passing: 'パス',
          BallHandling: 'ボールコントロール',
          Aerial: '空中',
          Physical: 'フィジカル',
          Predictive: '予測',
          Arrigo: 'アリゴ',
          Score: 'スコア',
          Turnovers: 'ボールロスト',
          Carries: 'ドリブル',
          SequenceInvolvement: 'ポゼッションへの参加',
          Crosses: 'センタリング',
          Distance: '異なる速度での走行距離',
          Sprint: '異なる速度での走行',
          Acceleration: '加速',
          Speed: 'スピード',
          OutPlay: 'パッキング',
          LineBreakingPasses: 'ラインブレイクパス',
          LineBreakingCarries: 'ラインブレイクキャリー',
          LineBreakingActions: 'ライン間アクション',
          PassUnderPressure: 'プレッシャー下のパス',
          BallReceived: 'ボールを受けた',
          OnBallPressureReceived: 'ボール保持中のプレッシャー',
          OnBallPressure: 'ボール保持者へのプレッシャー',
          BallReceiptsInSpace: 'スペースでのボール受信',
          SpatialCoverage: 'ピッチコントロール',
          OffBallPressure: 'オフボール時のプレッシャー',
          OffBallRuns: 'オフ・ザ・ボールラン',
          HandPassing: 'ゴールキーパーが手で出したパス、またはセットプレーでのスロー'
        },
        abbr: {
          Association: '協力',
          Saving: 'セーブ',
          Shooting: 'シュート',
          Defending: 'ディフェンシング',
          Passing: 'パス',
          BallHandling: 'ボールコントロール',
          Aerial: '空中',
          Physical: 'フィジカル',
          Predictive: '予測',
          Arrigo: 'アリゴ',
          Score: 'スコア',
          Turnovers: '売上高',
          Carries: 'ドリブル',
          SequenceInvolvement: 'ポゼッションへの参加',
          Crosses: 'センタリング',
          Distance: '距離',
          Sprint: '走行',
          Acceleration: '加速',
          MaxAcceleration: '最大加速度',
          Speed: 'スピード',
          OutPlay: 'パッキング',
          LineBreakingPasses: 'ラインブレイクパス',
          LineBreakingCarries: 'ラインブレイクキャリー',
          LineBreakingActions: 'ライン間アクション',
          PassUnderPressure: 'プレッシャー下のパス',
          BallReceived: 'ボールを受けた',
          OnBallPressureReceived: 'ボール保持中のプレッシャー',
          OnBallPressure: 'ボール保持者へのプレッシャー',
          BallReceiptsInSpace: 'スペースでのボール受信',
          SpatialCoverage: 'ピッチコントロール',
          OffBallPressure: 'オフボール時のプレッシャー',
          OffBallRuns: 'オフ・ザ・ボールラン',
          HandPassing: 'ハンドパス'
        },
        HandPassing: 'ハンドパス'
      },
      types: {
        1: '90分ごと',
        2: '割合',
        3: '比',
        4: '有効性',
        5: '平均',
        6: '試合ごと',
        7: '差',
        8: 'Max'
      },
      moreInfo: '詳細はこちら'
    },
    api: {
      subtitle: 'さまざまなリクエストからデータを収集する',
      resourcesTitle: 'リソース',
      authentication: '認証',
      authText: 'API を呼び出すには、各リクエストのヘッダー`Authorization` と値 `Bearer {API_TOKEN}`を含める必要があります。',
      generate: '生成する',
      tokenPlaceholder: 'トークンを持っていないか、有効期限が切れている場合は、[生成する] をクリックします。\'',
      pathParameters: 'パスパラメータ',
      queryParameters: 'クエリパラメータ',
      responseModel: '応答モデル',
      tokenWarning: '* API をテストできるようにするためのトークンを生成します',
      pathParamsWarning: '* 未入力のパスパラメータがあります',
      genericDescription: 'API (アプリケーション・プログラミング・インターフェイス) は、開発者がデータや機能を自分のアプリケーションにアクセスして統合できるようにするものです。私たちのサッカー統計APIは、国、大会、チーム、選手、試合などに関するさまざまなデータへの包括的なアクセスを提供します。このAPIを使用することで、分析、ビジュアライゼーション、またはその他の革新的なソリューションのために、豊富なサッカードデータを活用するアプリケーションを構築できます。',
      methods: {
        getAllCountries: 'このメソッドは、APIで利用可能なすべての国の完全なリストを取得し、各国のユニークな識別子や名前などの重要な詳細を提供します。このエンドポイントは、地理的なサッカーデータを必要とするアプリケーションに最適で、国の選択、フィルタリング、分析といった機能を可能にします。また、`countryId`パラメータに依存する他のエンドポイントと連携するための基盤的なリソースとしても機能し、APIデータセットとのスムーズな統合を保証します。',
        getCountryDetail: 'このメソッドは、APIで利用可能な特定の国に関する詳細情報を提供します。このエンドポイントを使用することで、その国の名前、コード、関連するメタデータなどのデータを取得できます。これは、地理データに基づいてコンテキスト情報を表示したり、カスタマイズされたインサイトを生成したりするなど、国固有の詳細が必要なアプリケーションに特に役立ちます。他のエンドポイントを補完し、選択した国を深く掘り下げて探索することを可能にします。',
        getCountryCompetitions: 'このメソッドは、特定の国で利用可能なすべての大会のリストを取得します。地域別に大会を探索できる機能を提供するための貴重なリソースであり、国のデータをその関連トーナメントとシームレスに結び付けます。このエンドポイントは、地域限定のサッカーコンテンツや地域分析に重点を置いたアプリケーションにとって不可欠です。',
        getAllCompetitionTypes: 'このメソッドは、APIで利用可能なすべての大会タイプ（リーグ、カップ、国際トーナメントなど）のリストを返します。このエンドポイントは、大会を分類し、異なる種類のイベントを整理された形でユーザーに提供するのに最適です。大会の性質に基づいてサッカーデータを探索するためのフィルターやドロップダウンメニューといった機能を構築する際に特に役立ちます。',
        getAllCompetitions: 'このメソッドは、タイプや場所に関係なく、APIで利用可能なすべての大会の包括的なリストを取得します。このエンドポイントは、幅広いサッカー大会を表示または分析する必要があるアプリケーションにとって便利で、ユーザーが興味のあるイベントを探索し選択することを可能にします。',
        getCompetitionAvailable: 'このメソッドは、現在APIで利用可能とマークされている大会のリストを取得します。これにより、返されるデータが最新かつアプリケーションで使用可能であることが保証されます。特に、アクティブまたはアクセス可能な大会に依存する機能を構築する開発者にとって有用であり、ユーザーが関連するイベントを探索する際に古いデータや不完全なデータに遭遇しないようにします。',
        getCompetitionDetail: 'このメソッドは、APIで利用可能な特定の大会に関する詳細情報を提供します。これは、大会に関する詳細ビュー、コンテキストに基づく洞察、または大会の特徴に基づくフィルタリングオプションを可能にするアプリケーションに特に役立ちます。',
        getCompetitionSeasons: 'このメソッドは、特定の大会に関連付けられているすべてのシーズンのリストを取得します。このエンドポイントは、ある大会の歴史や現在の状況を包括的にカバーすることを目指すアプリケーションにとって重要で、ユーザーがシーズンごとにデータを探索することを可能にします。',
        getSeasonAvailable: 'このメソッドは、APIで現在利用可能とされているすべてのシーズンのリストを提供します。ライブや進行中のサッカーイベントに焦点を当てたアプリケーションに特に有用で、ユーザーが関連する最新のシーズンデータと連携できるようにします。',
        getSeasonDetail: 'このメソッドは、特定のシーズンに関する詳細情報を取得します。タイムライン、関連する大会、主要なメタデータを含みます。このエンドポイントは、特定のシーズンに関する詳細なインサイトを必要とするアプリケーションに不可欠で、シーズン概要、大会ごとのフィルタリング、または詳細なタイムライン表示などの機能を可能にします。',
        getSeasonTeams: 'このメソッドは、特定のシーズンに参加しているすべてのチームのリストを提供します。ロスター管理、チームパフォーマンスの分析、またはシーズンごとのフィルター作成などの機能に最適です。',
        getSeasonPlayer: 'このメソッドは、特定のシーズンに登録されたすべての選手のリストを取得します。選手ロスター、パフォーマンス追跡、または選択したシーズンに基づく選手のフィルタリング機能を構築するのに理想的です。',
        getSeasonPlayerStats: 'このメソッドは、特定のシーズンにおけるすべての選手の詳細な統計を提供します。分析、選手の比較、またはシーズンを通じた選手の成果の動的なビジュアライゼーションを重視したアプリケーションに特に有用です。',
        getSeasonArrigoMetrics: 'この手法は、特定のシーズンにおける全選手の総合的な統計情報を提供します。特に、分析、選手比較、シーズンを通しての選手の成績を動的に視覚化するアプリケーションに有効です。',
        getSeasonTeamStats: 'このメソッドは、特定のシーズンに参加するすべてのチームの包括的な統計を提供します。チーム分析、シーズンのまとめ、またはシーズンを通じたチームパフォーマンスの比較に焦点を当てたアプリケーションに特に有用です。',
        getSeasonCoaches: 'このメソッドは、特定のシーズン中にチームを指導したすべてのコーチのリストを取得します。シーズンインサイト、コーチング分析、またはシーズンを通じたチーム管理の変更を追跡するアプリケーションに特に有用です。',
        getSeasonGames: 'このメソッドは、特定のシーズンに行われたすべての試合のリストを提供します。シーズン全体のスケジュールを表示したり、試合結果を分析したり、シーズン試合データに総合的にアクセスする機能を提供したりするアプリケーションに最適です。',
        getSeasonGamesMatchday: 'このメソッドは、特定のシーズン内の特定のマッチデーに行われたすべての試合を取得します。マッチデーのスケジュールを表示したり、特定のラウンドを分析したり、シーズン中の特定の試合セットに焦点を当てたインサイトを提供するアプリケーションに特に有用です。',
        getSeasonLeagueTable: 'このメソッドは、特定のシーズンのリーグテーブルを提供します。ランキング、ポイント、勝利、引き分け、敗北、および各チームに関連するその他の統計を含みます。このエンドポイントは、チーム順位の追跡、リーグの進行状況の分析、またはシーズンを通じてユーザーに最新の順位を提示することを目的としたアプリケーションに不可欠です。',
        getTeamDetail: 'このメソッドは、特定のチームに関する詳細情報を提供します。チーム名、設立年、スタジアム、その他のメタデータが含まれます。このエンドポイントは、チームプロファイルの詳細表示、歴史的背景の提供、または豊富なチームデータを活用したユーザー体験の向上を目的とするアプリケーションに最適です。',
        getTeamLoans: 'このメソッドは、特定のチームが関与するレンタル取引に関する情報を取得します。移籍分析、チームのロスター管理、またはシーズン中の選手の動きを追跡するアプリケーションに特に有用です。',
        getTeamRoster: 'このメソッドは、特定のチームのロスターに含まれるすべての選手の完全なリストを提供します。チームのラインアップ表示、選手の役割分析、またはチームのロスター関連機能を管理するアプリケーションに理想的です。',
        getTeamGames: 'このメソッドは、特定のチームがプレーしたすべての試合のリストを取得します。チームのパフォーマンス、スケジュールの追跡、またはチームの完全な試合履歴へのアクセスを提供するアプリケーションに特に適しています。',
        getTeamGameStats: 'このメソッドは、特定の試合における特定のチームの詳細な統計を提供します。試合分析、パフォーマンス評価、または個々の試合でのチームのパフォーマンスの詳細な内訳に焦点を当てたアプリケーションに特に有用です。',
        getTeamTransfers: 'このメソッドは、特定のチームが関与する移籍取引に関する情報を取得します。移籍市場分析、チームロスターの変更、または長期的な選手移動の追跡に重点を置いたアプリケーションに最適です。',
        getGameStatus: 'このメソッドは、APIで利用可能なすべての試合ステータスのリストを提供します。例として、予定済み、進行中、完了、延期、またはキャンセルがあります。リアルタイムの試合追跡、ステータス別の試合フィルタリング、または試合の進行状況や状態に関する明確な更新をユーザーに提供するアプリケーションに特に有用です。',
        getPlayerPositions: 'このメソッドは、ゴールキーパー、ディフェンダー、ミッドフィルダー、フォワードなど、すべての可能な選手のポジションのリストを返します。選手を分類したり、ポジションデータを分析したり、フィールド上での役割に基づいて選手をフィルタリングする機能を提供するアプリケーションに特に役立ちます。',
        getGameDetail: 'このメソッドは、特定の試合に関する包括的な情報を提供します。参加チーム、日付と時間、会場、スコア、その他の重要なメタデータなどの詳細が含まれます。試合の詳細なプレビュー、レポート、または分析機能を提供するアプリケーションに最適です。',
        getGameStats: 'このメソッドは、特定の試合に関する詳細な統計情報を提供します。ゴール数、シュート数、ボール支配率、パス、ディフェンスアクションなどの指標が含まれます。試合分析、試合後のレポート、または試合中のチームパフォーマンスの視覚化に焦点を当てたアプリケーションに特に有用です。',
        getGamePlayerStats: 'このメソッドは、特定の試合に参加したすべての選手の詳細なパフォーマンス統計を取得します。個々の選手のパフォーマンスを分析したり、試合レポートを作成したり、単一試合の文脈で選手を比較するアプリケーションに特に適しています。',
        getGamePlayerPhysicalStats: 'このメソッドは、特定の試合における選手の詳細なフィジカルパフォーマンス指標を提供します。選手のコンディション分析、フィジカルパフォーマンスの追跡、または選手個人の試合インサイトを生成するアプリケーションに特に有用です。',
        getGameTeamPhysicalStats: 'このメソッドは、特定の試合におけるチームの詳細なフィジカルパフォーマンス指標を提供します。これには、総走行距離、スプリント回数、高強度ランニング、その他の身体的属性が含まれます。チームのフィットネス分析、チーム間のフィジカル努力の比較、または試合全体のパフォーマンス評価に特に有用です。',
        getGamePlayerArrigoMetrics: 'このメソッドは、特定の試合におけるプレイヤーの詳細なArrigoメトリックを提供します。これは、分析に重点を置き、試合におけるプレイヤーに関する詳細な洞察を生成するアプリケーションに特に役立ちます。',
        getGameTeamArrigoMetrics: 'このメソッドは、特定の試合におけるチームArrigoの詳細な指標を提供します。これには、敗北した選手やその他の属性などのデータが含まれます。特に、試合全体のパフォーマンス評価を分析することに重点を置いたアプリケーションに役立ちます。',
        getGameLineup: 'このメソッドは、特定の試合のスタメンや控え選手、そのポジションを含むラインナップを取得します。試合前情報の表示、チームのフォーメーション分析、または特定の試合における戦術的決定の洞察を提供するアプリケーションに特に役立ちます。',
        getGameTimeline: 'このメソッドは、特定の試合中に発生したイベントの時系列リストを提供します。リアルタイム試合更新、試合後の要約、または試合イベントの詳細な分析を提供するアプリケーションに特に有用です。',
        getGameTracking: 'このメソッドは、特定の試合におけるトラッキングデータファイルをダウンロードするリンクを提供します。このファイルには、試合中の選手やボールの動きと位置に関する詳細なデータが含まれています。高度な分析、戦術分析、または試合中の選手やボールの動きの可視化に焦点を当てたアプリケーションに特に適しています。',
        getTrackingStatus: 'このメソッドは、追跡で利用可能なすべての状態の完全なリストを返し、各状態の一意の識別子や名前などの重要な詳細を提供します。このエンドポイントは、状態の選択、フィルタリング、分析などの機能を有効にし、一致追跡を必要とするアプリケーションに最適です。また、「statusId」パラメータに依存する他のエンドポイントと対話するための重要なリソースとしても機能し、シームレスなナビゲーションと API の広範なデータセットとの統合を保証します',
        getPlayerTransfersTypes: 'このメソッドは、選手の移籍タイプ（完全移籍、レンタル移籍、フリー移籍、交換移籍など）のリストを取得します。このエンドポイントは、移籍市場の傾向を分析したり、選手の動きを分類したり、移籍取引の種類に関する詳細な洞察を提供するアプリケーションに特に有用です。',
        getPlayerDetail: 'このメソッドは、特定の選手に関する詳細情報を提供します。個人情報、キャリア統計、所属チームなどが含まれます。選手プロフィール、歴史的なインサイト、個々の選手のパフォーマンスやキャリア軌跡を分析するアプリケーションに最適です。',
        getPlayerGames: 'このメソッドは、特定の選手が出場したすべての試合のリストを取得します。選手のパフォーマンス追跡、試合履歴分析、個々の選手の試合ログを提供するアプリケーションに特に有用です。',
        getPlayerInjuries: 'このメソッドは、特定の選手が経験した怪我の詳細な記録を提供します。選手の健康状態分析、キャリアへの影響評価、またはリハビリ期間の追跡に焦点を当てたアプリケーションに特に有用です。',
        getPlayerNationalTeam: 'このメソッドは、選手の代表チームでの試合参加に関する詳細情報を取得します。代表レベルでの選手のパフォーマンスを分析したり、国際キャリアを追跡したり、トーナメントや親善試合での貢献を提供するアプリケーションに特に適しています。',
        getPlayerSeasons: 'このメソッドは、特定の選手が参加したすべてのシーズンのリストを提供します。選手のキャリアの進行状況を追跡したり、シーズンごとのパフォーマンスを分析したり、成果に関する歴史的な文脈を提供するアプリケーションに特に有用です。',
        getPlayerTransfers: 'このメソッドは、特定の選手に関わる移籍履歴を詳細に取得します。選手キャリアの分析、移籍市場の洞察、またはチーム間での選手の動きを追跡するアプリケーションに特に適しています。',
        getPlayerSeasonTeamStats: 'このメソッドは、特定の選手が特定のシーズンで所属チームと共に達成した詳細なパフォーマンス統計を提供します。シーズンを通じた選手分析、チームやシーズン間の比較、チームの成功に対する個々の貢献を追跡するアプリケーションに特に有用です。',
        getPlayerSeasonPhysicalStats: 'このメソッドは、特定の選手のシーズン全体にわたる詳細な身体パフォーマンス指標を提供します。選手のフィットネス追跡、身体的パフォーマンス分析、またはシーズン中の選手の負荷を評価するアプリケーションに最適です。',
        getPlayerSeasonGamePhysicalStats: 'このメソッドは、特定の選手のシーズン中の各試合ごとの身体パフォーマンス指標を詳細に提供します。試合ごとのフィットネス分析、選手の負荷追跡、または異なる試合間での身体パフォーマンスを比較するアプリケーションに特に有用です。',
        getPlayerSeasonGameStats: 'このメソッドは、特定の選手のシーズン中の各試合ごとの詳細なパフォーマンス統計を取得します。試合ごとの選手分析、パフォーマンストレンド、またはシーズン内の試合間での詳細な比較に焦点を当てたアプリケーションに最適です。',
        getCoachDetail: 'このメソッドは、特定の監督に関する詳細情報を提供します。名前、キャリア履歴、指導したチーム、主な実績が含まれます。このエンドポイントは、監督のプロフィールを紹介したり、キャリアを追跡したり、チームパフォーマンスにおける監督の影響を分析するアプリケーションに特に有用です。',
        getCoachHistory: 'このメソッドは、特定の監督のキャリア履歴を包括的に取得します。指導したチーム、参加した大会、任期期間が含まれます。このエンドポイントは、監督のキャリアを分析したり、マネジメントの変遷を追跡したり、監督のプロフェッショナルな軌跡や実績に関するインサイトを提供するアプリケーションに最適です。',
        getGameEventing: 'このメソッドはすべてのイベントを提供します',
        getLinkStream: 'このメソッドは、ゲームビデオを視聴するためのリンクを取得します。',
        getLinkDownload: 'このメソッドは、ゲームビデオをダウンロードするためのリンクを取得します。',
        getGameTs: 'このメソッドは、特定の一致の最後のタイムスタンプを提供します',
        getGameFileTypes: 'このメソッドは、一致するファイル タイプを提供します。',
        deletePlayer: 'This method delete a player',
        getGeneralPositions: 'このメソッドは、ゴールキーパー、ディフェンダー、ミッドフィールダー、フォワードなど、考えられる一般的なポジションのリストを返します。',
        getPercentiles: 'このメソッドは、利用可能なすべてのパーセンタイルを提供します',
        getPlayerPercentilesEventing: 'このメソッドは、特定のパーセンティルとポジションのすべての統計を提供します。'
      },
      responseCodes: 'レスポンスコード',
      furtherInformation: '詳細については、次のリンクのガイドを参照してください。',
      clipboard: 'クリップボードにコピーしました！',
      limit50: '最初の 50 件の結果のみを表示'
    }
  },
  globalSearch: {
    subtitle: 'より詳しいフィルター'
  },
  global: {
    teamElos: {
      title: 'チームELO',
      subtitle: '世界中のチームランキングとインサイト',
      team: 'チーム',
      teams: 'チーム',
      dates: '日付',
      excludeInternational: '国際チームを除外',
      elo: 'ELO',
      selectButton: 'トップを選択',
      selectTeamFromTable: 'テーブルからチームを選択してELOトレンドを表示します。',
      showingTeamAveragesLastSeason: '最新シーズンのチーム平均を表示',
      showingTeamStatsLastSeason: '最新シーズンのチーム統計のみを表示',
      searchToolTip: 'ヒント: Ctrl + B を押すと、検索バーに直接アクセスできます。',
      selectTopTooltip: '比較のためにチャートに追加のチームを表示します',
      loadingPage: 'データを準備しています...'
    },
    leagueElos: {
      title: 'リーグELO',
      subtitle: 'グローバルリーグランキングと分析',
      rankings: 'ランキング',
      insights: 'インサイト',
      filters: 'フィルター',
      leagues: 'リーグ',
      from: '開始日',
      to: '終了日',
      elo: 'ELO',
      change: '変動',
      league: 'リーグ',
      excludeContinental: '国際大会を除外',
      eloTrend: 'ELOトレンド',
      eloRanking: 'ELOランキング',
      currentELOLabel: '(現在のELO)',
      allTime: '全期間',
      average: '平均',
      noChartData: '選択されたフィルターに利用可能なチャートデータがありません。',
      selectLeagueFromTable: 'テーブルからリーグを選択してELOトレンドを表示します。',
      noInsightsData: '選択したリーグに利用可能なインサイトデータがありません。リーグに利用可能なシーズンやチームインサイトデータがあるかご確認ください。',
      showingLeagueAveragesLastSeason: '各リーグの最新シーズン平均のみを表示しています',
      selectTopTooltip: '比較のためにチャートに追加のリーグを表示します',
      confederations: {
        world: 'ワールド',
        top5: 'トップ5',
        uefa: 'ヨーロッパ',
        conmebol: '南米',
        concacaf: '北中米カリブ',
        caf: 'アフリカ',
        afc: 'アジア'
      },
      numberOfLeagues: 'リーグ数',
      minimumElo: '最小ELO'
    },
    players: {
      title: 'プレーヤーの GPI',
      subtitle: 'グローバルプレーヤーのランキングと洞察',
      gpiRanking: 'GPIランキング',
      rankTooltip: 'カーソルを合わせるとグローバルランキングが表示されます',
      globalRanking: '世界ランキング',
      player: 'プレーヤー',
      players: '選手',
      gpiTrend: 'GPIトレンド',
      currentGPILabel: '(現在のGPI)',
      nationality: '生まれた国',
      position: '位置',
      marketValue: '市場価値',
      apply: '適用する',
      marketValueAndAgeTooltip: '範囲を入力して「適用」をクリックするか、Enter キーを押します。',
      searchPlaceholder: 'プレーヤーを検索...',
      selectTopTooltip: '比較のためにチャートに追加のプレーヤーを表示します',
      gpi: 'GPI',
      numberOfPlayers: 'プレイヤー数',
      showingPlayerStatsLastSeason: '最後のアクティブシーズンのプレーヤーの平均統計のみを表示します',
      date: '日付',
      showChartLabels: 'ラベルを表示',
      marketValueTooltip: '範囲を入力して「適用」をクリックするか、Enter キーを押します。',
      freeAgents: 'Free Agents',
      selectPlayerFromTable: 'テーブルからプレーヤーを選択すると、GPI トレンドが表示されます。'
    }
  },
  iso: {
    AF: 'アフガニスタン',
    DZ: 'アルジェリア',
    AO: 'アンゴラ',
    AR: 'アルゼンチン',
    AU: 'オーストラリア',
    AZ: 'アゼルバイジャン',
    BH: 'バーレーン',
    BB: 'バーレーン',
    BE: 'ベルギー',
    BJ: 'ベナン',
    BO: 'ボリビア',
    BW: 'ボツワナ',
    BN: 'ブルネイ',
    BF: 'ブルキナファソ',
    KH: 'カンボジア',
    CA: 'カナダ',
    CF: '中央アフリカ共和国',
    CL: 'チリ',
    CO: 'コロンビア',
    CD: 'コンゴ民主共和国',
    CG: 'コンゴ',
    CI: 'コートジボアール',
    CU: 'キューバ',
    CZ: 'チェコ',
    DJ: 'ジブチ',
    DO: 'ドミニカ共和国',
    EC: 'エクアドル',
    SV: 'エルサルバドル',
    ER: 'エリトリア',
    ET: 'エチオピア',
    FI: 'フィンランド',
    PF: 'フランス領ポリネシア',
    GM: 'ガンビア',
    DE: 'ドイツ',
    GI: 'ジブラルタル',
    GL: 'グリーンランド',
    GP: 'グアドループ',
    GN: 'ギニア',
    GY: 'ガイアナ',
    HN: 'ホンジュラス',
    HU: 'ハンガリ-',
    IN: 'インド',
    IR: 'イラン',
    IE: 'アイルランド',
    IT: 'イタリア',
    JP: '日本',
    KZ: 'カザフスタン',
    KI: 'キリバス',
    KR: '韓国',
    KG: 'キルギスタン',
    LV: 'ラトビア',
    LS: 'レソト',
    LY: 'リビア',
    LT: 'リトアニア',
    MO: 'マカオ',
    MG: 'マダガスカル',
    MY: 'マレーシア',
    ML: 'マリ',
    MH: 'マーシャル諸島',
    MR: 'モーリタニア',
    MX: 'メキシコ',
    MD: 'モルドバ',
    MN: 'モンゴル',
    MA: 'モロッコ',
    MM: 'ミャンマー',
    NR: 'ナウル',
    NL: 'オランダ',
    NZ: 'ニュージーランド',
    NE: 'ナイジェリア',
    MP: 'マリアナ諸島',
    OM: 'オマーン',
    PW: 'パラオ',
    PA: 'パナマ',
    PY: 'パラグアイ',
    PH: 'フィリピン',
    PT: 'ポルトガル',
    QA: 'カタール',
    RO: 'ルーマニア',
    RW: 'ルワンダ',
    LC: 'セントルシア',
    SM: 'サンマリノ',
    SA: 'サウジアラビア',
    RS: 'セルビア',
    SL: 'シエラレオネ',
    SK: 'スロバキア',
    SB: 'ソロモン諸島',
    ZA: '南アフリカ',
    LK: 'スリランカ',
    SD: 'スーダン',
    SZ: 'エスワティニ',
    CH: 'スイス',
    TW: '台湾',
    TZ: 'タンザニア',
    TG: 'トーゴ',
    TT: 'トリニダード・トバゴ',
    TR: 'トルコ',
    TV: 'ツバル',
    UA: 'ウクライナ',
    GB: '英国',
    UY: 'ウルグアイ',
    VU: 'バヌアツ',
    VE: 'ベネズエラ',
    VG: 'イギリス領ヴァージン諸島',
    EH: '西サハラ',
    ZM: 'ザンビア',
    AL: 'アルバニア',
    AD: 'アンドラ',
    AG: 'アンティグア・バーブーダ',
    AM: 'アルメニア',
    AT: 'オーストリア',
    BS: 'バハマ',
    BD: 'バングラデシュ',
    BY: 'ベラルーシ',
    BZ: 'ベリーズ',
    BT: 'ブータン王国',
    BA: 'ボスニア・ヘルツェゴビナ',
    BR: 'ブラジル',
    BG: 'ブルガリア',
    BI: 'ブルンジ',
    CM: 'カメルーン',
    CV: 'カーボベルデ',
    TD: 'チャド',
    CN: '中国',
    KM: 'コモロ',
    CR: 'コスタリカ',
    HR: 'クロアチア',
    CY: 'キプロス',
    DK: 'デンマーク',
    DM: 'ドミニカ',
    TL: '東ティモール',
    EG: 'エジプト',
    GQ: '赤道ギニア',
    EE: 'エストニア',
    FJ: 'フィジ-',
    FR: 'フランス',
    GA: 'ガボン',
    GE: 'ジョージア',
    GH: 'ガーナ',
    GR: 'ギリシャ',
    GD: 'グレナダ',
    GT: 'グアテマラ',
    GW: 'ギニアビサウ',
    HT: 'ハイチ',
    HK: '香港',
    IS: 'アイスランド',
    ID: 'インドネシア',
    IQ: 'イラク',
    IL: 'イスラエル',
    JM: 'ジャマイカ',
    JO: 'ヨルダン',
    KE: 'ケニア',
    KP: '北朝鮮',
    KW: 'クウェート',
    LA: 'ラオス人民民主共和国',
    LB: 'レバノン',
    LR: 'リベリア',
    LI: 'リヒテンシュタイン',
    LU: 'ルクセンブルク',
    MK: '北マケドニア',
    MW: 'マラウィ',
    MV: 'モルディブ',
    MT: 'マルタ',
    MQ: 'マルティニーク',
    MU: 'モーリシャス共和国',
    FM: 'ミクロネシア連邦',
    MC: 'モナコ',
    ME: 'モンテネグロ',
    MZ: 'モザンビーク',
    NA: 'ナミビア',
    NP: 'ネパール',
    NC: 'ニューカレドニア',
    NI: 'ニカラグア',
    NG: 'ナイジェリア',
    NO: 'ノルウェー',
    PK: 'パキスタン',
    PS: 'パレスチナ領域',
    PG: 'パプア・ニューギニア',
    PE: 'ペルー',
    PL: 'ポーランド',
    PR: 'プエルトリコ',
    RE: 'レユニオン',
    RU: 'ロシア',
    KN: 'セントクリストファー・ネイビス',
    WS: 'サモア',
    ST: 'サントメ・プリンシペ',
    SN: 'セネガル',
    SC: 'セイシェル',
    SG: 'シンガポール',
    SI: 'スロベニア',
    SO: 'ソマリア',
    ES: 'スペイン',
    VC: 'セントビンセントおよびグレナディーン諸島',
    SR: 'スリナム',
    SE: 'スウェーデン',
    SY: 'シリア',
    TJ: 'タジキスタン',
    TH: 'タイ',
    TO: 'トンガ',
    TN: 'チュニジア',
    TM: 'トルクメニスタン',
    UG: 'ウガンダ',
    AE: 'アラブ首長国連邦',
    US: '米国',
    UZ: 'ウズベキスタン',
    VA: 'バチカン市国',
    VN: 'ベトナム',
    VI: 'アメリカ領ヴァージン諸島',
    YE: 'イエメン',
    ZW: 'ジンバブエ',
    EU: 'ヨーロッパ',
    INT: 'インターナショナル',
    CW: 'キュラソー',
    AFC: 'AFC',
    CONCACAF: 'CONCACAF',
    'GB-ENG': 'イングランド',
    'GB-WLS': 'ウェールズ',
    'GB-SCT': 'スコットランド',
    LATAM: '南アメリカ',
    CAF: 'シーエーエフ',
    XK: 'コソボ',
    AI: 'アンギラ',
    AN: 'オランダ領アンティル',
    AS: 'アメリカ領サモア',
    AW: 'アルバ',
    BM: 'バミューダ',
    BQ: 'ボネール',
    CK: 'クック諸島',
    FO: 'フェロー諸島',
    GF: 'ガイアナ',
    GG: 'ガーンジー邦領',
    GU: 'グアム準州',
    IM: 'マン島',
    JE: 'ジャージー島',
    KY: 'ケイマン諸島',
    MF: 'セント・マーチン島',
    MS: 'モンセラット',
    NU: 'ニウエ',
    OC: 'オセアニア',
    RI: 'インドネシア',
    SS: '南スーダン共和国',
    TC: 'タークス・カイコス諸島',
    YT: 'マヨット県」「マヨット県',
    SX: 'シント・マールテン'
  },
  loadingMessages: {
    players: '選手の準備中',
    teams: 'チームを整理中',
    games: '試合を回収中',
    stats: '指標の計算中',
    graphs: 'グラフの描画中',
    gettingReady: '準備中',
    placeholder: 'ダウンロード中'
  },
  requestReport: {
    subtitle: '必要なものが記載された詳細なレポートを受け取る',
    categories: {
      scouting: {
        title: 'スカウティング',
        subtitle: 'リーグで最高の選手は誰ですか? 他のリーグでは？ フィルター (年齢、身長、契約終了) を使用してカスタムリクエストし、最適なプレーヤーを見つけます。'
      },
      coaches: {
        title: '監督',
        subtitle: 'コーチはどのように動き、彼のスタイルとゲームをどのようにクラブに適応させるでしょうか? 詳細情報を取得するか、プロフィールを指定して、ニーズに合った監督を見つけてください。'
      },
      'team analysis': {
        title: 'チーム分析',
        subtitle: 'チームに関する詳細な情報を取得します。スタイル、守備と攻撃のパフォーマンス、弱点、最高の選手など...'
      },
      'game analysis': {
        title: '試合の分析',
        subtitle: '試合が与えられると、詳細な情報と共に試合前後の分析を取得します。'
      },
      'special projects': {
        title: 'スペシャルプロジェクト',
        subtitle: '選手はアウェイでどのようにパフォーマンスしますか? 選手は今のリーグから違うリーグへとどのように変化しますか? レンタルで獲得できる選手は？ 質問があれば聞いてください。'
      },
      conversation: {
        title: '会話',
        subtitle: '私たちのチームと会話を始めます。'
      }
    },
    notesPlaceholder: '情報が必要なリーグ、プロフィール、監督、チーム、または試合を指定してください。',
    chooseType: 'レポートの種類を選択',
    requestSummary: 'リクエストの概要',
    reportType: 'レポートの種類',
    reportLanguage: 'レポートの言語',
    detailTitle: 'レポートのフォローアップ',
    detailSubtitle: 'ご要望のレポートに関するすべての情報'
  },
  bugReport: {
    modalSubtitle: '私たちが改善するのを手伝ってください。',
    about: 'について',
    sendSuccess: '正常に送信されました。 受信トレイから確認してください。',
    bugs: 'エラー'
  },
  gbe: {
    autopass: 'Auto Pass',
    bandX: 'Band {0}',
    bandXCont: 'Band {0} Continental Competition',
    points: 'ポイント',
    titleWinner: 'Title Winner',
    qualifiedGroupsBandX: 'Qualified for group stage of a Band {0} Continental Competition',
    qualifiedQualifiersBandX: 'Qualified for qualifiers of a Band {0} Continental Competition',
    midTable: 'Mid-Table',
    relegation: '降格',
    promotion: '昇格',
    final: '決勝',
    semifinal: '準決勝',
    quarterfinal: '準々決勝',
    round16: 'ベスト16',
    round32: 'ベスト32',
    groupstage: 'グループステージ',
    firstRound: '1回戦',
    secondRound: '2回戦',
    thirdRound: '3回戦',
    fourthRound: '4回戦',
    preliminaryRound: '予選ラウンド',
    other: 'その他',
    score: 'スコア',
    totalSummary: 'Total Summary',
    currentlyPlayingInUK: 'The player is a citizen of the United Kingdom or Ireland, or the player is a permanent resident in the United Kingdom',
    bandsAlert: 'There are minutes played in more than one band, total is the max value',
    bandsAlertMax: 'There are minutes played in more than one band, total is the max value',
    bandsAlertAvg: 'There are minutes played in more than one band, total is the average value',
    generate: 'GBEApplicationForm',
    debutYouthPlayer: 'Debut for Youth Player',
    table1: {
      name: 'Player´s International Appearances',
      title1: 'Aggregated FIFA World Ranking of the Player’s National Association',
      title2: 'Player’s International Appearances'
    },
    table2: {
      name: 'Player’s Domestic Minutes',
      title1: 'Player’s Domestic Minutes'
    },
    table3: {
      name: 'Player’s Continental Minutes',
      title1: 'Player’s Continental Minutes'
    },
    table4: {
      name: 'Final League Position of Player´s Last Club',
      title1: 'Last Club’s Final League Position'
    },
    table5: {
      name: 'Continental Progression of Player´s Last Club',
      title1: 'Continental Progression'
    },
    table6: {
      name: 'League Quality of Player´s Current Club',
      title1: 'Band of Player’s Current Club'
    },
    table7: {
      name: 'Youth - Debut',
      title1: 'Band'
    },
    table8: {
      name: 'Youth - Final League Position',
      title1: 'Last Club’s Final League Position'
    },
    table9: {
      name: 'Youth - Continental Progression',
      title1: 'Continental Progression'
    },
    table10: {
      name: 'Youth - League Quality of Player´s Current',
      title1: 'Band of Player’s Current Club'
    },
    table11: {
      name: 'Youth - League Quality of Player´s Current',
      title1: 'Band of Player’s Current Club'
    },
    table12: {
      name: 'Youth - International Appearances',
      title1: 'Player\'s International Appearances'
    }
  },
  mediaMode: {
    borderColor: '縁の色',
    fillColor: '塗りつぶしの色',
    bgColor: '背景色',
    upperText: '上部テキスト',
    lowerText: '下部テキスト',
    socialMedia: 'ソーシャルメディア',
    textColor: 'テキストの色',
    axisColor: '目の色',
    logo: 'ロゴ',
    comparisonBorderColor: '縁の色比較',
    comparisonFillColor: '塗りつぶしの色比較',
    comparisonUpperText: '上部テキスト比較n',
    comparisonLowerText: '下部テキスト比較',
    homeFillColor: '塗りつぶしの色 (ホーム)',
    homeBorderColor: '縁の色 (ホーム)',
    awayFillColor: '塗りつぶしの色 (アウェイ)',
    awayBorderColor: '縁の色 (アウェイ)',
    face: '顔',
    nationalTeam: '代表チーム',
    comparisonFace: '顔比較',
    upperTextX: '上部テキスト {0}',
    lowerTextX: '下部テキスト {0}',
    borderColorX: '縁の色 {0}',
    fillColorX: '塗りつぶしの色 {0}',
    homeFillColorX: '塗りつぶしの色 (ホーム) {0}',
    homeBorderColorX: '縁の色 (ホーム) {0}',
    awayFillColorX: '塗りつぶしの色 (アウェイ) {0}',
    awayBorderColorX: '縁の色 (アウェイ) {0}',
    faceX: '顔 {0}',
    selectField: 'プロパティを選択',
    orientationX: 'オリエンテーション {0}',
    searchBarPlaceholder: '選手や試合を検索...',
    title: 'メディア - スコア表',
    pageSubtitle: '地図と画像の閲覧およびダウンロード',
    chooseChart: 'グラフを選択...',
    headerTextX: 'Tヘッダーテキスト{0}',
    avatarLineLength: 'アバターラインの長さ',
    avatarLineWeight: 'アバターラインの太さ',
    avatarSize: 'アバターの大きさ',
    chartX: 'クラフ {0}',
    chartHeaderFontSize: 'グラフタイトルのサイズ',
    chartHeaderFontWeight: 'グラフタイトルの太さ',
    upperTextFontSize: '上部のテキストのサイズ',
    upperTextFontWeight: '上部のテキストの太さ',
    lowerTextFontSize: '下部のテキストのサイズ',
    lowerTextFontWeight: '下部のテキストの太さ',
    socialMediaFontSize: 'ソーシャルメディアのテキストのサイズ',
    socialMediaFontWeight: 'ソーシャルメディアのテキストの太さ',
    subtitle: 'サブタイトル',
    subtitleFontSize: 'サブタイトルの大きさ',
    subtitleFontWeight: 'サブタイトルの太さ',
    subtitleX: 'サブタイトル {0}',
    subtitleFontSizeX: 'サブタイトルの大きさ {0}',
    subtitleFontWeightX: 'サブタイトルの太さ {0}',
    titleX: 'タイトル {0}',
    titleFontSize: 'タイトルの大きさ',
    titleFontWeight: 'タイトルの太さ',
    sponsor: 'スポンサー',
    fontFamily: 'Font family'
  },
  documents: {
    types: {
      SCOUTING_REPORT: 'スカウトレポート',
      GAME_REPORT: '試合のレポート',
      MEDICAL_REPORT: '医療レポート',
      PHYSICAL_REPORT: 'フィジカルレポート',
      PSYCHOLOGICAL_REPORT: '心理レポート',
      OTHER: 'その他',
      QUICK_NOTES: 'メモ',
      PLAYER_REPORT: 'プレイヤーレポート',
      GENERAL_COMMENTS: '総評',
      PLAYER_ANALYSIS: '選手分析'
    },
    uploadDocument: '書類をアップロード',
    notesPlaceholder: 'ドキュメントに関連する記述、注意事項を示します。',
    notesPlaceholderAlt: '選手に関連する記述、注意事項を示します。',
    uploadedBy: 'によってアップロードされました',
    updatedBy: 'によってアップデートされました',
    seeNotes: 'メモをみる',
    addNote: 'メモを追加',
    rating: 'レーティング',
    position: 'ベストポジション',
    physical: 'フィジカル',
    onBall: 'オンボール',
    offBall: 'オフボール',
    mental: 'メンタル',
    potential: 'ポテンシャル',
    conclusion: '結論',
    recommendation: {
      1: '契約する',
      2: 'モニターする',
      3: '放棄する',
      4: '興味深い',
      label: '推薦'
    },
    match: '試合',
    deleteQuickNote: 'メモを削除',
    deleteQuickNoteMessage: 'メモが完全に削除されます。よろしいですか？',
    noQuickNotes: 'データがありません。メモの追加から始めてください！',
    deleteDocument: 'ドキュメントを削除',
    deleteDocumentMessage: 'ドキュメントは完全に削除されます。よろしいですか？',
    noDocuments: 'データがありません。ドキュメントの追加から始めてください！'
  },
  notifications: {
    newReportMessage: 'レポートに1件の新しいメッセージがあります'
  },
  blog: {
    subtitle: '最新の記事、予告、ニュース',
    newEntry: '新しい投稿',
    title: 'タイトル',
    text: 'テキスト',
    link: 'リンク',
    image: 'イメージ',
    author: '作成者',
    date: '発行日',
    deleteEntry: '投稿を削除',
    deleteEntryMessage: 'この投稿を削除してもよろしいですか?',
    readMore: 'もっと読む'
  },
  positionsOrlegi: {
    GK: 'ゴールキーパー',
    DC: 'センターバック',
    DR: 'サイドバック',
    MC: 'ミッドフィールダー',
    AMC: 'トップ下',
    FW: 'フォワード',
    FWR: 'ウインガー'
  },
  library: {
    subtitle: '更新されたドキュメントの表示と共有',
    mediaSubtitle: 'エクスポートしたグラフの表示と共有',
    charts: 'グラフ',
    goToLibrary: '図書館に行く'
  },
  scatterPlot: {
    bubbleSize: 'バブルチャート',
    byMinutes: '時間ごと',
    byAge: '年齢ごと',
    byMarketValue: '価値ごと'
  },
  eventChart: {
    successfulEvent: '成功',
    unsuccessfulEvent: '失敗しました',
    possessionLost: '成功しても回復しない',
    successfulPass: '成功したパス',
    unsuccessfulPass: '失敗したパス',
    successfulCarry: '成功したドリブル',
    unsuccessfulCarry: '失敗したドリブル',
    carryAndKeyPass: 'ボールを運んでパス',
    carryAndAssist: 'ボールを運んでアシストa',
    carryAndShot: 'ボールを運んでシュート',
    ballProgressionAndPass: 'ボールを前進させてからパス',
    ballProgression: 'ボールを前進させる',
    ballProgressionAndKeyPass: 'ボールを前進させてからキーパス',
    ballProgressionAndAssist: 'ボールを前進させてからアシスト',
    ballProgressionAndShot: 'ボールを前進させてからシュート',
    ballProgressionAndGoal: 'ボールを前進させてからゴール',
    pass: 'パス',
    carryAndPass: 'ボールを運んでパス',
    carryAndGoal: 'ボールを運んでゴール',
    totalTouches: '合計タッチ数',
    totalPasses: '合計パス',
    successful: '成功',
    unsuccessful: '失敗',
    tacklePossessionLost: '成功 - 所有権が失われました',
    gamesSelected: '{count} 試合を選択',
    allGamesOfSeason: 'シーズン全試合',
    allGamesOfSeasons: '全シーズン全試合',
    allEvents: 'すべてのイベント',
    eventTypesCount: '{count}種類のイベント',
    totalEvents: 'イベント総数',
    zoneDominanceNote: '各ゾーンで各チームが示したタッチは成功したタッチのみを表します',
    selectedEvents: '選択されたイベント'
  },
  event: {
    Pass: 'パス',
    TakeOn: 'ドリブル',
    Takeon: 'ドリブル',
    Foul: 'ファール',
    Error: 'エラー',
    Tackle: 'タックル',
    Interception: 'インターセプト',
    Clearance: 'クリア',
    MissedShot: '外したシュート',
    ShotOnPost: 'バー、ポストに当たったシュート',
    SavedShot: '止められたシュート',
    Goal: 'ゴール',
    Aerial: '空中戦',
    BallRecovery: 'ボール奪取',
    Dispossessed: 'ボールロスト',
    ChanceMissed: '逃したチャンス',
    BallTouch: 'ボールタッチ',
    BlockedPass: 'ブロックされたパス',
    Challenge: 'チャレンジ',
    lossPossession: 'ポゼッションを失う',
    OffsidePass: 'オフサイドパス',
    groundDuelsLost: '地上戦のデュエル敗北数',
    'Ball touch': 'ボールタッチ',
    Smother: 'カバー',
    'Keeper pickup': '地面からボールを拾う',
    'Good skill': '巧みな動き',
    Punch: 'パンチング',
    'Saved shot': '止められたシュート',
    'Shot on post': 'バー、ポストに当たったシュート',
    'Missed shot': '外したシュート',
    Save: 'セーブ',
    'Take on': 'ドリブル',
    'Offside pass': 'オフサイドパス',
    Claim: 'センタリングのボールをキャッチ',
    'Blocked pass': 'ブロックされたパス',
    KeeperPickup: 'キーパーピックアップ',
    'Ball recovery': 'ボール奪取',
    'Ball Recovery': 'ボール奪取',
    'Chance missed': '逃したチャンス',
    'Loss possession': 'ポゼッションを失う',
    Carries: 'ドリブル',
    BallProgression: 'ボールの進行',
    MissedChance: '逃したチャンス',
    Event: 'イベント',
    Shot: 'シュート',
    Assist: 'アシスト',
    KeyPass: 'キーパス',
    'Foul taken': 'ファールレシーブ'
  },
  leagueTab: {
    leagueTable: '順位表',
    matchdays: '節',
    playerInsights: 'キープレーヤー',
    onlyLocalPlayers: 'ローカルプレイヤーのみ',
    teamInsights: 'キーチーム',
    head2head: '1対1',
    addNewChart: 'グラフを追加',
    rounds: {
      16: 'ベスト16',
      32: 'ベスト32',
      W: '優勝',
      F: '決勝',
      SF: '準決勝',
      QF: '準々決勝',
      GR: 'グループリーグ',
      '4R': '4回線',
      '3R': '3回線',
      '2R': '2回線',
      '1R': '1回線',
      PR: '予選ラウンド',
      QPO1: 'ベスト16　下のレベル',
      QPO2: 'プレベスト32',
      QPO3: '予選ラウンド オブ 32'
    },
    positions: 'ポジション',
    prediction: '予測',
    predicted: '予測',
    groups: 'グループ',
    ranking: '順位表',
    numberOfTeams: 'チーム数',
    statsWithMinimum: {
      message: '選択したシーズンで{0}{1}を超える選手のみを表示',
      dribblesTotal90: '90分あたりのドリブル数',
      crosses90: '90分あたりのクロス数',
      tacklesAttempted90: '90分あたりのタックル試行数',
      aerialsTotal90: '90分あたりの空中戦数'
    },
    numberOfLeagues: 'リーグ数',
    position: {
      titleWinner: 'タイトル獲得者',
      championsLeague: 'チャンピオンズリーグ',
      qualifierChampionsLeague: 'チャンピオンズリーグ予選',
      europeLeague: 'ヨーロッパリーグ',
      qualifierEuropeLeague: 'ヨーロッパリーグ予選',
      conferenceLeague: 'カンファレンスリーグ',
      qualifierConferenceLeague: '予選カンファレンスリーグ',
      midTable: 'ミッドテーブル',
      relegation: '降格',
      promotion: 'プロモーション',
      relegationPlayoff: '降格プレーオフ',
      promotionPlayoff: '昇格プレーオフ',
      championshipGroup: 'チャンピオンシップグループ',
      relegationGroup: '降格グループ',
      championshipPlayoffs: 'チャンピオンシッププレーオフ',
      preChampionshipPlayoffs2: 'プレチャンピオンシッププレーオフ 2',
      preChampionshipPlayoffs3: 'プレチャンピオンシッププレーオフ 3',
      playoffsQualifierBand3: 'プレーオフ予選バンド 3',
      continentalGroup: 'コンチネンタルグループ'
    },
    group: {
      1: 'あ',
      2: 'B',
      3: 'C',
      4: 'D',
      5: 'E',
      6: 'F',
      7: 'G',
      8: 'H',
      9: '私',
      10: 'J',
      11: 'K',
      12: 'L'
    }
  },
  similarity: {
    subtitle: '似た選手を探す',
    searchBarPlaceholder: '似た選手を見つけるために、プレーヤーを検索します',
    radarFilters: 'レーダーフィルター',
    similarityFilters: '類似のフィルター',
    playersFilters: '選手のフィルター',
    similarPlayers: '似た選手',
    seasonWarning: '450分以上プレーしたシーズンのみが利用可能です'
  },
  squadBuilder: {
    subtitle: '独自のテンプレートを作成してモデル化する',
    playerSelector: '選手カタログ',
    loadSquad: 'チームをロード',
    yearsOld: '歳',
    playersPerPosition: 'ポジション毎の選手',
    custom: 'カスタム',
    removeSquad: 'スクワッドを削除する',
    removeSquadMessage: '本当にスクワッドを削除しますか?',
    deleteSquadSuccess: 'スクワッドは正常に削除されました',
    playerDetails: '詳細の可視性',
    ageFormat: '年齢の形式',
    mainPlayer: '主要な選手',
    showDetails: '詳細を表示',
    all: 'すべて',
    squadPosition: 'チーム内のポジション',
    noData: 'データがありません。まずはピッチに選手を追加してください！'
  },
  tours: {
    buttons: {
      dontShowAgain: 'ドント・ショウ・アゲイン',
      skipTour: 'ガイドツアーをスキップする',
      previous: '前へ',
      next: '次へ',
      finish: '終了'
    },
    playerRadar: {
      step1: {
        title: 'パーソナル・ファイル',
        message: '選手の基本データ（年齢、身長、契約日）の確認'
      },
      step2: {
        title: 'GBEフィルター',
        message: '英国でプレーするのに十分なGBEポイントを保有しているかどうかを知ることができる機能'
      },
      step3: {
        title: 'アベイラビリティ',
        message: '出場可能な時間の割合と出場した時間の割合'
      },
      step4: {
        title: 'ポジション',
        message: 'どのポジションで何分プレーしたかを調べる'
      },
      step5: {
        title: '表示形式',
        message: 'レーダー、ポーラー、ロリポップ、テキストの4種類のビジュアライゼーションでパフォーマンスを測定し、同じポジションの選手と比較することができます。'
      },
      step6: {
        title: 'パフォーマンスレーダー',
        message: 'ここでは、パフォーマンスが視覚的に反映されます。パネルはインタラクティブで、各指標にカーソルを合わせると、その定義を知ることができます。'
      },
      step7: {
        title: 'シーズンセレクション',
        message: 'パフォーマンスを測定するためにシーズンを選択または追加する'
      },
      step8: {
        title: 'カスタムテンプレート選択',
        message: '作成したカスタムテンプレートを使って、標準のレーダーとは異なる指標で選手を計測します'
      },
      step9: {
        title: '選曲',
        message: 'さまざまなポジションのチェックを外して、測定したいポジションで彼を測定します'
      },
      step10: {
        title: '選り抜き',
        message: '自分のシーズン、トップ5リーグ、ユーザーアカウントの自シーズンとデフォルトシーズンの高低差でプレイヤーを測定します。'
      },
      step11: {
        title: '比較対象',
        message: '過去の成績、同じポジションの他の選手、ポジションの平均と比較する。'
      },
      step12: {
        title: 'イメージダウンロードフォーマット',
        message: 'ダウンロード形式は、png、svg、embedの3種類です。'
      }
    },
    playerRanking: {
      step1: {
        title: 'シーズン、チーム、ポジション',
        message: '選手を比較するシーズン、チーム、ポジションを選択する'
      },
      step2: {
        title: '基本的なフィルター',
        message: '年齢、プレイ時間、身長で選手をフィルタリングする'
      },
      step3: {
        title: 'ハイライトと除外',
        message: '必要な選手をハイライトし、表示中のチームを除外する'
      },
      step4: {
        title: 'カテゴリーで絞り込む',
        message: 'カテゴリーで統計をフィルタリングする アソシエーション、ディフェンス、パス、ボールハンドリング、その他'
      },
      step5: {
        title: 'イメージダウンロードフォーマット',
        message: 'ダウンロード形式は、png、svg、embedの3種類です。'
      }
    },
    playerFinishing: {
      step1: {
        title: 'ディスプレイを選択する',
        message: 'フィニッシングマップをメインビュー、ゴールビュー、分布表で見ることができます'
      },
      step2: {
        title: 'シーズン選択',
        message: 'シーズンを追加して、シュート効率を測定する'
      },
      step3: {
        title: 'シュート位置',
        message: 'シュートの正確な位置（円）またはボックスとピッチのエリア（エリア）を表示する可能性を選択します。'
      },
      step4: {
        title: 'xG ON TARGET',
        message: 'xG to GoalとxG Completionのボックスにチェックを入れると、シュート後に選手がどのような付加価値をつけたかを確認することができます。'
      },
      step5: {
        title: 'シュートタイプ',
        message: 'シュートタイプ、戦略、エリア、体の部位でフィルタリングします。'
      },
      step6: {
        title: '分数フィルター',
        message: '特定のゲームピリオドで獲得したショットとゴールを選択するためのミニッツバー'
      },
      step7: {
        title: 'イメージダウンロードフォーマット',
        message: 'ダウンロード形式は、png、svg、embedの3種類です。'
      },
      step8: {
        title: 'シュートマップ',
        message: '地図はインタラクティブに表示されます。マウスで各サークルをチェックすると、各ショットのXGがわかります。'
      }
    },
    playerKeyPass: {
      step1: {
        title: 'シーズン選択',
        message: 'シーズンを追加して、シュート効率を測定する'
      },
      step2: {
        title: 'キーパス位置',
        message: 'キーパスの正確な位置（円）またはエリアとフィールドのエリア別（エリア）で表示する可能性を選択する'
      },
      step3: {
        title: 'キーパス後のフィニッシュのタイプ',
        message: 'キーパス後のシュート、戦略、エリア、ボディパーツの種類でフィルタリングします。'
      },
      step4: {
        title: '議事録のフィルタリング',
        message: '特定のゲームピリオドで獲得したショットとゴールを選択するためのミニッツバーです。'
      },
      step5: {
        title: 'イメージダウンロードフォーマット',
        message: 'ダウンロード形式は、png、svg、embedの3種類です。'
      },
      step6: {
        title: 'キーパス・マップ',
        message: 'この地図はインタラクティブに表示されます。各パスのxAを知るには、マウスで各円を参照してください。'
      }
    },
    playerThreat: {
      step1: {
        title: 'シーズン選択',
        message: 'シーズンを追加して、シュート効率を測定します。'
      },
      step2: {
        title: '脅威の位置',
        message: 'キーパスの正確な位置を表示する可能性を選択する（円）またはエリアとフィールドゾーンで表示する（エリア）。'
      },
      step3: {
        title: 'アクションとコンプリート',
        message: '地図上に表示したいアクションと完了の種類に応じて、チェックを入れたり外したりします。'
      },
      step4: {
        title: '分と脅威',
        message: '期間別、分単位、アクションの脅威値でフィルタリングします。'
      },
      step5: {
        title: 'イメージダウンロードフォーマット',
        message: 'ダウンロード形式は、png、svg、embedの3種類です。'
      },
      step6: {
        title: '脅威マップ',
        message: 'このマップはインタラクティブです。各パスのxTプレイで発生する脅威を知るには、マウスで各円を参照してください。'
      }
    },
    playerTouches: {
      step1: {
        title: 'ゲームとイベントの選択',
        message: 'マップに表示したいゲームとイベントを選択します。'
      },
      step2: {
        title: 'イベントタイプ',
        message: 'ゲーム中のプレイヤーのイベントの防御的、攻撃的な性質に応じて、チェックを入れたり外したりする'
      },
      step3: {
        title: '表示フィルター',
        message: '基本動作、ヒートマップ、サークル、ボックスでマップをフィルタリングします。'
      },
      step4: {
        title: 'イメージダウンロードフォーマット',
        message: 'ダウンロード形式は、png、svg、embedの3種類です。'
      },
      step5: {
        title: 'タッチマップ',
        message: '地図はインタラクティブに表示されます。各イベントをクリックすることで、各イベントを見ることができます'
      }
    },
    playerAllGames: {
      step1: {
        title: 'アベイラビリティー',
        message: '試合ごとに空き状況やプレイ時間を確認できます。'
      },
      step2: {
        title: 'ポジション',
        message: '各試合での出場ポジションを確認する。'
      }
    },
    playerInjuries: {
      step1: {
        title: '履歴と損失日数',
        message: '過去1年間、または全履歴、日数による負傷の範囲を参照する。'
      },
      step2: {
        title: 'クラブ別怪我',
        message: 'シーズンやクラブごとに分けられた怪我の履歴を参照することができます。'
      }
    },
    playerInfo: {
      step1: {
        title: 'キャリアと移籍',
        message: '所属クラブ、代表チームでの出場時間、ポジション、出場機会の履歴や、キャリアを通じた選手の移籍を参照することができます'
      }
    },
    teamOverview: {
      step1: {
        title: 'チームシート',
        message: 'チームの基本データ（平均年齢、基本フォーメーション、ELO、移籍のバランス）を参照する'
      },
      step2: {
        title: '基本統計',
        message: 'ポゼッション、xG、シュート数、PPDA、垂直性について相談する'
      },
      step3: {
        title: 'レーダーとシーズン',
        message: 'レーダー、シーズン、ホームゲームまたはアウェイゲームを選択し、チームのパフォーマンスを測定する'
      },
      step4: {
        title: '監督と試合で絞り込む',
        message: '各コーチのステージ別パフォーマンスを選択'
      },
      step5: {
        title: 'パーフォマンス・レーダー',
        message: 'パネルはインタラクティブで、各メトリクスの上にカーソルを置くと、その定義が表示されます'
      },
      step6: {
        title: '画像ダウンロード形式',
        message: 'ダウンロード形式はpngとsvgの2種類。'
      },
      step7: {
        title: 'カレンダー',
        message: 'チームの試合スケジュールを見る'
      },
      step8: {
        title: 'メトリックス別ベストプレーヤー',
        message: 'このパネルでは、さまざまな指標を選択し、どの選手が最も重要な選手であるかを確認することができる'
      },
      step9: {
        title: '次の試合と負傷者',
        message: '次の対戦相手とチームの負傷者、出場停止選手をチェックする'
      },
      step10: {
        title: 'グラフとトレンド',
        message: '過去10試合または20試合のさまざまなグラフを見る'
      }
    },
    teamRoster: {
      step1: {
        title: 'ビュータイプ',
        message: 'ポジション別、契約満了別、年齢別、アベイラビリティ別、年齢プロフィール別、ピッチ別の6つのカテゴリーから代表選手を見ることができます'
      }
    },
    teamLoans: {
      step1: {
        title: 'ローン・プレーヤー',
        message: '他チームにレンタル移籍した選手とそのポジションを相談する'
      }
    },
    teamBeeswarm: {
      step1: {
        title: 'シーズンとメンバー',
        message: 'シーズン、レーダーチーム、お好みのリーグで比較できます'
      },
      step2: {
        title: 'メトリクス別パフォーマンス',
        message: '事前に選択したリーグの全チームと比較して、各指標におけるチームの位置を確認する'
      },
      step3: {
        title: '画像ダウンロード形式',
        message: 'ダウンロード形式はpng、svg、embedの3種類です'
      }
    },
    teamFinishingMap: {
      step1: {
        title: 'シーズン選択',
        message: 'シーズンを追加してシュート効率を測定'
      },
      step2: {
        title: '自陣または相手陣でのフィニッシュ',
        message: 'チームの完成マップを表示するか、対戦相手全員の完成マップを表示するかを選択する'
      },
      step3: {
        title: 'ショット・プレイスメント',
        message: 'チームのシュートをどのように表示するか、サークルかゾーン（ボックス）かを選択します'
      },
      step4: {
        title: 'ショットタイプ',
        message: 'ショットの種類、戦略、エリア、体の部位で絞り込む'
      },
      step5: {
        title: 'フィルター・ミニッツ',
        message: '特定の試合時間帯のシュートとゴールを選択するミニッツバー'
      },
      step6: {
        title: '画像ダウンロード形式',
        message: 'ダウンロード形式はpng、svg、embedの3種類です'
      },
      step7: {
        title: 'ショットマップ',
        message: '地図はインタラクティブです。各ショットのXGを知るには、マウスで各サークルをチェックする'
      }
    },
    teamKeyPassMap: {
      step1: {
        title: 'シーズン選択',
        message: 'シーズンを追加してシュート効率を測定'
      },
      step2: {
        title: '自社またはライバルのキーパス',
        message: 'チームの主要なパスのマップを表示するか、すべてのライバルのマップを表示するかを選択します'
      },
      step3: {
        title: 'キーパスの場所',
        message: 'キーパスの正確な位置を表示するか（丸印）、エリアやフィールドごとに表示するか（ボックス）を選択します'
      },
      step4: {
        title: 'パス後の仕上げのタイプ',
        message: 'キーパス後に行われたシュートの種類、戦略、エリア、体の部位によるフィルタリング'
      },
      step5: {
        title: 'フィルター・ミニッツ',
        message: '特定の試合時間帯のシュートとゴールを選択するミニッツバー'
      },
      step6: {
        title: '画像ダウンロード形式',
        message: 'ダウンロード形式はpng、svg、embedの3種類です'
      },
      step7: {
        title: 'ショットマップ',
        message: '地図はインタラクティブです。各パスのxAを知るために、マウスで各円を参照する'
      }
    },
    teamLatestGames: {
      step1: {
        title: '最新のゲーム',
        message: '全チームの試合結果、ポゼッション、xG、勝率を参照する'
      }
    },
    teamTransfers: {
      step1: {
        title: '到着',
        message: '暦年の全入荷（購入＋移籍）について相談する'
      },
      step2: {
        title: '出発',
        message: 'すべての出国者（販売＋移籍）を暦年で参照する'
      }
    },
    teamAnalysis: {
      step1: {
        title: 'トレンド',
        message: '連勝、勝利、クリーンシート、逆転劇、ゴールのあった期間、ゴールの種類などを通じて、チームのフォームを確認する'
      },
      step2: {
        title: 'セットプレー',
        message: 'セットプレーとオープンプレーの間でチームのパフォーマンスを比較し、セットプレーの詳細な概要を取得します'
      },
      step3: {
        title: 'サブスティテュート',
        message: 'チームがいつ交代を行い、どの選手が最も多く交代したかを確認する'
      },
      step4: {
        title: 'コネクション',
        message: '選手間の最も一般的な接続をご相談ください。シーズンとプレータイプで絞り込む'
      },
      step5: {
        title: '攻撃ゾーン',
        message: 'チームの攻撃ゾーンを発見し、シーズンや攻撃のタイプでフィルタリングする'
      },
      step6: {
        title: 'フォーメーション',
        message: '最もよく使われたフォーメーションと、それぞれのフォーメーションでの勝率、引き分け率、敗戦率をチェックする'
      },
      step7: {
        title: 'ショットゾーン',
        message: 'シーズン、チーム、対戦相手、マップの視覚化方法、シュートタイプ、分数によるフィルタリング'
      },
      step8: {
        title: '交差点',
        message: 'シーズン、表示の種類、成功または失敗、スタート地点とゴール地点、コーナーキックなどによる検索とフィルタリング'
      },
      step9: {
        title: 'プレーヤーズ',
        message: 'シーズン、ディスプレイの種類、成功したか失敗したか、スタート地点とゴール地点、コーナーキックを含むかどうかでフィルタリングする'
      }
    },
    teamOnOff: {
      step1: {
        title: 'Sシーズンと試合',
        message: 'シーズン、試合、ホームまたはアウェイゲームで絞り込む'
      },
      step2: {
        title: 'プレーヤーズ',
        message: '数え切れないほどの指標を通して、チーム内の全選手のパフォーマンスを見ることができます'
      }
    }
  },
  alerts: {
    numPlayers: 'プレイヤー数',
    newPlayersLastWeek: '先週の新規プレイヤー',
    subtitle: '検索で新しい選手が見つかったときに通知を受け取る',
    generalSubtitle: 'あなたの条件に基づいた新しい選手やお気に入りの選手のニュースに関するアラートを受け取る',
    subtitlePlayer: 'お気に入りの選手に関するニュースがある時にアラートを受け取る',
    subtitleSearch: '検索基準に合う新しい選手がいる場合にアラートを受け取る',
    favorite: 'お気に入り',
    newEventCalendar: '新しいイベント',
    updatedEventCalendar: '更新されたイベント',
    newShareFrom: 'からの新しい共有',
    injuryAlert: '負傷アラート',
    contractAlert: '契約アラート',
    teamAlert: 'サインアラート',
    marketValueAlert: '市場価値アラート',
    gameAlert: '試合出場アラート'
  },
  videoEvents: {
    highlights: 'ハイライト',
    fullGame: 'フルゲーム',
    autoplay: 'オートプレー',
    searchBarPlaceholder: '選手、チーム、試合を探す',
    subtitle: 'ビデオでイベントを分析する',
    successful: '成功',
    unsuccessful: '失敗',
    playing: '再生する',
    games: '試合',
    moreFilters: 'More filters...',
    startArea: 'Start area',
    endArea: 'End area',
    select: 'Select',
    selectLastXGames: 'Select last {0} games',
    advancedFilters: 'Advanced Filters',
    freeKicks: 'Free Kicks',
    cornerKicks: 'Corner Kicks',
    allShots: 'All Shots',
    generateZip: 'Generate ZIP',
    zippedModalMessage: 'ZIP process has been started, could take some minutes. You would receive an email when is finished',
    clickToSeeVideo: 'Click to see video'
  },
  videoUpload: {
    subtitle: 'Upload video and create new game',
    uploadVideo: 'Upload video',
    selectPeriod: 'Select period',
    gameData: 'Game Data',
    venue: 'Venue',
    matchType: 'Match type',
    matchGroup: 'Match group',
    roundType: 'Round type',
    roundNumber: 'Round number',
    offsetFh: 'Offset First Half',
    offsetSh: 'Offset Second Half',
    offsetFhOT: 'Offset Overtime First Half',
    offsetShOT: 'Offset Overtime Second Half',
    homeLineup: 'Home Lineup',
    awayLineup: 'Away Lineup',
    existingPlayer: 'Existing player',
    newPlayer: 'New player',
    startingTeam: 'Starting',
    saveAndUpload: 'Save and upload',
    existingGame: 'Game exists already',
    sendToKora: 'Send',
    invalidForm: 'Invalid form',
    warningModalTitle: 'Anomalies have been detected',
    noScoreSheetWarning: 'No scoresheet attached',
    onlyOnePartUploadedWarning: 'Only one half time attached',
    continueQuestion: 'continue?',
    slaLimit: '{1} を使用して {0} ゲームをアップロードしました。あなたの制限は {2} です',
    requestedGames: 'リクエストされた試合',
    limitClose: 'リクエスト可能な試合はあと{0}試合です',
    limitReached: '動画のアップロード上限に達しました。追加で試合をアップロードすると追加料金が発生する可能性があります。',
    seasonFinishedWarning: 'これにより、すでに終了したシーズンに試合が作成されます。正しいことを確認してください。',
    teamCountryWarning: 'このチームは、選択されたリーグの国とは異なる国のチームです。正しいことを確認してください。',
    uploading: 'アップロード中',
    doNotNavigateAway: 'アップロードの進行中は、このタブを閉じたり、ページを更新したり、別の場所に移動したりしないでください。',
    severalMinutes: 'このプロセスには数分かかる場合があります。'
  },
  videoPlaylists: {
    subtitle: 'Collections of video highlights filters',
    savePlaylist: 'Save Playlist',
    seeAllPlaylists: 'すべてのリストを見る'
  },
  videoHighlights: {
    recap: '要約',
    homeCondensed: 'ホーム凝縮ゲーム',
    awayCondensed: 'アウェイでの凝縮された試合',
    selectedActions: '選択されたアクション',
    noActions: '指定されたフィルター条件に一致するアクションはありません',
    noGames: 'まだ試合がアップロードされていません',
    attackingActions: '攻撃アクション',
    defensiveActions: '守備アクション',
    groundDuels: 'グラウンドデュエル',
    penaltiesProvoked: '誘発されたペナルティ',
    goalkeeperActions: 'ゴールキーパーのアクション',
    addSomeGames: '試合を追加して始めましょう！',
    goToVideoUploadTool: 'ビデオをアップロードする',
    ballInPlay: 'ボールがプレー中',
    filterSeasons: 'シーズンを絞り込む',
    streaming: 'ストリーミング',
    clips: 'クリップ',
    qualifiers: {
      Pass: 'パス',
      Save: 'セーブ',
      'Saved Shot': 'セーブされたシュート',
      Shot: 'シュート',
      Goal: 'ゴール',
      'Missed Shot': '枠外シュート',
      'Shot on Post': 'ポスト直撃シュート',
      Error: 'エラー',
      Clearance: 'クリア',
      Aerial: 'エアリアルデュエル',
      Challenge: 'デュエル敗北',
      Dispossessed: 'ボールロスト',
      Foul: 'ファウル',
      Card: 'カード',
      'Offside Pass': 'オフサイドパス',
      Claim: 'キャッチ',
      'Keeper Pickup': 'キーパーピックアップ',
      'Ball Touch': 'ボールタッチ',
      Dribble: 'ドリブル',
      Interception: 'インターセプト',
      Tackle: 'タックル',
      'Ball Recovery': 'ボールリカバリー',
      Takeon: 'ドリブル'
    },
    qualifierIds: {
      1: 'ロングパス',
      2: 'クロス',
      5: '直接フリーキック',
      6: 'コーナーキック',
      9: 'ペナルティキック',
      15: 'ヘディング',
      20: '右足',
      21: '体の他の部分',
      22: 'オープンプレー',
      23: 'カウンターアタック',
      24: 'セットプレー',
      25: 'コーナーから',
      26: 'フリーキック',
      28: 'オウンゴール',
      29: 'アシスト',
      31: 'イエローカード',
      32: '2枚目のイエローカード',
      33: 'レッドカード',
      72: '左足',
      73: '左',
      82: 'セーブされたシュート(GKなし)',
      94: 'ディフェンスブロック',
      123: 'ゴールキーパーのスロー',
      124: 'ゴールキック',
      160: 'スローイン',
      170: 'ゴールにつながる',
      173: '安全なクリア',
      174: '危険なクリア',
      177: 'キャッチ',
      178: '立って',
      179: 'ダイビングして',
      182: '手',
      183: '足',
      185: 'クロスブロック',
      210: 'アシスト',
      215: '個人プレー',
      279: 'キックオフ',
      285: 'ディフェンシブ',
      286: 'オフェンシブ'
    },
    areas: {
      goalArea: 'ゴールエリア',
      boxLeft: 'ペナルティエリア左',
      boxCenter: 'ペナルティエリア中央',
      boxRight: 'ペナルティエリア右',
      outBoxDeepLeft: 'ペナルティエリア外左',
      outBoxDeepRight: 'ペナルティエリア外右',
      outBoxLeft: 'ペナルティエリア外左',
      outBoxCentreLeft: 'ペナルティエリア外中央左',
      outBoxCentre: 'ペナルティエリア外中央',
      outBoxCentreRight: 'ペナルティエリア外中央右',
      outBoxRight: 'ペナルティエリア外右',
      midfieldLeft35: 'ミッドフィールド左',
      midfieldCentreLeft35: 'ミッドフィールド中央左',
      midfieldCentre35: 'ミッドフィールド中央',
      midfieldCentreRight35: 'ミッドフィールド中央右',
      midfieldRight35: 'ミッドフィールド右',
      ownGoalArea: '自陣ゴールエリア',
      ownBoxLeft: '自陣ペナルティエリア左',
      ownBoxCenter: '自陣ペナルティエリア中央',
      ownBoxRight: '自陣ペナルティエリア右',
      ownFieldOutOfBoxDeepLeft: '自陣エリア外左深部',
      ownFieldOutOfBoxDeepRight: '自陣エリア外右深部',
      ownFieldOutOfBoxLeft: '自陣エリア外左',
      ownFieldOutOfBoxCentreLeft: '自陣エリア外中央左',
      ownFieldOutOfBoxCentre: '自陣エリア外中央',
      ownFieldOutOfBoxCentreRight: '自陣エリア外中央右',
      ownFieldOutOfBoxRight: '自陣エリア外右',
      '6 YARD BOX': 'Goal area',
      'BOX RIGHT': 'Box right',
      'BOX CENTER': 'Box center',
      'BOX LEFT': 'Box left',
      'OUT BOX DEEP RIGHT': 'Out box deep right',
      'OUT BOX DEEP LEFT': 'Out box deep left',
      'OUT BOX RIGHT': 'Out box right',
      'OUT BOX LEFT': 'Out box left',
      'FINAL THIRD RIGHT': 'Final third right',
      'FINAL THIRD LEFT': 'Final third left',
      'FULL BOX': 'Full box',
      'OUT BOX DEEP RIGHT LARGE': 'Out box deep right large',
      'OUT BOX DEEP LEFT LARGE': 'Out box deep left large',
      'FINAL THIRD RIGHT LARGE': 'Final third right large',
      'FINAL THIRD LEFT LARGE': 'Final third left large',
      'OUT BOX CENTER RIGHT': 'Out box center right',
      'OUT BOX CENTER': 'Out box center',
      'OUT BOX CENTER LEFT': 'Out box center left',
      'FINAL THIRD CENTER RIGHT': 'Final third center right',
      'FINAL THIRD CENTER': 'Final third center',
      'FINAL THIRD CENTER LEFT': 'Final third center left',
      'OUT BOX CENTER RIGHT SMALL': 'Out box center right small',
      'OUT BOX CENTER SMALL': 'Out box center small',
      'OUT BOX CENTER LEFT SMALL': 'Out box center left small',
      'FINAL THIRD CENTER RIGHT LARGE': 'Final third center right large',
      'FINAL THIRD CENTER LARGE': 'Final third center large',
      'FINAL THIRD CENTER LEFT LARGE': 'Final third center left large',
      'OWN 6 YARD BOX': 'Own Goal area',
      'OWN BOX RIGHT': 'Own Box right',
      'OWN BOX CENTER': 'Own Box center',
      'OWN BOX LEFT': 'Own Box left',
      'OWN OUT BOX DEEP RIGHT': 'Own Out box deep right',
      'OWN OUT BOX DEEP LEFT': 'Own Out box deep left',
      'OWN OUT BOX RIGHT': 'Own Out box right',
      'OWN OUT BOX LEFT': 'Own Out box left',
      'OWN FINAL THIRD RIGHT': 'Own Final third right',
      'OWN FINAL THIRD LEFT': 'Own Final third left',
      'OWN FULL BOX': 'Own Full box',
      'OWN OUT BOX DEEP RIGHT LARGE': 'Own Out box deep right large',
      'OWN OUT BOX DEEP LEFT LARGE': 'Own Out box deep left large',
      'OWN FINAL THIRD RIGHT LARGE': 'Own Final third right large',
      'OWN FINAL THIRD LEFT LARGE': 'Own Final third left large',
      'OWN OUT BOX CENTER RIGHT': 'Own Out box center right',
      'OWN OUT BOX CENTER': 'Own Out box center',
      'OWN OUT BOX CENTER LEFT': 'Own Out box center left',
      'OWN FINAL THIRD CENTER RIGHT': 'Own Final third center right',
      'OWN FINAL THIRD CENTER': 'Own Final third center',
      'OWN FINAL THIRD CENTER LEFT': 'Own Final third center left',
      'OWN OUT BOX CENTER RIGHT SMALL': 'Own Out box center right small',
      'OWN OUT BOX CENTER SMALL': 'Own Out box center small',
      'OWN OUT BOX CENTER LEFT SMALL': 'Own Out box center left small',
      'OWN FINAL THIRD CENTER RIGHT LARGE': 'Own Final third center right large',
      'OWN FINAL THIRD CENTER LARGE': 'Own Final third center large',
      'OWN FINAL THIRD CENTER LEFT LARGE': 'Own Final third center left large'
    },
    outcomes: {
      success: '成功',
      fail: '失敗',
      possessionWon: 'ボール奪取',
      possessionNotWon: 'ボール奪取失敗',
      received: '受け取り',
      provoked: '誘発'
    },
    homePlayerHighlights: 'ホーム選手のハイライト',
    awayPlayerHighlights: 'アウェイ選手のハイライト'
  },
  share: {
    shareTo: 'Send to',
    viaApp: 'App (Driblab Message)',
    viaEmail: 'Email',
    description: 'Description',
    titleTab: 'Shares',
    toMe: '受領',
    fromMe: '送信済み',
    typeInternal: 'Internal',
    typeExternal: 'External',
    title: '共有された',
    subtitle: '共有リストのアイテムの概要',
    selectUser: 'ユーザーを選択',
    expired: '期限切れ',
    limitReached: 'リンクが使用制限に達しました'
  },
  homeStats: {
    data: '利用可能なデータ',
    players: '選手',
    totalPlayers: '全選手',
    teams: 'チーム',
    totalTeams: '全チーム',
    leagues: 'リーグ',
    totalLeagues: '全リーグ',
    seasons: 'シーズン',
    totalSeasons: '全シーズン',
    games: 'ゲーム',
    totalGames: '全ゲーム'
  },
  scoutingCalendar: {
    subtitle: 'スカウトタスクを作成し、整理する',
    myCalendars: 'プライベートカレンダー',
    publicCalendars: '公開カレンダー',
    otherCalendars: 'その他のカレンダー',
    calendarSettings: 'カレンダー設定',
    moreInfo: '詳細情報',
    individualScouting: '個別スカウティング',
    matchScouting: '試合スカウティング',
    calendarView: {
      type: 'カレンダータイプ',
      month: '月',
      week: '週',
      day: '日'
    },
    weekView: {
      type: '週の種類',
      monSun: '月曜日 - 日曜日',
      sunSat: '日曜日 - 土曜日',
      monFri: '月曜日 - 金曜日'
    },
    tasks: {
      addNew: '新しいタスクを追加',
      myTasks: '私のタスク',
      filterTasks: 'タスクをフィルターする',
      sharedWithMe: '私と共有されている',
      createTask: 'タスクを作成',
      newTask: '新しいタスク',
      taskName: 'タスク名',
      allDay: '終日',
      startDate: '開始日',
      endDate: '終了日',
      startHour: '開始時間',
      endHour: '終了時間',
      assignedTo: '割り当て先',
      assignedToMe: '私に割り当てられた',
      color: '色',
      scoutingType: 'スカウトの種類',
      taskLocation: 'タスクの場所',
      selectLeague: 'リーグを選択',
      selectMatch: '試合を選択',
      useMatchdate: '試合日を使用する',
      stadium: 'スタジアム',
      travel: '移動',
      hotel: 'ホテル',
      tickets: 'チケット',
      taskNotes: 'タスクに関連する説明的なノートまたはコメントを入力してください',
      states: {
        toDo: '未着手',
        inProgress: '進行中',
        done: '完了'
      },
      type: {
        player: '選手評価',
        team: 'チーム評価',
        other: 'その他'
      },
      location: {
        stadium: 'スタジアム内',
        video: 'ビデオ'
      },
      accommodation: {
        accommodationDetails: '宿泊詳細',
        ownArrangement: '自分で手配',
        required: '必要',
        notRequired: '不要',
        booked: '予約済み'
      },
      assignToMe: '私に割り当てる',
      addOther: '他を追加',
      deleteTask: 'タスクを削除',
      deleteTaskMessage: 'タスクは削除されます、よろしいですか？',
      cancelUpdate: '更新をキャンセル',
      cancelUpdateMessage: '変更は保存されません、よろしいですか？',
      selectGame: 'ファイルを追加する試合を選んでください',
      noData: 'データがありません。タスクを追加して始めましょう！',
      widgetSubtitle: '次のタスクを確認してください',
      scoutingDetails: 'スカウティングの詳細',
      taskDetails: 'タスクの詳細',
      playerDocuments: '選手の書類',
      teamDocuments: 'チームの書類',
      gameDocuments: '試合の書類',
      taskDocuments: 'タスクの書類',
      task: 'タスク'
    },
    nextGames: '次の試合'
  },
  scoutingTasksBoard: {
    period: {
      week: '今週',
      month: '今月',
      year: '今年'
    },
    noTasks: '新しいタスクを作成するか、ここにドラッグしてください！',
    goToBoard: 'ボードに行く'
  },
  profile: {
    title: 'プロフィール',
    subtitle: 'アカウントとサブスクリプションの詳細をカスタマイズする'
  },
  hub: {
    onlyHub: 'Driblab Hubでのみ利用可能',
    blue: '青',
    purple: '紫',
    orange: 'オレンジ',
    grey: 'グレー',
    indigo: 'インジゴ',
    teal: 'ティール',
    lightBlue: '水色',
    brown: '茶色'
  },
  uploadedGames: {
    subtitle: 'アップロードされた試合映像',
    timeRequested: '更新日時',
    timeReceived: 'When it was received',
    diffHours: 'Difference in hours',
    collectionCompleted: 'Collection completed',
    dateFrom: 'Date from',
    dateTo: 'Date to',
    goToUploadedGames: 'アップロードされた試合に移動',
    sla: 'サービスレベル合意',
    matchDate: '試合日',
    rejectedGame: '却下',
    reviewed: 'レビュー済み',
    requested: 'リクエスト済み',
    koraStatus: 'Kora のステータス',
    aws: 'AWS',
    fullVideo: 'フルビデオ',
    offset: 'オフセット',
    updateFullVideo: 'フルビデオを更新しますか？'
  },
  gameMap: {
    title: 'ゲームマップ',
    subtitle: '翌日の試合を探る',
    warning: '時間と場所が正しくない可能性があります。この情報を確認してください。',
    taskAdded: 'タスクが正常に作成されました。Scouting Calendarを確認してください。'
  },
  leagueRequestAccess: {
    sendSuccess: '正常に通知されました',
    notPermissions: '閲覧する権限がありません',
    notPermissionsLeague: 'このリーグを閲覧する権限がありません',
    notPermissionsGame: 'この試合を閲覧する権限がありません',
    requestAccessTo: 'アクセスをリクエストする',
    sendRequest: 'リクエストを送信'
  },
  videoTeams: {
    subtitle: 'チーム別にタグ付けされた最新の試合を見つける',
    noGamesUploaded: 'まだ試合はアップロードされていません'
  },
  scoutingAnalysis: {
    scoutingAnalysis: 'スカウティング分析',
    scoutingAnalyses: 'スカウティング分析',
    playerScoutingAnalyses: '選手スカウティング分析',
    gameScoutingAnalyses: '試合スカウティング分析',
    analyses: '分析',
    addReport: '分析を追加',
    technical: '技術的',
    tactical: '戦術的',
    physical: '身体的',
    mental: '心理的',
    technicalNotes: '技術的なメモ',
    tacticalNotes: '戦術的なメモ',
    physicalNotes: '身体的なメモ',
    mentalNotes: '心理的プロファイルのメモ',
    conclusion: '結論',
    charactersMax: '最大1000文字',
    globalRating: '総合評価',
    noData: 'データなし。スカウティング分析の追加から始めましょう！',
    deleteAnalysis: 'スカウティング分析を削除',
    deleteAnalysisMessage: '分析は完全に削除されます。よろしいですか？',
    avgTooltip: 'あなたに表示される分析の最終評価に基づく平均',
    avgOverallScoreTooltip: '平均はあなたが見ることができる選手の全体的なスコアに基づいています',
    scouter: 'スカウター',
    lastEdited: '最終編集',
    analysisFilters: '分析フィルター',
    generalFilters: '一般フィルター',
    widgetSubtitle: '追加された最新の分析',
    addPlayerReport: '選手のスカウティング分析を追加',
    seeReports: 'レポートを見る',
    addGameReport: '試合のスカウティング分析を追加',
    keyPlayers: 'キープレーヤー',
    formation: 'フォーメーション',
    inPossession: 'ボール保持時',
    notesIP: 'ボール保持時のメモ',
    outOfPossession: 'ボール非保持時',
    notesOP: 'ボール非保持時のメモ',
    transitions: 'トランジション',
    notesTransitions: 'トランジションのメモ',
    notesSP: 'セットプレーのメモ',
    finalRating: '最終評価',
    gameNotesPlaceholder: '試合に関する説明的なメモやコメントを入力',
    avgPotentialTooltip: '表示可能な分析の可能性に基づく平均',
    potential: '潜在的',
    tags: 'タグ',
    tagsPlaceholder: 'いくつかのタグを追加する',
    tagsHint: 'タグを追加するには、入力して Enter キーを押します',
    exampleTags: {
      leadership: 'リーダーシップ',
      resilience: '回復力',
      competitiveMindset: '競争意識',
      calmUnderPressure: 'プレッシャーの下でも冷静に',
      focus: '集中',
      discipline: '規律',
      coachability: 'コーチング能力',
      poorBodyLanguage: 'ボディーランゲージが悪い',
      lowConfidence: '低い信頼性',
      easilyFrustrated: 'イライラしやすい'
    },
    totals: 'Totals',
    byPossession: 'By Possession'
  },
  addPlayerForm: {
    noLeague: 'リーグなしでチームを作成すると、そのインデックス作成とアプリケーション内での後の検索に悪影響を及ぼす可能性があります。'
  },
  expenses: {
    expense: '費用',
    expenses: '経費',
    addExpense: '費用を追加',
    transportation: '交通',
    accommodation: '宿泊',
    dietary: '食事',
    eventTicket: 'イベントチケット',
    expenseType: '費用の種類',
    amount: '金額',
    expenseDate: '費用の日付',
    expenseFilters: '経費フィルター',
    noData: 'データがありません。経費を追加して始めましょう！',
    deleteExpense: '経費を削除',
    deleteExpenseMessage: '経費は永久に削除されます。本当によろしいですか？'
  },
  disabledTooltips: {
    general: 'この機能は現在無効です',
    youth: '年齢を設定するにはユースである必要があります',
    unit: '統計はRuns、HSR、またはSPRでなければなりません',
    seasonsWithout60MinsGames: '選択されたシーズンで、選手は1試合で60分以上プレーしていません',
    notEditable: 'これは編集できません',
    noMatchdate: '試合日が利用できません',
    selectGame: 'まず試合を選択してください',
    selectPlayer: 'まず選手を選択してください',
    selectTeam: 'まずチームを選択してください',
    selectBoxes: 'ボックスの可視化を選択する必要があります',
    selectYear: 'まず年を選択してください',
    pdScoreNotAvailable: '試合で60分間プレーしていない選手にはスコアは表示されません',
    pdSeasonNotAvailable: '今シーズンのフィジカルデータは利用できません',
    pdGameNotAvailable: 'この試合のフィジカルデータは利用できません'
  },
  leagueTypes: {
    regular: 'レギュラー',
    continental: '大陸',
    nationalTeam: 'ナショナルチーム',
    countryCup: '国内カップ',
    qualifier: '予選',
    playOff: 'プレーオフ',
    regionalLeague: '地域リーグ',
    friendly: '親善試合',
    nationalFriendly: '国内親善試合',
    nationaQualifier: '国内予選'
  },
  playerSides: {
    'Left/Right': '左/右',
    'Left/Centre/Right': '左/中央/右',
    Right: '右',
    Centre: '中央',
    'Centre/Right': '中央/右',
    Left: '左',
    'Left/Centre': '左/中央'
  },
  areaSelector: {
    selectAreas: 'エリアを選択',
    filterAreas: 'エリアを絞り込む'
  },
  spatialCoverage: {
    lastDefenderDist: '最後のディフェンダーの距離',
    defensiveLineDist: 'ディフェンスラインの距離',
    fullBackAvgDist: '平均横方向距離',
    offensiveLineDist: 'オフェンスラインの距離',
    distanceToGoal: 'ゴールまでの距離',
    avgLineWidth: '平均線幅',
    leagueAvgDistanceToGoal: 'リーグ平均ゴール距離',
    leagueAvgLineWidth: 'リーグ平均ライン幅',
    avgShort: '平均',
    meters: 'メートル',
    leagueAvgDist: 'リーグ平均距離',
    distance: '距離',
    avgPositionYAxis: 'ピッチ上の平均距離（Y）',
    leagueAvgPositionYAxis: 'リーグ平均のピッチ上距離（Y）',
    lbRbDistanceSeparation: 'LB–RB 距離',
    leagueAvgLbRbDistanceSeparation: 'リーグ平均 LB–RB 距離',
    legendTeam: 'チーム',
    legendLeagueAvg: 'リーグ平均',
    maxLength: '最大長さ',
    maxWidth: '最大幅',
    avgBlockDistance: '平均ブロック距離'
  },
  arrigo: {
    beta: 'BETA',
    subtitle: 'インテリジェントなデータ',
    passesUnderPressureSubtitle: '守備のプレッシャー下で行われたパスの成功率を分析する',
    onBallPressureSubtitle: 'フィールドゾーン別の守備圧力イベントとその成功率を分析',
    ballReceiptsInSpaceSubtitle: 'スペース内で受け取ったパスをフィールドゾーンごとに分析する',
    ballReceipts: '領収書',
    totalBallReceipts: '総ボール受信数',
    totalBallReceiptsCompleted: '総ボールレシート完了',
    completed: '完了',
    lineBreakingPassesSubtitle: 'ラインを突破し、優位性を生み出すパスを分析',
    bypassed: 'バイパス',
    oppsBypassed: '対戦相手が負けた',
    passer: 'パサー',
    passedTo: 'パスを受け取る',
    receivedFrom: '受信元',
    distanceToNearestDefender: '最も近いディフェンダーまでの距離',
    lineBreaking: '改行 {0}',
    keyPass: 'キーパス',
    receiver: '受信機',
    dynamicTracking: 'ダイナミックトラッキング',
    eventLockTooltip: '一部のプレイヤーはプレイ中に表示されません',
    bypassedPlayers: '{0} 人の選手を突破',
    playersCount: '{0}人の選手',
    bothTeams: '両チーム',
    matchesCount: '{0}試合',
    lbpType: {
      F: '前線',
      M: '中盤',
      B: '最終ライン',
      MF: '中盤・前線',
      BM: '最終ライン・中盤',
      BF: '最終ライン・前線',
      BMF: '最終ライン・中盤・前線'
    },
    lbpCategory: {
      'G-IN-T': 'グラウンダー・インサイド（ディフェンスライン突破）',
      'G-IN-NT': 'グラウンダー・インサイド（ディフェンスライン非突破）',
      'G-OUT-T': 'グラウンダー・アウトサイド（ディフェンスライン突破）',
      'G-OUT-NT': 'グラウンダー・アウトサイド（ディフェンスライン非突破）',
      'O-IN-T': '浮き玉・インサイド（ディフェンスライン突破）',
      'O-IN-NT': '浮き玉・インサイド（ディフェンスライン非突破）',
      'O-OUT-T': '浮き玉・アウトサイド（ディフェンスライン突破）',
      'O-OUT-NT': '浮き玉・アウトサイド（ディフェンスライン非突破）',
      ground: 'グラウンダー',
      over: '上を通る',
      inside: '内側',
      outside: '外側',
      through: 'ディフェンスラインを突破',
      notThrough: 'ディフェンスラインを突破しない',
      throughAbbr: 'ブレイキングデフ。ライン',
      notThroughAbbr: 'デフを崩さない。ライン'
    },
    lbpCategorySplit: {
      G: 'グラウンド: パスはグラウンドでした',
      O: 'フライ: パスはフライでした',
      OUT: 'アウトサイド: パスはアウトサイドに行きました',
      IN: 'インサイド: パスはインサイドに行きました',
      T: 'ディフェンスライン突破: パスは内側からディフェンスラインを突破します',
      NT: 'ディフェンスライン非突破: パスは内側から突破せず、外側から迂回します'
    },
    obrType: {
      OL: 'オーバーラップ',
      UL: 'アンダーラップ',
      RA: '前へ走る',
      RB: '後ろへ走る',
      CR: 'クロスレシーバー',
      SP: 'サポート',
      CS: 'ショートする'
    },
    visualization: 'ビジュアライゼーション',
    points: '円',
    zones: 'ヒートマップ',
    pressureIntensity: '圧力強度',
    pressureOutcome: '圧力結果',
    passesOutcome: 'パス結果',
    strong: '強い',
    light: '軽い',
    normal: '普通',
    successful: '成功',
    unsuccessful: '失敗',
    presses: '圧力',
    passes: 'パス',
    passUnder: '下を通る',
    successRate: '成功率',
    pressureOn: '圧力',
    pressureOf: 'のプレッシャー',
    pressure: '圧力',
    totalLabel: '合計',
    totalPasses: '合計パス数',
    unknown: '不明',
    selectGameToViewMap: '圧力マップを表示するにはゲームを選択してください',
    noEventsFoundForGame: 'このゲームの圧力イベントは見つかりませんでした',
    noEventsFoundForTeamAndSeason: 'このチームとシーズンの圧力イベントは見つかりませんでした',
    noEventsFoundForPlayerAndSeason: 'このプレーヤーとシーズンの圧力イベントは見つかりませんでした',
    noEventsMatchFilters: '現在のフィルターに一致するイベントは見つかりませんでした',
    totalEventsAvailable: '総イベント数',
    passType: {
      P: '合格',
      A: 'アシスト',
      KP: 'キーパス',
      PiOB: 'オップに入る。箱',
      PiFT: 'ファイナルサードへのパス',
      SoPP: 'プレイパスの切り替え'
    },
    minFrom: 'からの分',
    minTo: 'ミント',
    secondFrom: 'からのセグメント',
    secondTo: 'セグトゥ',
    positionPlayed: 'プレーしたポジション',
    highlight: 'ハイライト',
    passTypeLabel: 'パスの種類',
    offBallRunSubtitle: 'オフボールランを分析する',
    insights: '洞察',
    insightsSubtitle: '高度な Arrigo 分析による最高のランキング',
    pressurePassTypeLabel: 'Pressure On Pass Type'
  },
  driblabAI: {
    chatText: '今日はどのようにお手伝いできますか?',
    chatSubtext: 'サッカーデータのことなら何でも聞いてください！',
    thinking: '考え...',
    giveFeedback: 'フィードバックを与える',
    disclaimer: 'DriblabAI は間違いを犯す可能性があります。必ずご確認ください。',
    recent: '最近の',
    noConversations: 'ここには最近の会話が表示されます。',
    rename: '名前の変更',
    deleteConversation: '会話を削除する',
    confirmDelete: 'この会話を削除してもよろしいですか?',
    feedback: 'フィードバック',
    feedbackQuestion: 'この回答は役に立ちましたか?',
    feedbackComments: '追加コメント',
    feedbackPlaceholder: '役に立った点、または改善できる点を教えてください...',
    errorMessage: 'メッセージを処理できませんでした。もう一度試してください。',
    newConversation: '新しいチャット',
    write: 'メッセージを書いてください...'
  },
  periodId: {
    1: '前半',
    2: '後半',
    3: '延長戦 - 1°',
    4: '延長戦 - 2°',
    5: 'ペナルティシュートアウト',
    6: 'フルタイム',
    7: 'プレマッチ',
    8: '放棄された',
    9: 'ライブ',
    10: '0-15',
    11: '16-30',
    12: '31+',
    13: '45-60',
    14: '61-75',
    15: '76歳以上',
    '-1': '他の'
  }
};
